/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createAccountInformation = /* GraphQL */ `
  mutation CreateAccountInformation(
    $input: CreateAccountInformationInput!
    $condition: ModelAccountInformationConditionInput
  ) {
    createAccountInformation(input: $input, condition: $condition) {
      id
      primaryOwner
      owner
      accountNumber
      accountName
      accountType
      customerType
      accountRequestStatus
      investigationStatus
      apexId
      apexFdid
      apexCatAccountholderType
      apexJson
      accountStatus
      balance {
        id
        accountNumber
        owner
        accountInformation {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        overnightBuyingPowerID
        firm
        totalEquity
        marginEquity
        marginRequirement
        marginExcessEquity
        cashEquity
        cashRequirement
        cashExcessEquity
        overnightBuyingPowerIssued
        dayTradeBuyingPowerIssued
        regTBuyingPowerIssued
        overnightFactorIssued
        dayTradeFactorIssued
        marginEquityPercent
        positionMarketValue
        longEquityMarketValue
        shortEquityMarketValue
        longOptionMarketValue
        shortOptionMarketValue
        totalTradeBalance
        totalSettleBalance
        cashTradeBalance
        marginTradeBalance
        shortTradeBalance
        cashSettleBalance
        marginSettleBalance
        shortSettleBalance
        moneyMarketSettleBalance
        moneyMarketTradeBalance
        freeCash
        sma
        availableToWithdraw
        optionsRequirement
        nonOptionsRequirement
        lastUpdate
        nonOptionsRequirementNotConcentrated
        typeIUnavailableCashProceeds
        typeIIUnavailableCashProceeds
        netBalance
        smaCommitted
        netLiquidity
        pendingDebitInterest
        pendingDebitDividends
        fullyPaidUnsettledFunds
        cashOnOrders
        buyingPowerOnOrders
        marginExcessEquitySod
        cashExcessEquitySod
        netBalanceSod
        optionBuyingPowerInternal
        stockBuyingPowerInternal
        updateFlag
        accountType
        pendingTransfers {
          deposit
          amount
          achDepositWithdrawalRequestId
          __typename
        }
        createdAt
        updatedAt
        balanceAccountInformationId
        __typename
      }
      permissions {
        id
        accountNumber
        accountInformation {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        owner
        systemAccess
        equityTrading
        optionsTrading
        cryptoTrading
        margin
        securitiesLending
        optionsLevel
        exitOnlyTrades
        restrictReason
        allowCancelOrder
        allowModifyOrder
        achWithdrawal
        patternDayTrader
        achApproval
        profileStatus
        betaFeatures
        achDeposit
        updatedBy
        createdAt
        updatedAt
        userPermissionsAccountInformationId
        __typename
      }
      userOrders {
        items {
          id
          accountNumber
          owner
          subAccountNumber
          cancel
          cancelReplace
          createdDate
          updatedDate
          commission
          feesAndCommission
          symbol
          side
          brokerSkipChecks
          brokerOverride
          brokerId
          quantity
          limitPrice
          stopPrice
          stockValue
          originalOrderId
          strategy
          avgPx
          orderType
          timeInForce
          instruction
          userOrderLegs {
            legType
            side
            quantity
            expiration
            strike
            openClose
            bid
            ask
            sharesPerContract
            avgPx
            __typename
          }
          cashSecured
          cashSecuredAmount
          message
          submitStatus
          status
          executionReports {
            items {
              id
              owner
              accountInformationId
              subAccountNumber
              orderID
              executionIncrementId
              secondaryOrderID
              clOrdID
              origClOrdID
              clientID
              execBroker
              listID
              execID
              execTransType
              execRefID
              execType
              ordStatus
              ordRejReason
              execRestatementReason
              account
              settlmntTyp
              futSettDate
              symbol
              symbolSfx
              securityID
              iDSource
              securityType
              maturityMonthYear
              maturityDay
              putOrCall
              strikePrice
              optAttribute
              contractMultiplier
              couponRate
              securityExchange
              issuer
              encodedIssuerLen
              encodedIssuer
              securityDesc
              encodedSecurityDescLen
              encodedSecurityDesc
              side
              orderQty
              cashOrderQty
              ordType
              price
              stopPx
              pegDifference
              discretionInst
              discretionOffset
              currency
              complianceID
              solicitedFlag
              timeInForce
              effectiveTime
              expireDate
              expireTime
              execInst
              rule80A
              lastShares
              lastPx
              lastSpotRate
              lastForwardPoints
              lastMkt
              tradingSessionID
              lastCapacity
              leavesQty
              cumQty
              avgPx
              dayOrderQty
              dayCumQty
              dayAvgPx
              gTBookingInst
              tradeDate
              transactTime
              reportToExch
              commission
              commType
              grossTradeAmt
              settlCurrAmt
              settlCurrency
              settlCurrFxRate
              settlCurrFxRateCalc
              handlInst
              minQty
              maxFloor
              openClose
              maxShow
              text
              encodedTextLen
              encodedText
              futSettDate2
              orderQty2
              clearingFirm
              clearingAccount
              multiLegReportingType
              legRefId
              uploadedToBackoffice
              fixMessage
              isAllocation
              groupUploadId
              processedAt
              createdDate
              createdAt
              updatedAt
              userOrderExecutionReportsId
              groupOrderExecutionReportsId
              __typename
            }
            nextToken
            __typename
          }
          cryptoOrder
          groupUploadOrderId
          reviewStatus
          createdAt
          updatedAt
          groupUpload {
            id
            name
            description
            orders {
              items {
                id
                groupUploadOrdersId
                accountNumber
                quantity
                brokerOverride
                commission
                owner
                userOrder {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                accountInformationId
                failed
                failedReason
                orderIds
                createdDate
                createdAt
                updatedAt
                groupUploadOrderUserOrderId
                __typename
              }
              nextToken
              __typename
            }
            owner
            isPlaced
            isPlacedString
            isAvgPx
            createdAt
            updatedAt
            __typename
          }
          accountInformationUserOrdersId
          userOrderGroupUploadId
          __typename
        }
        nextToken
        __typename
      }
      positions {
        items {
          id
          accountNumber
          owner
          underlying
          pricePaid
          isCryptoPosition
          quantity
          marginRequirement
          strategy
          positionLegs {
            side
            quantity
            ratioQuantity
            pricePaid
            legType
            cusip
            marginRequirement
            expiration
            strike
            __typename
          }
          subAccountNumber
          status
          groupUploadOrderId
          createdAt
          updatedAt
          accountInformationPositionsId
          __typename
        }
        nextToken
        __typename
      }
      subAccounts {
        items {
          id
          accountNumber
          owner
          subAccountName
          subAccountNumber
          selfDirected
          balance {
            id
            accountNumber
            owner
            subAccountName
            subAccountNumber
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            accountType
            createdAt
            updatedAt
            __typename
          }
          transfers {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              toSubAccountNumber
              amount
              message
              deposit
              status
              cancel
              createdAt
              updatedAt
              subAccountTransfersId
              __typename
            }
            nextToken
            __typename
          }
          commissionCode
          repCode
          newsLetter {
            newsLetter
            portfolio
            __typename
          }
          stock {
            stockSignals
            maxDollarAllocationPerSignal
            maxNumberOfSharesPerSignal
            allOrNone
            roundLotsOnly
            multiplier
            __typename
          }
          option {
            optionSignals
            maxDollarAllocationPerSignal
            maxNumberOfContractsPerSignal
            allOrNone
            multiplier
            __typename
          }
          createdAt
          updatedAt
          accountInformationSubAccountsId
          subAccountBalanceId
          __typename
        }
        nextToken
        __typename
      }
      documentUpload {
        items {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          investigationId
          investigationNote
          submittedBy
          document {
            documentTag
            documentType
            s3uri
            __typename
          }
          approvedBy
          approvalStatus
          createdAt
          updatedAt
          accountInformationDocumentUploadId
          __typename
        }
        nextToken
        __typename
      }
      cryptoTransfer {
        items {
          id
          accountNumber
          owner
          blockchainHash
          clientTransactionId
          currency
          quantity
          receiveAddress {
            hotWalletAddress
            coin
            __typename
          }
          userWalletAddress {
            owner
            address
            nickname
            id
            createdAt
            updatedAt
            __typename
          }
          deposit
          status
          type
          version
          createdAt
          updatedAt
          accountInformationCryptoTransferId
          __typename
        }
        nextToken
        __typename
      }
      selectedWatchlist {
        items {
          id
          accountNumber
          owner
          watchListName
          selectedStocks
          createdAt
          updatedAt
          accountInformationSelectedWatchlistId
          __typename
        }
        nextToken
        __typename
      }
      notifications {
        items {
          id
          accountNumber
          owner
          notificationType
          message
          severity
          acknowledged
          star
          sent
          deleted
          toUser
          fromUser
          fromSystem
          ttl
          createdAt
          updatedAt
          accountInformationNotificationsId
          __typename
        }
        nextToken
        __typename
      }
      achRelationship {
        id
        accountNumber
        owner
        accountInformation {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        achRelationshipStatic {
          id
          accountNumber
          owner
          plaidProcessorToken
          plaidAccountId
          bankRoutingNumber
          bankAccount
          bankAccountOwnerName
          bankAccountType
          deleted
          approvalMethod
          relationshipId
          status
          statusCode
          statusJson
          createdAt
          updatedAt
          __typename
        }
        deleted
        nickname
        microDepositTries
        microDeposits
        microDepositStatus
        depositWithdrawalRequests {
          items {
            id
            accountNumber
            owner
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            relationshipId
            amount
            message
            memo
            reason
            iraContributionDistribution {
              contributionType
              applyToPriorYear
              distributionReason
              federalTaxWithholding {
                valueType
                value
                __typename
              }
              stateTaxWithholding {
                valueType
                value
                __typename
              }
              __typename
            }
            isFullDisbursement
            transferId
            deposit
            status
            cancel
            createdAt
            updatedAt
            achRelationshipDepositWithdrawalRequestsId
            __typename
          }
          nextToken
          __typename
        }
        reissueTries
        reissue
        createdAt
        updatedAt
        achRelationshipAchRelationshipStaticId
        achRelationshipAccountInformationId
        __typename
      }
      userProfileIds
      createdAt
      updatedAt
      userProfileAccountsId
      draftUserProfileAccountsId
      accountInformationBalanceId
      accountInformationPermissionsId
      accountInformationAchRelationshipId
      __typename
    }
  }
`;
export const updateAccountInformation = /* GraphQL */ `
  mutation UpdateAccountInformation(
    $input: UpdateAccountInformationInput!
    $condition: ModelAccountInformationConditionInput
  ) {
    updateAccountInformation(input: $input, condition: $condition) {
      id
      primaryOwner
      owner
      accountNumber
      accountName
      accountType
      customerType
      accountRequestStatus
      investigationStatus
      apexId
      apexFdid
      apexCatAccountholderType
      apexJson
      accountStatus
      balance {
        id
        accountNumber
        owner
        accountInformation {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        overnightBuyingPowerID
        firm
        totalEquity
        marginEquity
        marginRequirement
        marginExcessEquity
        cashEquity
        cashRequirement
        cashExcessEquity
        overnightBuyingPowerIssued
        dayTradeBuyingPowerIssued
        regTBuyingPowerIssued
        overnightFactorIssued
        dayTradeFactorIssued
        marginEquityPercent
        positionMarketValue
        longEquityMarketValue
        shortEquityMarketValue
        longOptionMarketValue
        shortOptionMarketValue
        totalTradeBalance
        totalSettleBalance
        cashTradeBalance
        marginTradeBalance
        shortTradeBalance
        cashSettleBalance
        marginSettleBalance
        shortSettleBalance
        moneyMarketSettleBalance
        moneyMarketTradeBalance
        freeCash
        sma
        availableToWithdraw
        optionsRequirement
        nonOptionsRequirement
        lastUpdate
        nonOptionsRequirementNotConcentrated
        typeIUnavailableCashProceeds
        typeIIUnavailableCashProceeds
        netBalance
        smaCommitted
        netLiquidity
        pendingDebitInterest
        pendingDebitDividends
        fullyPaidUnsettledFunds
        cashOnOrders
        buyingPowerOnOrders
        marginExcessEquitySod
        cashExcessEquitySod
        netBalanceSod
        optionBuyingPowerInternal
        stockBuyingPowerInternal
        updateFlag
        accountType
        pendingTransfers {
          deposit
          amount
          achDepositWithdrawalRequestId
          __typename
        }
        createdAt
        updatedAt
        balanceAccountInformationId
        __typename
      }
      permissions {
        id
        accountNumber
        accountInformation {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        owner
        systemAccess
        equityTrading
        optionsTrading
        cryptoTrading
        margin
        securitiesLending
        optionsLevel
        exitOnlyTrades
        restrictReason
        allowCancelOrder
        allowModifyOrder
        achWithdrawal
        patternDayTrader
        achApproval
        profileStatus
        betaFeatures
        achDeposit
        updatedBy
        createdAt
        updatedAt
        userPermissionsAccountInformationId
        __typename
      }
      userOrders {
        items {
          id
          accountNumber
          owner
          subAccountNumber
          cancel
          cancelReplace
          createdDate
          updatedDate
          commission
          feesAndCommission
          symbol
          side
          brokerSkipChecks
          brokerOverride
          brokerId
          quantity
          limitPrice
          stopPrice
          stockValue
          originalOrderId
          strategy
          avgPx
          orderType
          timeInForce
          instruction
          userOrderLegs {
            legType
            side
            quantity
            expiration
            strike
            openClose
            bid
            ask
            sharesPerContract
            avgPx
            __typename
          }
          cashSecured
          cashSecuredAmount
          message
          submitStatus
          status
          executionReports {
            items {
              id
              owner
              accountInformationId
              subAccountNumber
              orderID
              executionIncrementId
              secondaryOrderID
              clOrdID
              origClOrdID
              clientID
              execBroker
              listID
              execID
              execTransType
              execRefID
              execType
              ordStatus
              ordRejReason
              execRestatementReason
              account
              settlmntTyp
              futSettDate
              symbol
              symbolSfx
              securityID
              iDSource
              securityType
              maturityMonthYear
              maturityDay
              putOrCall
              strikePrice
              optAttribute
              contractMultiplier
              couponRate
              securityExchange
              issuer
              encodedIssuerLen
              encodedIssuer
              securityDesc
              encodedSecurityDescLen
              encodedSecurityDesc
              side
              orderQty
              cashOrderQty
              ordType
              price
              stopPx
              pegDifference
              discretionInst
              discretionOffset
              currency
              complianceID
              solicitedFlag
              timeInForce
              effectiveTime
              expireDate
              expireTime
              execInst
              rule80A
              lastShares
              lastPx
              lastSpotRate
              lastForwardPoints
              lastMkt
              tradingSessionID
              lastCapacity
              leavesQty
              cumQty
              avgPx
              dayOrderQty
              dayCumQty
              dayAvgPx
              gTBookingInst
              tradeDate
              transactTime
              reportToExch
              commission
              commType
              grossTradeAmt
              settlCurrAmt
              settlCurrency
              settlCurrFxRate
              settlCurrFxRateCalc
              handlInst
              minQty
              maxFloor
              openClose
              maxShow
              text
              encodedTextLen
              encodedText
              futSettDate2
              orderQty2
              clearingFirm
              clearingAccount
              multiLegReportingType
              legRefId
              uploadedToBackoffice
              fixMessage
              isAllocation
              groupUploadId
              processedAt
              createdDate
              createdAt
              updatedAt
              userOrderExecutionReportsId
              groupOrderExecutionReportsId
              __typename
            }
            nextToken
            __typename
          }
          cryptoOrder
          groupUploadOrderId
          reviewStatus
          createdAt
          updatedAt
          groupUpload {
            id
            name
            description
            orders {
              items {
                id
                groupUploadOrdersId
                accountNumber
                quantity
                brokerOverride
                commission
                owner
                userOrder {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                accountInformationId
                failed
                failedReason
                orderIds
                createdDate
                createdAt
                updatedAt
                groupUploadOrderUserOrderId
                __typename
              }
              nextToken
              __typename
            }
            owner
            isPlaced
            isPlacedString
            isAvgPx
            createdAt
            updatedAt
            __typename
          }
          accountInformationUserOrdersId
          userOrderGroupUploadId
          __typename
        }
        nextToken
        __typename
      }
      positions {
        items {
          id
          accountNumber
          owner
          underlying
          pricePaid
          isCryptoPosition
          quantity
          marginRequirement
          strategy
          positionLegs {
            side
            quantity
            ratioQuantity
            pricePaid
            legType
            cusip
            marginRequirement
            expiration
            strike
            __typename
          }
          subAccountNumber
          status
          groupUploadOrderId
          createdAt
          updatedAt
          accountInformationPositionsId
          __typename
        }
        nextToken
        __typename
      }
      subAccounts {
        items {
          id
          accountNumber
          owner
          subAccountName
          subAccountNumber
          selfDirected
          balance {
            id
            accountNumber
            owner
            subAccountName
            subAccountNumber
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            accountType
            createdAt
            updatedAt
            __typename
          }
          transfers {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              toSubAccountNumber
              amount
              message
              deposit
              status
              cancel
              createdAt
              updatedAt
              subAccountTransfersId
              __typename
            }
            nextToken
            __typename
          }
          commissionCode
          repCode
          newsLetter {
            newsLetter
            portfolio
            __typename
          }
          stock {
            stockSignals
            maxDollarAllocationPerSignal
            maxNumberOfSharesPerSignal
            allOrNone
            roundLotsOnly
            multiplier
            __typename
          }
          option {
            optionSignals
            maxDollarAllocationPerSignal
            maxNumberOfContractsPerSignal
            allOrNone
            multiplier
            __typename
          }
          createdAt
          updatedAt
          accountInformationSubAccountsId
          subAccountBalanceId
          __typename
        }
        nextToken
        __typename
      }
      documentUpload {
        items {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          investigationId
          investigationNote
          submittedBy
          document {
            documentTag
            documentType
            s3uri
            __typename
          }
          approvedBy
          approvalStatus
          createdAt
          updatedAt
          accountInformationDocumentUploadId
          __typename
        }
        nextToken
        __typename
      }
      cryptoTransfer {
        items {
          id
          accountNumber
          owner
          blockchainHash
          clientTransactionId
          currency
          quantity
          receiveAddress {
            hotWalletAddress
            coin
            __typename
          }
          userWalletAddress {
            owner
            address
            nickname
            id
            createdAt
            updatedAt
            __typename
          }
          deposit
          status
          type
          version
          createdAt
          updatedAt
          accountInformationCryptoTransferId
          __typename
        }
        nextToken
        __typename
      }
      selectedWatchlist {
        items {
          id
          accountNumber
          owner
          watchListName
          selectedStocks
          createdAt
          updatedAt
          accountInformationSelectedWatchlistId
          __typename
        }
        nextToken
        __typename
      }
      notifications {
        items {
          id
          accountNumber
          owner
          notificationType
          message
          severity
          acknowledged
          star
          sent
          deleted
          toUser
          fromUser
          fromSystem
          ttl
          createdAt
          updatedAt
          accountInformationNotificationsId
          __typename
        }
        nextToken
        __typename
      }
      achRelationship {
        id
        accountNumber
        owner
        accountInformation {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        achRelationshipStatic {
          id
          accountNumber
          owner
          plaidProcessorToken
          plaidAccountId
          bankRoutingNumber
          bankAccount
          bankAccountOwnerName
          bankAccountType
          deleted
          approvalMethod
          relationshipId
          status
          statusCode
          statusJson
          createdAt
          updatedAt
          __typename
        }
        deleted
        nickname
        microDepositTries
        microDeposits
        microDepositStatus
        depositWithdrawalRequests {
          items {
            id
            accountNumber
            owner
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            relationshipId
            amount
            message
            memo
            reason
            iraContributionDistribution {
              contributionType
              applyToPriorYear
              distributionReason
              federalTaxWithholding {
                valueType
                value
                __typename
              }
              stateTaxWithholding {
                valueType
                value
                __typename
              }
              __typename
            }
            isFullDisbursement
            transferId
            deposit
            status
            cancel
            createdAt
            updatedAt
            achRelationshipDepositWithdrawalRequestsId
            __typename
          }
          nextToken
          __typename
        }
        reissueTries
        reissue
        createdAt
        updatedAt
        achRelationshipAchRelationshipStaticId
        achRelationshipAccountInformationId
        __typename
      }
      userProfileIds
      createdAt
      updatedAt
      userProfileAccountsId
      draftUserProfileAccountsId
      accountInformationBalanceId
      accountInformationPermissionsId
      accountInformationAchRelationshipId
      __typename
    }
  }
`;
export const deleteAccountInformation = /* GraphQL */ `
  mutation DeleteAccountInformation(
    $input: DeleteAccountInformationInput!
    $condition: ModelAccountInformationConditionInput
  ) {
    deleteAccountInformation(input: $input, condition: $condition) {
      id
      primaryOwner
      owner
      accountNumber
      accountName
      accountType
      customerType
      accountRequestStatus
      investigationStatus
      apexId
      apexFdid
      apexCatAccountholderType
      apexJson
      accountStatus
      balance {
        id
        accountNumber
        owner
        accountInformation {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        overnightBuyingPowerID
        firm
        totalEquity
        marginEquity
        marginRequirement
        marginExcessEquity
        cashEquity
        cashRequirement
        cashExcessEquity
        overnightBuyingPowerIssued
        dayTradeBuyingPowerIssued
        regTBuyingPowerIssued
        overnightFactorIssued
        dayTradeFactorIssued
        marginEquityPercent
        positionMarketValue
        longEquityMarketValue
        shortEquityMarketValue
        longOptionMarketValue
        shortOptionMarketValue
        totalTradeBalance
        totalSettleBalance
        cashTradeBalance
        marginTradeBalance
        shortTradeBalance
        cashSettleBalance
        marginSettleBalance
        shortSettleBalance
        moneyMarketSettleBalance
        moneyMarketTradeBalance
        freeCash
        sma
        availableToWithdraw
        optionsRequirement
        nonOptionsRequirement
        lastUpdate
        nonOptionsRequirementNotConcentrated
        typeIUnavailableCashProceeds
        typeIIUnavailableCashProceeds
        netBalance
        smaCommitted
        netLiquidity
        pendingDebitInterest
        pendingDebitDividends
        fullyPaidUnsettledFunds
        cashOnOrders
        buyingPowerOnOrders
        marginExcessEquitySod
        cashExcessEquitySod
        netBalanceSod
        optionBuyingPowerInternal
        stockBuyingPowerInternal
        updateFlag
        accountType
        pendingTransfers {
          deposit
          amount
          achDepositWithdrawalRequestId
          __typename
        }
        createdAt
        updatedAt
        balanceAccountInformationId
        __typename
      }
      permissions {
        id
        accountNumber
        accountInformation {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        owner
        systemAccess
        equityTrading
        optionsTrading
        cryptoTrading
        margin
        securitiesLending
        optionsLevel
        exitOnlyTrades
        restrictReason
        allowCancelOrder
        allowModifyOrder
        achWithdrawal
        patternDayTrader
        achApproval
        profileStatus
        betaFeatures
        achDeposit
        updatedBy
        createdAt
        updatedAt
        userPermissionsAccountInformationId
        __typename
      }
      userOrders {
        items {
          id
          accountNumber
          owner
          subAccountNumber
          cancel
          cancelReplace
          createdDate
          updatedDate
          commission
          feesAndCommission
          symbol
          side
          brokerSkipChecks
          brokerOverride
          brokerId
          quantity
          limitPrice
          stopPrice
          stockValue
          originalOrderId
          strategy
          avgPx
          orderType
          timeInForce
          instruction
          userOrderLegs {
            legType
            side
            quantity
            expiration
            strike
            openClose
            bid
            ask
            sharesPerContract
            avgPx
            __typename
          }
          cashSecured
          cashSecuredAmount
          message
          submitStatus
          status
          executionReports {
            items {
              id
              owner
              accountInformationId
              subAccountNumber
              orderID
              executionIncrementId
              secondaryOrderID
              clOrdID
              origClOrdID
              clientID
              execBroker
              listID
              execID
              execTransType
              execRefID
              execType
              ordStatus
              ordRejReason
              execRestatementReason
              account
              settlmntTyp
              futSettDate
              symbol
              symbolSfx
              securityID
              iDSource
              securityType
              maturityMonthYear
              maturityDay
              putOrCall
              strikePrice
              optAttribute
              contractMultiplier
              couponRate
              securityExchange
              issuer
              encodedIssuerLen
              encodedIssuer
              securityDesc
              encodedSecurityDescLen
              encodedSecurityDesc
              side
              orderQty
              cashOrderQty
              ordType
              price
              stopPx
              pegDifference
              discretionInst
              discretionOffset
              currency
              complianceID
              solicitedFlag
              timeInForce
              effectiveTime
              expireDate
              expireTime
              execInst
              rule80A
              lastShares
              lastPx
              lastSpotRate
              lastForwardPoints
              lastMkt
              tradingSessionID
              lastCapacity
              leavesQty
              cumQty
              avgPx
              dayOrderQty
              dayCumQty
              dayAvgPx
              gTBookingInst
              tradeDate
              transactTime
              reportToExch
              commission
              commType
              grossTradeAmt
              settlCurrAmt
              settlCurrency
              settlCurrFxRate
              settlCurrFxRateCalc
              handlInst
              minQty
              maxFloor
              openClose
              maxShow
              text
              encodedTextLen
              encodedText
              futSettDate2
              orderQty2
              clearingFirm
              clearingAccount
              multiLegReportingType
              legRefId
              uploadedToBackoffice
              fixMessage
              isAllocation
              groupUploadId
              processedAt
              createdDate
              createdAt
              updatedAt
              userOrderExecutionReportsId
              groupOrderExecutionReportsId
              __typename
            }
            nextToken
            __typename
          }
          cryptoOrder
          groupUploadOrderId
          reviewStatus
          createdAt
          updatedAt
          groupUpload {
            id
            name
            description
            orders {
              items {
                id
                groupUploadOrdersId
                accountNumber
                quantity
                brokerOverride
                commission
                owner
                userOrder {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                accountInformationId
                failed
                failedReason
                orderIds
                createdDate
                createdAt
                updatedAt
                groupUploadOrderUserOrderId
                __typename
              }
              nextToken
              __typename
            }
            owner
            isPlaced
            isPlacedString
            isAvgPx
            createdAt
            updatedAt
            __typename
          }
          accountInformationUserOrdersId
          userOrderGroupUploadId
          __typename
        }
        nextToken
        __typename
      }
      positions {
        items {
          id
          accountNumber
          owner
          underlying
          pricePaid
          isCryptoPosition
          quantity
          marginRequirement
          strategy
          positionLegs {
            side
            quantity
            ratioQuantity
            pricePaid
            legType
            cusip
            marginRequirement
            expiration
            strike
            __typename
          }
          subAccountNumber
          status
          groupUploadOrderId
          createdAt
          updatedAt
          accountInformationPositionsId
          __typename
        }
        nextToken
        __typename
      }
      subAccounts {
        items {
          id
          accountNumber
          owner
          subAccountName
          subAccountNumber
          selfDirected
          balance {
            id
            accountNumber
            owner
            subAccountName
            subAccountNumber
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            accountType
            createdAt
            updatedAt
            __typename
          }
          transfers {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              toSubAccountNumber
              amount
              message
              deposit
              status
              cancel
              createdAt
              updatedAt
              subAccountTransfersId
              __typename
            }
            nextToken
            __typename
          }
          commissionCode
          repCode
          newsLetter {
            newsLetter
            portfolio
            __typename
          }
          stock {
            stockSignals
            maxDollarAllocationPerSignal
            maxNumberOfSharesPerSignal
            allOrNone
            roundLotsOnly
            multiplier
            __typename
          }
          option {
            optionSignals
            maxDollarAllocationPerSignal
            maxNumberOfContractsPerSignal
            allOrNone
            multiplier
            __typename
          }
          createdAt
          updatedAt
          accountInformationSubAccountsId
          subAccountBalanceId
          __typename
        }
        nextToken
        __typename
      }
      documentUpload {
        items {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          investigationId
          investigationNote
          submittedBy
          document {
            documentTag
            documentType
            s3uri
            __typename
          }
          approvedBy
          approvalStatus
          createdAt
          updatedAt
          accountInformationDocumentUploadId
          __typename
        }
        nextToken
        __typename
      }
      cryptoTransfer {
        items {
          id
          accountNumber
          owner
          blockchainHash
          clientTransactionId
          currency
          quantity
          receiveAddress {
            hotWalletAddress
            coin
            __typename
          }
          userWalletAddress {
            owner
            address
            nickname
            id
            createdAt
            updatedAt
            __typename
          }
          deposit
          status
          type
          version
          createdAt
          updatedAt
          accountInformationCryptoTransferId
          __typename
        }
        nextToken
        __typename
      }
      selectedWatchlist {
        items {
          id
          accountNumber
          owner
          watchListName
          selectedStocks
          createdAt
          updatedAt
          accountInformationSelectedWatchlistId
          __typename
        }
        nextToken
        __typename
      }
      notifications {
        items {
          id
          accountNumber
          owner
          notificationType
          message
          severity
          acknowledged
          star
          sent
          deleted
          toUser
          fromUser
          fromSystem
          ttl
          createdAt
          updatedAt
          accountInformationNotificationsId
          __typename
        }
        nextToken
        __typename
      }
      achRelationship {
        id
        accountNumber
        owner
        accountInformation {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        achRelationshipStatic {
          id
          accountNumber
          owner
          plaidProcessorToken
          plaidAccountId
          bankRoutingNumber
          bankAccount
          bankAccountOwnerName
          bankAccountType
          deleted
          approvalMethod
          relationshipId
          status
          statusCode
          statusJson
          createdAt
          updatedAt
          __typename
        }
        deleted
        nickname
        microDepositTries
        microDeposits
        microDepositStatus
        depositWithdrawalRequests {
          items {
            id
            accountNumber
            owner
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            relationshipId
            amount
            message
            memo
            reason
            iraContributionDistribution {
              contributionType
              applyToPriorYear
              distributionReason
              federalTaxWithholding {
                valueType
                value
                __typename
              }
              stateTaxWithholding {
                valueType
                value
                __typename
              }
              __typename
            }
            isFullDisbursement
            transferId
            deposit
            status
            cancel
            createdAt
            updatedAt
            achRelationshipDepositWithdrawalRequestsId
            __typename
          }
          nextToken
          __typename
        }
        reissueTries
        reissue
        createdAt
        updatedAt
        achRelationshipAchRelationshipStaticId
        achRelationshipAccountInformationId
        __typename
      }
      userProfileIds
      createdAt
      updatedAt
      userProfileAccountsId
      draftUserProfileAccountsId
      accountInformationBalanceId
      accountInformationPermissionsId
      accountInformationAchRelationshipId
      __typename
    }
  }
`;
export const createAchRelationship = /* GraphQL */ `
  mutation CreateAchRelationship(
    $input: CreateAchRelationshipInput!
    $condition: ModelAchRelationshipConditionInput
  ) {
    createAchRelationship(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      accountInformation {
        id
        primaryOwner
        owner
        accountNumber
        accountName
        accountType
        customerType
        accountRequestStatus
        investigationStatus
        apexId
        apexFdid
        apexCatAccountholderType
        apexJson
        accountStatus
        balance {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          overnightBuyingPowerID
          firm
          totalEquity
          marginEquity
          marginRequirement
          marginExcessEquity
          cashEquity
          cashRequirement
          cashExcessEquity
          overnightBuyingPowerIssued
          dayTradeBuyingPowerIssued
          regTBuyingPowerIssued
          overnightFactorIssued
          dayTradeFactorIssued
          marginEquityPercent
          positionMarketValue
          longEquityMarketValue
          shortEquityMarketValue
          longOptionMarketValue
          shortOptionMarketValue
          totalTradeBalance
          totalSettleBalance
          cashTradeBalance
          marginTradeBalance
          shortTradeBalance
          cashSettleBalance
          marginSettleBalance
          shortSettleBalance
          moneyMarketSettleBalance
          moneyMarketTradeBalance
          freeCash
          sma
          availableToWithdraw
          optionsRequirement
          nonOptionsRequirement
          lastUpdate
          nonOptionsRequirementNotConcentrated
          typeIUnavailableCashProceeds
          typeIIUnavailableCashProceeds
          netBalance
          smaCommitted
          netLiquidity
          pendingDebitInterest
          pendingDebitDividends
          fullyPaidUnsettledFunds
          cashOnOrders
          buyingPowerOnOrders
          marginExcessEquitySod
          cashExcessEquitySod
          netBalanceSod
          optionBuyingPowerInternal
          stockBuyingPowerInternal
          updateFlag
          accountType
          pendingTransfers {
            deposit
            amount
            achDepositWithdrawalRequestId
            __typename
          }
          createdAt
          updatedAt
          balanceAccountInformationId
          __typename
        }
        permissions {
          id
          accountNumber
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          owner
          systemAccess
          equityTrading
          optionsTrading
          cryptoTrading
          margin
          securitiesLending
          optionsLevel
          exitOnlyTrades
          restrictReason
          allowCancelOrder
          allowModifyOrder
          achWithdrawal
          patternDayTrader
          achApproval
          profileStatus
          betaFeatures
          achDeposit
          updatedBy
          createdAt
          updatedAt
          userPermissionsAccountInformationId
          __typename
        }
        userOrders {
          items {
            id
            accountNumber
            owner
            subAccountNumber
            cancel
            cancelReplace
            createdDate
            updatedDate
            commission
            feesAndCommission
            symbol
            side
            brokerSkipChecks
            brokerOverride
            brokerId
            quantity
            limitPrice
            stopPrice
            stockValue
            originalOrderId
            strategy
            avgPx
            orderType
            timeInForce
            instruction
            userOrderLegs {
              legType
              side
              quantity
              expiration
              strike
              openClose
              bid
              ask
              sharesPerContract
              avgPx
              __typename
            }
            cashSecured
            cashSecuredAmount
            message
            submitStatus
            status
            executionReports {
              items {
                id
                owner
                accountInformationId
                subAccountNumber
                orderID
                executionIncrementId
                secondaryOrderID
                clOrdID
                origClOrdID
                clientID
                execBroker
                listID
                execID
                execTransType
                execRefID
                execType
                ordStatus
                ordRejReason
                execRestatementReason
                account
                settlmntTyp
                futSettDate
                symbol
                symbolSfx
                securityID
                iDSource
                securityType
                maturityMonthYear
                maturityDay
                putOrCall
                strikePrice
                optAttribute
                contractMultiplier
                couponRate
                securityExchange
                issuer
                encodedIssuerLen
                encodedIssuer
                securityDesc
                encodedSecurityDescLen
                encodedSecurityDesc
                side
                orderQty
                cashOrderQty
                ordType
                price
                stopPx
                pegDifference
                discretionInst
                discretionOffset
                currency
                complianceID
                solicitedFlag
                timeInForce
                effectiveTime
                expireDate
                expireTime
                execInst
                rule80A
                lastShares
                lastPx
                lastSpotRate
                lastForwardPoints
                lastMkt
                tradingSessionID
                lastCapacity
                leavesQty
                cumQty
                avgPx
                dayOrderQty
                dayCumQty
                dayAvgPx
                gTBookingInst
                tradeDate
                transactTime
                reportToExch
                commission
                commType
                grossTradeAmt
                settlCurrAmt
                settlCurrency
                settlCurrFxRate
                settlCurrFxRateCalc
                handlInst
                minQty
                maxFloor
                openClose
                maxShow
                text
                encodedTextLen
                encodedText
                futSettDate2
                orderQty2
                clearingFirm
                clearingAccount
                multiLegReportingType
                legRefId
                uploadedToBackoffice
                fixMessage
                isAllocation
                groupUploadId
                processedAt
                createdDate
                createdAt
                updatedAt
                userOrderExecutionReportsId
                groupOrderExecutionReportsId
                __typename
              }
              nextToken
              __typename
            }
            cryptoOrder
            groupUploadOrderId
            reviewStatus
            createdAt
            updatedAt
            groupUpload {
              id
              name
              description
              orders {
                items {
                  id
                  groupUploadOrdersId
                  accountNumber
                  quantity
                  brokerOverride
                  commission
                  owner
                  userOrder {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  accountInformationId
                  failed
                  failedReason
                  orderIds
                  createdDate
                  createdAt
                  updatedAt
                  groupUploadOrderUserOrderId
                  __typename
                }
                nextToken
                __typename
              }
              owner
              isPlaced
              isPlacedString
              isAvgPx
              createdAt
              updatedAt
              __typename
            }
            accountInformationUserOrdersId
            userOrderGroupUploadId
            __typename
          }
          nextToken
          __typename
        }
        positions {
          items {
            id
            accountNumber
            owner
            underlying
            pricePaid
            isCryptoPosition
            quantity
            marginRequirement
            strategy
            positionLegs {
              side
              quantity
              ratioQuantity
              pricePaid
              legType
              cusip
              marginRequirement
              expiration
              strike
              __typename
            }
            subAccountNumber
            status
            groupUploadOrderId
            createdAt
            updatedAt
            accountInformationPositionsId
            __typename
          }
          nextToken
          __typename
        }
        subAccounts {
          items {
            id
            accountNumber
            owner
            subAccountName
            subAccountNumber
            selfDirected
            balance {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              accountType
              createdAt
              updatedAt
              __typename
            }
            transfers {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                toSubAccountNumber
                amount
                message
                deposit
                status
                cancel
                createdAt
                updatedAt
                subAccountTransfersId
                __typename
              }
              nextToken
              __typename
            }
            commissionCode
            repCode
            newsLetter {
              newsLetter
              portfolio
              __typename
            }
            stock {
              stockSignals
              maxDollarAllocationPerSignal
              maxNumberOfSharesPerSignal
              allOrNone
              roundLotsOnly
              multiplier
              __typename
            }
            option {
              optionSignals
              maxDollarAllocationPerSignal
              maxNumberOfContractsPerSignal
              allOrNone
              multiplier
              __typename
            }
            createdAt
            updatedAt
            accountInformationSubAccountsId
            subAccountBalanceId
            __typename
          }
          nextToken
          __typename
        }
        documentUpload {
          items {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            investigationId
            investigationNote
            submittedBy
            document {
              documentTag
              documentType
              s3uri
              __typename
            }
            approvedBy
            approvalStatus
            createdAt
            updatedAt
            accountInformationDocumentUploadId
            __typename
          }
          nextToken
          __typename
        }
        cryptoTransfer {
          items {
            id
            accountNumber
            owner
            blockchainHash
            clientTransactionId
            currency
            quantity
            receiveAddress {
              hotWalletAddress
              coin
              __typename
            }
            userWalletAddress {
              owner
              address
              nickname
              id
              createdAt
              updatedAt
              __typename
            }
            deposit
            status
            type
            version
            createdAt
            updatedAt
            accountInformationCryptoTransferId
            __typename
          }
          nextToken
          __typename
        }
        selectedWatchlist {
          items {
            id
            accountNumber
            owner
            watchListName
            selectedStocks
            createdAt
            updatedAt
            accountInformationSelectedWatchlistId
            __typename
          }
          nextToken
          __typename
        }
        notifications {
          items {
            id
            accountNumber
            owner
            notificationType
            message
            severity
            acknowledged
            star
            sent
            deleted
            toUser
            fromUser
            fromSystem
            ttl
            createdAt
            updatedAt
            accountInformationNotificationsId
            __typename
          }
          nextToken
          __typename
        }
        achRelationship {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          achRelationshipStatic {
            id
            accountNumber
            owner
            plaidProcessorToken
            plaidAccountId
            bankRoutingNumber
            bankAccount
            bankAccountOwnerName
            bankAccountType
            deleted
            approvalMethod
            relationshipId
            status
            statusCode
            statusJson
            createdAt
            updatedAt
            __typename
          }
          deleted
          nickname
          microDepositTries
          microDeposits
          microDepositStatus
          depositWithdrawalRequests {
            items {
              id
              accountNumber
              owner
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              relationshipId
              amount
              message
              memo
              reason
              iraContributionDistribution {
                contributionType
                applyToPriorYear
                distributionReason
                federalTaxWithholding {
                  valueType
                  value
                  __typename
                }
                stateTaxWithholding {
                  valueType
                  value
                  __typename
                }
                __typename
              }
              isFullDisbursement
              transferId
              deposit
              status
              cancel
              createdAt
              updatedAt
              achRelationshipDepositWithdrawalRequestsId
              __typename
            }
            nextToken
            __typename
          }
          reissueTries
          reissue
          createdAt
          updatedAt
          achRelationshipAchRelationshipStaticId
          achRelationshipAccountInformationId
          __typename
        }
        userProfileIds
        createdAt
        updatedAt
        userProfileAccountsId
        draftUserProfileAccountsId
        accountInformationBalanceId
        accountInformationPermissionsId
        accountInformationAchRelationshipId
        __typename
      }
      achRelationshipStatic {
        id
        accountNumber
        owner
        plaidProcessorToken
        plaidAccountId
        bankRoutingNumber
        bankAccount
        bankAccountOwnerName
        bankAccountType
        deleted
        approvalMethod
        relationshipId
        status
        statusCode
        statusJson
        createdAt
        updatedAt
        __typename
      }
      deleted
      nickname
      microDepositTries
      microDeposits
      microDepositStatus
      depositWithdrawalRequests {
        items {
          id
          accountNumber
          owner
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          relationshipId
          amount
          message
          memo
          reason
          iraContributionDistribution {
            contributionType
            applyToPriorYear
            distributionReason
            federalTaxWithholding {
              valueType
              value
              __typename
            }
            stateTaxWithholding {
              valueType
              value
              __typename
            }
            __typename
          }
          isFullDisbursement
          transferId
          deposit
          status
          cancel
          createdAt
          updatedAt
          achRelationshipDepositWithdrawalRequestsId
          __typename
        }
        nextToken
        __typename
      }
      reissueTries
      reissue
      createdAt
      updatedAt
      achRelationshipAchRelationshipStaticId
      achRelationshipAccountInformationId
      __typename
    }
  }
`;
export const updateAchRelationship = /* GraphQL */ `
  mutation UpdateAchRelationship(
    $input: UpdateAchRelationshipInput!
    $condition: ModelAchRelationshipConditionInput
  ) {
    updateAchRelationship(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      accountInformation {
        id
        primaryOwner
        owner
        accountNumber
        accountName
        accountType
        customerType
        accountRequestStatus
        investigationStatus
        apexId
        apexFdid
        apexCatAccountholderType
        apexJson
        accountStatus
        balance {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          overnightBuyingPowerID
          firm
          totalEquity
          marginEquity
          marginRequirement
          marginExcessEquity
          cashEquity
          cashRequirement
          cashExcessEquity
          overnightBuyingPowerIssued
          dayTradeBuyingPowerIssued
          regTBuyingPowerIssued
          overnightFactorIssued
          dayTradeFactorIssued
          marginEquityPercent
          positionMarketValue
          longEquityMarketValue
          shortEquityMarketValue
          longOptionMarketValue
          shortOptionMarketValue
          totalTradeBalance
          totalSettleBalance
          cashTradeBalance
          marginTradeBalance
          shortTradeBalance
          cashSettleBalance
          marginSettleBalance
          shortSettleBalance
          moneyMarketSettleBalance
          moneyMarketTradeBalance
          freeCash
          sma
          availableToWithdraw
          optionsRequirement
          nonOptionsRequirement
          lastUpdate
          nonOptionsRequirementNotConcentrated
          typeIUnavailableCashProceeds
          typeIIUnavailableCashProceeds
          netBalance
          smaCommitted
          netLiquidity
          pendingDebitInterest
          pendingDebitDividends
          fullyPaidUnsettledFunds
          cashOnOrders
          buyingPowerOnOrders
          marginExcessEquitySod
          cashExcessEquitySod
          netBalanceSod
          optionBuyingPowerInternal
          stockBuyingPowerInternal
          updateFlag
          accountType
          pendingTransfers {
            deposit
            amount
            achDepositWithdrawalRequestId
            __typename
          }
          createdAt
          updatedAt
          balanceAccountInformationId
          __typename
        }
        permissions {
          id
          accountNumber
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          owner
          systemAccess
          equityTrading
          optionsTrading
          cryptoTrading
          margin
          securitiesLending
          optionsLevel
          exitOnlyTrades
          restrictReason
          allowCancelOrder
          allowModifyOrder
          achWithdrawal
          patternDayTrader
          achApproval
          profileStatus
          betaFeatures
          achDeposit
          updatedBy
          createdAt
          updatedAt
          userPermissionsAccountInformationId
          __typename
        }
        userOrders {
          items {
            id
            accountNumber
            owner
            subAccountNumber
            cancel
            cancelReplace
            createdDate
            updatedDate
            commission
            feesAndCommission
            symbol
            side
            brokerSkipChecks
            brokerOverride
            brokerId
            quantity
            limitPrice
            stopPrice
            stockValue
            originalOrderId
            strategy
            avgPx
            orderType
            timeInForce
            instruction
            userOrderLegs {
              legType
              side
              quantity
              expiration
              strike
              openClose
              bid
              ask
              sharesPerContract
              avgPx
              __typename
            }
            cashSecured
            cashSecuredAmount
            message
            submitStatus
            status
            executionReports {
              items {
                id
                owner
                accountInformationId
                subAccountNumber
                orderID
                executionIncrementId
                secondaryOrderID
                clOrdID
                origClOrdID
                clientID
                execBroker
                listID
                execID
                execTransType
                execRefID
                execType
                ordStatus
                ordRejReason
                execRestatementReason
                account
                settlmntTyp
                futSettDate
                symbol
                symbolSfx
                securityID
                iDSource
                securityType
                maturityMonthYear
                maturityDay
                putOrCall
                strikePrice
                optAttribute
                contractMultiplier
                couponRate
                securityExchange
                issuer
                encodedIssuerLen
                encodedIssuer
                securityDesc
                encodedSecurityDescLen
                encodedSecurityDesc
                side
                orderQty
                cashOrderQty
                ordType
                price
                stopPx
                pegDifference
                discretionInst
                discretionOffset
                currency
                complianceID
                solicitedFlag
                timeInForce
                effectiveTime
                expireDate
                expireTime
                execInst
                rule80A
                lastShares
                lastPx
                lastSpotRate
                lastForwardPoints
                lastMkt
                tradingSessionID
                lastCapacity
                leavesQty
                cumQty
                avgPx
                dayOrderQty
                dayCumQty
                dayAvgPx
                gTBookingInst
                tradeDate
                transactTime
                reportToExch
                commission
                commType
                grossTradeAmt
                settlCurrAmt
                settlCurrency
                settlCurrFxRate
                settlCurrFxRateCalc
                handlInst
                minQty
                maxFloor
                openClose
                maxShow
                text
                encodedTextLen
                encodedText
                futSettDate2
                orderQty2
                clearingFirm
                clearingAccount
                multiLegReportingType
                legRefId
                uploadedToBackoffice
                fixMessage
                isAllocation
                groupUploadId
                processedAt
                createdDate
                createdAt
                updatedAt
                userOrderExecutionReportsId
                groupOrderExecutionReportsId
                __typename
              }
              nextToken
              __typename
            }
            cryptoOrder
            groupUploadOrderId
            reviewStatus
            createdAt
            updatedAt
            groupUpload {
              id
              name
              description
              orders {
                items {
                  id
                  groupUploadOrdersId
                  accountNumber
                  quantity
                  brokerOverride
                  commission
                  owner
                  userOrder {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  accountInformationId
                  failed
                  failedReason
                  orderIds
                  createdDate
                  createdAt
                  updatedAt
                  groupUploadOrderUserOrderId
                  __typename
                }
                nextToken
                __typename
              }
              owner
              isPlaced
              isPlacedString
              isAvgPx
              createdAt
              updatedAt
              __typename
            }
            accountInformationUserOrdersId
            userOrderGroupUploadId
            __typename
          }
          nextToken
          __typename
        }
        positions {
          items {
            id
            accountNumber
            owner
            underlying
            pricePaid
            isCryptoPosition
            quantity
            marginRequirement
            strategy
            positionLegs {
              side
              quantity
              ratioQuantity
              pricePaid
              legType
              cusip
              marginRequirement
              expiration
              strike
              __typename
            }
            subAccountNumber
            status
            groupUploadOrderId
            createdAt
            updatedAt
            accountInformationPositionsId
            __typename
          }
          nextToken
          __typename
        }
        subAccounts {
          items {
            id
            accountNumber
            owner
            subAccountName
            subAccountNumber
            selfDirected
            balance {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              accountType
              createdAt
              updatedAt
              __typename
            }
            transfers {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                toSubAccountNumber
                amount
                message
                deposit
                status
                cancel
                createdAt
                updatedAt
                subAccountTransfersId
                __typename
              }
              nextToken
              __typename
            }
            commissionCode
            repCode
            newsLetter {
              newsLetter
              portfolio
              __typename
            }
            stock {
              stockSignals
              maxDollarAllocationPerSignal
              maxNumberOfSharesPerSignal
              allOrNone
              roundLotsOnly
              multiplier
              __typename
            }
            option {
              optionSignals
              maxDollarAllocationPerSignal
              maxNumberOfContractsPerSignal
              allOrNone
              multiplier
              __typename
            }
            createdAt
            updatedAt
            accountInformationSubAccountsId
            subAccountBalanceId
            __typename
          }
          nextToken
          __typename
        }
        documentUpload {
          items {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            investigationId
            investigationNote
            submittedBy
            document {
              documentTag
              documentType
              s3uri
              __typename
            }
            approvedBy
            approvalStatus
            createdAt
            updatedAt
            accountInformationDocumentUploadId
            __typename
          }
          nextToken
          __typename
        }
        cryptoTransfer {
          items {
            id
            accountNumber
            owner
            blockchainHash
            clientTransactionId
            currency
            quantity
            receiveAddress {
              hotWalletAddress
              coin
              __typename
            }
            userWalletAddress {
              owner
              address
              nickname
              id
              createdAt
              updatedAt
              __typename
            }
            deposit
            status
            type
            version
            createdAt
            updatedAt
            accountInformationCryptoTransferId
            __typename
          }
          nextToken
          __typename
        }
        selectedWatchlist {
          items {
            id
            accountNumber
            owner
            watchListName
            selectedStocks
            createdAt
            updatedAt
            accountInformationSelectedWatchlistId
            __typename
          }
          nextToken
          __typename
        }
        notifications {
          items {
            id
            accountNumber
            owner
            notificationType
            message
            severity
            acknowledged
            star
            sent
            deleted
            toUser
            fromUser
            fromSystem
            ttl
            createdAt
            updatedAt
            accountInformationNotificationsId
            __typename
          }
          nextToken
          __typename
        }
        achRelationship {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          achRelationshipStatic {
            id
            accountNumber
            owner
            plaidProcessorToken
            plaidAccountId
            bankRoutingNumber
            bankAccount
            bankAccountOwnerName
            bankAccountType
            deleted
            approvalMethod
            relationshipId
            status
            statusCode
            statusJson
            createdAt
            updatedAt
            __typename
          }
          deleted
          nickname
          microDepositTries
          microDeposits
          microDepositStatus
          depositWithdrawalRequests {
            items {
              id
              accountNumber
              owner
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              relationshipId
              amount
              message
              memo
              reason
              iraContributionDistribution {
                contributionType
                applyToPriorYear
                distributionReason
                federalTaxWithholding {
                  valueType
                  value
                  __typename
                }
                stateTaxWithholding {
                  valueType
                  value
                  __typename
                }
                __typename
              }
              isFullDisbursement
              transferId
              deposit
              status
              cancel
              createdAt
              updatedAt
              achRelationshipDepositWithdrawalRequestsId
              __typename
            }
            nextToken
            __typename
          }
          reissueTries
          reissue
          createdAt
          updatedAt
          achRelationshipAchRelationshipStaticId
          achRelationshipAccountInformationId
          __typename
        }
        userProfileIds
        createdAt
        updatedAt
        userProfileAccountsId
        draftUserProfileAccountsId
        accountInformationBalanceId
        accountInformationPermissionsId
        accountInformationAchRelationshipId
        __typename
      }
      achRelationshipStatic {
        id
        accountNumber
        owner
        plaidProcessorToken
        plaidAccountId
        bankRoutingNumber
        bankAccount
        bankAccountOwnerName
        bankAccountType
        deleted
        approvalMethod
        relationshipId
        status
        statusCode
        statusJson
        createdAt
        updatedAt
        __typename
      }
      deleted
      nickname
      microDepositTries
      microDeposits
      microDepositStatus
      depositWithdrawalRequests {
        items {
          id
          accountNumber
          owner
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          relationshipId
          amount
          message
          memo
          reason
          iraContributionDistribution {
            contributionType
            applyToPriorYear
            distributionReason
            federalTaxWithholding {
              valueType
              value
              __typename
            }
            stateTaxWithholding {
              valueType
              value
              __typename
            }
            __typename
          }
          isFullDisbursement
          transferId
          deposit
          status
          cancel
          createdAt
          updatedAt
          achRelationshipDepositWithdrawalRequestsId
          __typename
        }
        nextToken
        __typename
      }
      reissueTries
      reissue
      createdAt
      updatedAt
      achRelationshipAchRelationshipStaticId
      achRelationshipAccountInformationId
      __typename
    }
  }
`;
export const deleteAchRelationship = /* GraphQL */ `
  mutation DeleteAchRelationship(
    $input: DeleteAchRelationshipInput!
    $condition: ModelAchRelationshipConditionInput
  ) {
    deleteAchRelationship(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      accountInformation {
        id
        primaryOwner
        owner
        accountNumber
        accountName
        accountType
        customerType
        accountRequestStatus
        investigationStatus
        apexId
        apexFdid
        apexCatAccountholderType
        apexJson
        accountStatus
        balance {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          overnightBuyingPowerID
          firm
          totalEquity
          marginEquity
          marginRequirement
          marginExcessEquity
          cashEquity
          cashRequirement
          cashExcessEquity
          overnightBuyingPowerIssued
          dayTradeBuyingPowerIssued
          regTBuyingPowerIssued
          overnightFactorIssued
          dayTradeFactorIssued
          marginEquityPercent
          positionMarketValue
          longEquityMarketValue
          shortEquityMarketValue
          longOptionMarketValue
          shortOptionMarketValue
          totalTradeBalance
          totalSettleBalance
          cashTradeBalance
          marginTradeBalance
          shortTradeBalance
          cashSettleBalance
          marginSettleBalance
          shortSettleBalance
          moneyMarketSettleBalance
          moneyMarketTradeBalance
          freeCash
          sma
          availableToWithdraw
          optionsRequirement
          nonOptionsRequirement
          lastUpdate
          nonOptionsRequirementNotConcentrated
          typeIUnavailableCashProceeds
          typeIIUnavailableCashProceeds
          netBalance
          smaCommitted
          netLiquidity
          pendingDebitInterest
          pendingDebitDividends
          fullyPaidUnsettledFunds
          cashOnOrders
          buyingPowerOnOrders
          marginExcessEquitySod
          cashExcessEquitySod
          netBalanceSod
          optionBuyingPowerInternal
          stockBuyingPowerInternal
          updateFlag
          accountType
          pendingTransfers {
            deposit
            amount
            achDepositWithdrawalRequestId
            __typename
          }
          createdAt
          updatedAt
          balanceAccountInformationId
          __typename
        }
        permissions {
          id
          accountNumber
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          owner
          systemAccess
          equityTrading
          optionsTrading
          cryptoTrading
          margin
          securitiesLending
          optionsLevel
          exitOnlyTrades
          restrictReason
          allowCancelOrder
          allowModifyOrder
          achWithdrawal
          patternDayTrader
          achApproval
          profileStatus
          betaFeatures
          achDeposit
          updatedBy
          createdAt
          updatedAt
          userPermissionsAccountInformationId
          __typename
        }
        userOrders {
          items {
            id
            accountNumber
            owner
            subAccountNumber
            cancel
            cancelReplace
            createdDate
            updatedDate
            commission
            feesAndCommission
            symbol
            side
            brokerSkipChecks
            brokerOverride
            brokerId
            quantity
            limitPrice
            stopPrice
            stockValue
            originalOrderId
            strategy
            avgPx
            orderType
            timeInForce
            instruction
            userOrderLegs {
              legType
              side
              quantity
              expiration
              strike
              openClose
              bid
              ask
              sharesPerContract
              avgPx
              __typename
            }
            cashSecured
            cashSecuredAmount
            message
            submitStatus
            status
            executionReports {
              items {
                id
                owner
                accountInformationId
                subAccountNumber
                orderID
                executionIncrementId
                secondaryOrderID
                clOrdID
                origClOrdID
                clientID
                execBroker
                listID
                execID
                execTransType
                execRefID
                execType
                ordStatus
                ordRejReason
                execRestatementReason
                account
                settlmntTyp
                futSettDate
                symbol
                symbolSfx
                securityID
                iDSource
                securityType
                maturityMonthYear
                maturityDay
                putOrCall
                strikePrice
                optAttribute
                contractMultiplier
                couponRate
                securityExchange
                issuer
                encodedIssuerLen
                encodedIssuer
                securityDesc
                encodedSecurityDescLen
                encodedSecurityDesc
                side
                orderQty
                cashOrderQty
                ordType
                price
                stopPx
                pegDifference
                discretionInst
                discretionOffset
                currency
                complianceID
                solicitedFlag
                timeInForce
                effectiveTime
                expireDate
                expireTime
                execInst
                rule80A
                lastShares
                lastPx
                lastSpotRate
                lastForwardPoints
                lastMkt
                tradingSessionID
                lastCapacity
                leavesQty
                cumQty
                avgPx
                dayOrderQty
                dayCumQty
                dayAvgPx
                gTBookingInst
                tradeDate
                transactTime
                reportToExch
                commission
                commType
                grossTradeAmt
                settlCurrAmt
                settlCurrency
                settlCurrFxRate
                settlCurrFxRateCalc
                handlInst
                minQty
                maxFloor
                openClose
                maxShow
                text
                encodedTextLen
                encodedText
                futSettDate2
                orderQty2
                clearingFirm
                clearingAccount
                multiLegReportingType
                legRefId
                uploadedToBackoffice
                fixMessage
                isAllocation
                groupUploadId
                processedAt
                createdDate
                createdAt
                updatedAt
                userOrderExecutionReportsId
                groupOrderExecutionReportsId
                __typename
              }
              nextToken
              __typename
            }
            cryptoOrder
            groupUploadOrderId
            reviewStatus
            createdAt
            updatedAt
            groupUpload {
              id
              name
              description
              orders {
                items {
                  id
                  groupUploadOrdersId
                  accountNumber
                  quantity
                  brokerOverride
                  commission
                  owner
                  userOrder {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  accountInformationId
                  failed
                  failedReason
                  orderIds
                  createdDate
                  createdAt
                  updatedAt
                  groupUploadOrderUserOrderId
                  __typename
                }
                nextToken
                __typename
              }
              owner
              isPlaced
              isPlacedString
              isAvgPx
              createdAt
              updatedAt
              __typename
            }
            accountInformationUserOrdersId
            userOrderGroupUploadId
            __typename
          }
          nextToken
          __typename
        }
        positions {
          items {
            id
            accountNumber
            owner
            underlying
            pricePaid
            isCryptoPosition
            quantity
            marginRequirement
            strategy
            positionLegs {
              side
              quantity
              ratioQuantity
              pricePaid
              legType
              cusip
              marginRequirement
              expiration
              strike
              __typename
            }
            subAccountNumber
            status
            groupUploadOrderId
            createdAt
            updatedAt
            accountInformationPositionsId
            __typename
          }
          nextToken
          __typename
        }
        subAccounts {
          items {
            id
            accountNumber
            owner
            subAccountName
            subAccountNumber
            selfDirected
            balance {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              accountType
              createdAt
              updatedAt
              __typename
            }
            transfers {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                toSubAccountNumber
                amount
                message
                deposit
                status
                cancel
                createdAt
                updatedAt
                subAccountTransfersId
                __typename
              }
              nextToken
              __typename
            }
            commissionCode
            repCode
            newsLetter {
              newsLetter
              portfolio
              __typename
            }
            stock {
              stockSignals
              maxDollarAllocationPerSignal
              maxNumberOfSharesPerSignal
              allOrNone
              roundLotsOnly
              multiplier
              __typename
            }
            option {
              optionSignals
              maxDollarAllocationPerSignal
              maxNumberOfContractsPerSignal
              allOrNone
              multiplier
              __typename
            }
            createdAt
            updatedAt
            accountInformationSubAccountsId
            subAccountBalanceId
            __typename
          }
          nextToken
          __typename
        }
        documentUpload {
          items {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            investigationId
            investigationNote
            submittedBy
            document {
              documentTag
              documentType
              s3uri
              __typename
            }
            approvedBy
            approvalStatus
            createdAt
            updatedAt
            accountInformationDocumentUploadId
            __typename
          }
          nextToken
          __typename
        }
        cryptoTransfer {
          items {
            id
            accountNumber
            owner
            blockchainHash
            clientTransactionId
            currency
            quantity
            receiveAddress {
              hotWalletAddress
              coin
              __typename
            }
            userWalletAddress {
              owner
              address
              nickname
              id
              createdAt
              updatedAt
              __typename
            }
            deposit
            status
            type
            version
            createdAt
            updatedAt
            accountInformationCryptoTransferId
            __typename
          }
          nextToken
          __typename
        }
        selectedWatchlist {
          items {
            id
            accountNumber
            owner
            watchListName
            selectedStocks
            createdAt
            updatedAt
            accountInformationSelectedWatchlistId
            __typename
          }
          nextToken
          __typename
        }
        notifications {
          items {
            id
            accountNumber
            owner
            notificationType
            message
            severity
            acknowledged
            star
            sent
            deleted
            toUser
            fromUser
            fromSystem
            ttl
            createdAt
            updatedAt
            accountInformationNotificationsId
            __typename
          }
          nextToken
          __typename
        }
        achRelationship {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          achRelationshipStatic {
            id
            accountNumber
            owner
            plaidProcessorToken
            plaidAccountId
            bankRoutingNumber
            bankAccount
            bankAccountOwnerName
            bankAccountType
            deleted
            approvalMethod
            relationshipId
            status
            statusCode
            statusJson
            createdAt
            updatedAt
            __typename
          }
          deleted
          nickname
          microDepositTries
          microDeposits
          microDepositStatus
          depositWithdrawalRequests {
            items {
              id
              accountNumber
              owner
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              relationshipId
              amount
              message
              memo
              reason
              iraContributionDistribution {
                contributionType
                applyToPriorYear
                distributionReason
                federalTaxWithholding {
                  valueType
                  value
                  __typename
                }
                stateTaxWithholding {
                  valueType
                  value
                  __typename
                }
                __typename
              }
              isFullDisbursement
              transferId
              deposit
              status
              cancel
              createdAt
              updatedAt
              achRelationshipDepositWithdrawalRequestsId
              __typename
            }
            nextToken
            __typename
          }
          reissueTries
          reissue
          createdAt
          updatedAt
          achRelationshipAchRelationshipStaticId
          achRelationshipAccountInformationId
          __typename
        }
        userProfileIds
        createdAt
        updatedAt
        userProfileAccountsId
        draftUserProfileAccountsId
        accountInformationBalanceId
        accountInformationPermissionsId
        accountInformationAchRelationshipId
        __typename
      }
      achRelationshipStatic {
        id
        accountNumber
        owner
        plaidProcessorToken
        plaidAccountId
        bankRoutingNumber
        bankAccount
        bankAccountOwnerName
        bankAccountType
        deleted
        approvalMethod
        relationshipId
        status
        statusCode
        statusJson
        createdAt
        updatedAt
        __typename
      }
      deleted
      nickname
      microDepositTries
      microDeposits
      microDepositStatus
      depositWithdrawalRequests {
        items {
          id
          accountNumber
          owner
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          relationshipId
          amount
          message
          memo
          reason
          iraContributionDistribution {
            contributionType
            applyToPriorYear
            distributionReason
            federalTaxWithholding {
              valueType
              value
              __typename
            }
            stateTaxWithholding {
              valueType
              value
              __typename
            }
            __typename
          }
          isFullDisbursement
          transferId
          deposit
          status
          cancel
          createdAt
          updatedAt
          achRelationshipDepositWithdrawalRequestsId
          __typename
        }
        nextToken
        __typename
      }
      reissueTries
      reissue
      createdAt
      updatedAt
      achRelationshipAchRelationshipStaticId
      achRelationshipAccountInformationId
      __typename
    }
  }
`;
export const createAchRelationshipStatic = /* GraphQL */ `
  mutation CreateAchRelationshipStatic(
    $input: CreateAchRelationshipStaticInput!
    $condition: ModelAchRelationshipStaticConditionInput
  ) {
    createAchRelationshipStatic(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      plaidProcessorToken
      plaidAccountId
      bankRoutingNumber
      bankAccount
      bankAccountOwnerName
      bankAccountType
      deleted
      approvalMethod
      relationshipId
      status
      statusCode
      statusJson
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAchRelationshipStatic = /* GraphQL */ `
  mutation UpdateAchRelationshipStatic(
    $input: UpdateAchRelationshipStaticInput!
    $condition: ModelAchRelationshipStaticConditionInput
  ) {
    updateAchRelationshipStatic(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      plaidProcessorToken
      plaidAccountId
      bankRoutingNumber
      bankAccount
      bankAccountOwnerName
      bankAccountType
      deleted
      approvalMethod
      relationshipId
      status
      statusCode
      statusJson
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAchRelationshipStatic = /* GraphQL */ `
  mutation DeleteAchRelationshipStatic(
    $input: DeleteAchRelationshipStaticInput!
    $condition: ModelAchRelationshipStaticConditionInput
  ) {
    deleteAchRelationshipStatic(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      plaidProcessorToken
      plaidAccountId
      bankRoutingNumber
      bankAccount
      bankAccountOwnerName
      bankAccountType
      deleted
      approvalMethod
      relationshipId
      status
      statusCode
      statusJson
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAchDepositWithdrawalRequest = /* GraphQL */ `
  mutation CreateAchDepositWithdrawalRequest(
    $input: CreateAchDepositWithdrawalRequestInput!
    $condition: ModelAchDepositWithdrawalRequestConditionInput
  ) {
    createAchDepositWithdrawalRequest(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      achRelationship {
        id
        accountNumber
        owner
        accountInformation {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        achRelationshipStatic {
          id
          accountNumber
          owner
          plaidProcessorToken
          plaidAccountId
          bankRoutingNumber
          bankAccount
          bankAccountOwnerName
          bankAccountType
          deleted
          approvalMethod
          relationshipId
          status
          statusCode
          statusJson
          createdAt
          updatedAt
          __typename
        }
        deleted
        nickname
        microDepositTries
        microDeposits
        microDepositStatus
        depositWithdrawalRequests {
          items {
            id
            accountNumber
            owner
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            relationshipId
            amount
            message
            memo
            reason
            iraContributionDistribution {
              contributionType
              applyToPriorYear
              distributionReason
              federalTaxWithholding {
                valueType
                value
                __typename
              }
              stateTaxWithholding {
                valueType
                value
                __typename
              }
              __typename
            }
            isFullDisbursement
            transferId
            deposit
            status
            cancel
            createdAt
            updatedAt
            achRelationshipDepositWithdrawalRequestsId
            __typename
          }
          nextToken
          __typename
        }
        reissueTries
        reissue
        createdAt
        updatedAt
        achRelationshipAchRelationshipStaticId
        achRelationshipAccountInformationId
        __typename
      }
      relationshipId
      amount
      message
      memo
      reason
      iraContributionDistribution {
        contributionType
        applyToPriorYear
        distributionReason
        federalTaxWithholding {
          valueType
          value
          __typename
        }
        stateTaxWithholding {
          valueType
          value
          __typename
        }
        __typename
      }
      isFullDisbursement
      transferId
      deposit
      status
      cancel
      createdAt
      updatedAt
      achRelationshipDepositWithdrawalRequestsId
      __typename
    }
  }
`;
export const updateAchDepositWithdrawalRequest = /* GraphQL */ `
  mutation UpdateAchDepositWithdrawalRequest(
    $input: UpdateAchDepositWithdrawalRequestInput!
    $condition: ModelAchDepositWithdrawalRequestConditionInput
  ) {
    updateAchDepositWithdrawalRequest(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      achRelationship {
        id
        accountNumber
        owner
        accountInformation {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        achRelationshipStatic {
          id
          accountNumber
          owner
          plaidProcessorToken
          plaidAccountId
          bankRoutingNumber
          bankAccount
          bankAccountOwnerName
          bankAccountType
          deleted
          approvalMethod
          relationshipId
          status
          statusCode
          statusJson
          createdAt
          updatedAt
          __typename
        }
        deleted
        nickname
        microDepositTries
        microDeposits
        microDepositStatus
        depositWithdrawalRequests {
          items {
            id
            accountNumber
            owner
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            relationshipId
            amount
            message
            memo
            reason
            iraContributionDistribution {
              contributionType
              applyToPriorYear
              distributionReason
              federalTaxWithholding {
                valueType
                value
                __typename
              }
              stateTaxWithholding {
                valueType
                value
                __typename
              }
              __typename
            }
            isFullDisbursement
            transferId
            deposit
            status
            cancel
            createdAt
            updatedAt
            achRelationshipDepositWithdrawalRequestsId
            __typename
          }
          nextToken
          __typename
        }
        reissueTries
        reissue
        createdAt
        updatedAt
        achRelationshipAchRelationshipStaticId
        achRelationshipAccountInformationId
        __typename
      }
      relationshipId
      amount
      message
      memo
      reason
      iraContributionDistribution {
        contributionType
        applyToPriorYear
        distributionReason
        federalTaxWithholding {
          valueType
          value
          __typename
        }
        stateTaxWithholding {
          valueType
          value
          __typename
        }
        __typename
      }
      isFullDisbursement
      transferId
      deposit
      status
      cancel
      createdAt
      updatedAt
      achRelationshipDepositWithdrawalRequestsId
      __typename
    }
  }
`;
export const deleteAchDepositWithdrawalRequest = /* GraphQL */ `
  mutation DeleteAchDepositWithdrawalRequest(
    $input: DeleteAchDepositWithdrawalRequestInput!
    $condition: ModelAchDepositWithdrawalRequestConditionInput
  ) {
    deleteAchDepositWithdrawalRequest(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      achRelationship {
        id
        accountNumber
        owner
        accountInformation {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        achRelationshipStatic {
          id
          accountNumber
          owner
          plaidProcessorToken
          plaidAccountId
          bankRoutingNumber
          bankAccount
          bankAccountOwnerName
          bankAccountType
          deleted
          approvalMethod
          relationshipId
          status
          statusCode
          statusJson
          createdAt
          updatedAt
          __typename
        }
        deleted
        nickname
        microDepositTries
        microDeposits
        microDepositStatus
        depositWithdrawalRequests {
          items {
            id
            accountNumber
            owner
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            relationshipId
            amount
            message
            memo
            reason
            iraContributionDistribution {
              contributionType
              applyToPriorYear
              distributionReason
              federalTaxWithholding {
                valueType
                value
                __typename
              }
              stateTaxWithholding {
                valueType
                value
                __typename
              }
              __typename
            }
            isFullDisbursement
            transferId
            deposit
            status
            cancel
            createdAt
            updatedAt
            achRelationshipDepositWithdrawalRequestsId
            __typename
          }
          nextToken
          __typename
        }
        reissueTries
        reissue
        createdAt
        updatedAt
        achRelationshipAchRelationshipStaticId
        achRelationshipAccountInformationId
        __typename
      }
      relationshipId
      amount
      message
      memo
      reason
      iraContributionDistribution {
        contributionType
        applyToPriorYear
        distributionReason
        federalTaxWithholding {
          valueType
          value
          __typename
        }
        stateTaxWithholding {
          valueType
          value
          __typename
        }
        __typename
      }
      isFullDisbursement
      transferId
      deposit
      status
      cancel
      createdAt
      updatedAt
      achRelationshipDepositWithdrawalRequestsId
      __typename
    }
  }
`;
export const createBalance = /* GraphQL */ `
  mutation CreateBalance(
    $input: CreateBalanceInput!
    $condition: ModelBalanceConditionInput
  ) {
    createBalance(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      accountInformation {
        id
        primaryOwner
        owner
        accountNumber
        accountName
        accountType
        customerType
        accountRequestStatus
        investigationStatus
        apexId
        apexFdid
        apexCatAccountholderType
        apexJson
        accountStatus
        balance {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          overnightBuyingPowerID
          firm
          totalEquity
          marginEquity
          marginRequirement
          marginExcessEquity
          cashEquity
          cashRequirement
          cashExcessEquity
          overnightBuyingPowerIssued
          dayTradeBuyingPowerIssued
          regTBuyingPowerIssued
          overnightFactorIssued
          dayTradeFactorIssued
          marginEquityPercent
          positionMarketValue
          longEquityMarketValue
          shortEquityMarketValue
          longOptionMarketValue
          shortOptionMarketValue
          totalTradeBalance
          totalSettleBalance
          cashTradeBalance
          marginTradeBalance
          shortTradeBalance
          cashSettleBalance
          marginSettleBalance
          shortSettleBalance
          moneyMarketSettleBalance
          moneyMarketTradeBalance
          freeCash
          sma
          availableToWithdraw
          optionsRequirement
          nonOptionsRequirement
          lastUpdate
          nonOptionsRequirementNotConcentrated
          typeIUnavailableCashProceeds
          typeIIUnavailableCashProceeds
          netBalance
          smaCommitted
          netLiquidity
          pendingDebitInterest
          pendingDebitDividends
          fullyPaidUnsettledFunds
          cashOnOrders
          buyingPowerOnOrders
          marginExcessEquitySod
          cashExcessEquitySod
          netBalanceSod
          optionBuyingPowerInternal
          stockBuyingPowerInternal
          updateFlag
          accountType
          pendingTransfers {
            deposit
            amount
            achDepositWithdrawalRequestId
            __typename
          }
          createdAt
          updatedAt
          balanceAccountInformationId
          __typename
        }
        permissions {
          id
          accountNumber
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          owner
          systemAccess
          equityTrading
          optionsTrading
          cryptoTrading
          margin
          securitiesLending
          optionsLevel
          exitOnlyTrades
          restrictReason
          allowCancelOrder
          allowModifyOrder
          achWithdrawal
          patternDayTrader
          achApproval
          profileStatus
          betaFeatures
          achDeposit
          updatedBy
          createdAt
          updatedAt
          userPermissionsAccountInformationId
          __typename
        }
        userOrders {
          items {
            id
            accountNumber
            owner
            subAccountNumber
            cancel
            cancelReplace
            createdDate
            updatedDate
            commission
            feesAndCommission
            symbol
            side
            brokerSkipChecks
            brokerOverride
            brokerId
            quantity
            limitPrice
            stopPrice
            stockValue
            originalOrderId
            strategy
            avgPx
            orderType
            timeInForce
            instruction
            userOrderLegs {
              legType
              side
              quantity
              expiration
              strike
              openClose
              bid
              ask
              sharesPerContract
              avgPx
              __typename
            }
            cashSecured
            cashSecuredAmount
            message
            submitStatus
            status
            executionReports {
              items {
                id
                owner
                accountInformationId
                subAccountNumber
                orderID
                executionIncrementId
                secondaryOrderID
                clOrdID
                origClOrdID
                clientID
                execBroker
                listID
                execID
                execTransType
                execRefID
                execType
                ordStatus
                ordRejReason
                execRestatementReason
                account
                settlmntTyp
                futSettDate
                symbol
                symbolSfx
                securityID
                iDSource
                securityType
                maturityMonthYear
                maturityDay
                putOrCall
                strikePrice
                optAttribute
                contractMultiplier
                couponRate
                securityExchange
                issuer
                encodedIssuerLen
                encodedIssuer
                securityDesc
                encodedSecurityDescLen
                encodedSecurityDesc
                side
                orderQty
                cashOrderQty
                ordType
                price
                stopPx
                pegDifference
                discretionInst
                discretionOffset
                currency
                complianceID
                solicitedFlag
                timeInForce
                effectiveTime
                expireDate
                expireTime
                execInst
                rule80A
                lastShares
                lastPx
                lastSpotRate
                lastForwardPoints
                lastMkt
                tradingSessionID
                lastCapacity
                leavesQty
                cumQty
                avgPx
                dayOrderQty
                dayCumQty
                dayAvgPx
                gTBookingInst
                tradeDate
                transactTime
                reportToExch
                commission
                commType
                grossTradeAmt
                settlCurrAmt
                settlCurrency
                settlCurrFxRate
                settlCurrFxRateCalc
                handlInst
                minQty
                maxFloor
                openClose
                maxShow
                text
                encodedTextLen
                encodedText
                futSettDate2
                orderQty2
                clearingFirm
                clearingAccount
                multiLegReportingType
                legRefId
                uploadedToBackoffice
                fixMessage
                isAllocation
                groupUploadId
                processedAt
                createdDate
                createdAt
                updatedAt
                userOrderExecutionReportsId
                groupOrderExecutionReportsId
                __typename
              }
              nextToken
              __typename
            }
            cryptoOrder
            groupUploadOrderId
            reviewStatus
            createdAt
            updatedAt
            groupUpload {
              id
              name
              description
              orders {
                items {
                  id
                  groupUploadOrdersId
                  accountNumber
                  quantity
                  brokerOverride
                  commission
                  owner
                  userOrder {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  accountInformationId
                  failed
                  failedReason
                  orderIds
                  createdDate
                  createdAt
                  updatedAt
                  groupUploadOrderUserOrderId
                  __typename
                }
                nextToken
                __typename
              }
              owner
              isPlaced
              isPlacedString
              isAvgPx
              createdAt
              updatedAt
              __typename
            }
            accountInformationUserOrdersId
            userOrderGroupUploadId
            __typename
          }
          nextToken
          __typename
        }
        positions {
          items {
            id
            accountNumber
            owner
            underlying
            pricePaid
            isCryptoPosition
            quantity
            marginRequirement
            strategy
            positionLegs {
              side
              quantity
              ratioQuantity
              pricePaid
              legType
              cusip
              marginRequirement
              expiration
              strike
              __typename
            }
            subAccountNumber
            status
            groupUploadOrderId
            createdAt
            updatedAt
            accountInformationPositionsId
            __typename
          }
          nextToken
          __typename
        }
        subAccounts {
          items {
            id
            accountNumber
            owner
            subAccountName
            subAccountNumber
            selfDirected
            balance {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              accountType
              createdAt
              updatedAt
              __typename
            }
            transfers {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                toSubAccountNumber
                amount
                message
                deposit
                status
                cancel
                createdAt
                updatedAt
                subAccountTransfersId
                __typename
              }
              nextToken
              __typename
            }
            commissionCode
            repCode
            newsLetter {
              newsLetter
              portfolio
              __typename
            }
            stock {
              stockSignals
              maxDollarAllocationPerSignal
              maxNumberOfSharesPerSignal
              allOrNone
              roundLotsOnly
              multiplier
              __typename
            }
            option {
              optionSignals
              maxDollarAllocationPerSignal
              maxNumberOfContractsPerSignal
              allOrNone
              multiplier
              __typename
            }
            createdAt
            updatedAt
            accountInformationSubAccountsId
            subAccountBalanceId
            __typename
          }
          nextToken
          __typename
        }
        documentUpload {
          items {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            investigationId
            investigationNote
            submittedBy
            document {
              documentTag
              documentType
              s3uri
              __typename
            }
            approvedBy
            approvalStatus
            createdAt
            updatedAt
            accountInformationDocumentUploadId
            __typename
          }
          nextToken
          __typename
        }
        cryptoTransfer {
          items {
            id
            accountNumber
            owner
            blockchainHash
            clientTransactionId
            currency
            quantity
            receiveAddress {
              hotWalletAddress
              coin
              __typename
            }
            userWalletAddress {
              owner
              address
              nickname
              id
              createdAt
              updatedAt
              __typename
            }
            deposit
            status
            type
            version
            createdAt
            updatedAt
            accountInformationCryptoTransferId
            __typename
          }
          nextToken
          __typename
        }
        selectedWatchlist {
          items {
            id
            accountNumber
            owner
            watchListName
            selectedStocks
            createdAt
            updatedAt
            accountInformationSelectedWatchlistId
            __typename
          }
          nextToken
          __typename
        }
        notifications {
          items {
            id
            accountNumber
            owner
            notificationType
            message
            severity
            acknowledged
            star
            sent
            deleted
            toUser
            fromUser
            fromSystem
            ttl
            createdAt
            updatedAt
            accountInformationNotificationsId
            __typename
          }
          nextToken
          __typename
        }
        achRelationship {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          achRelationshipStatic {
            id
            accountNumber
            owner
            plaidProcessorToken
            plaidAccountId
            bankRoutingNumber
            bankAccount
            bankAccountOwnerName
            bankAccountType
            deleted
            approvalMethod
            relationshipId
            status
            statusCode
            statusJson
            createdAt
            updatedAt
            __typename
          }
          deleted
          nickname
          microDepositTries
          microDeposits
          microDepositStatus
          depositWithdrawalRequests {
            items {
              id
              accountNumber
              owner
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              relationshipId
              amount
              message
              memo
              reason
              iraContributionDistribution {
                contributionType
                applyToPriorYear
                distributionReason
                federalTaxWithholding {
                  valueType
                  value
                  __typename
                }
                stateTaxWithholding {
                  valueType
                  value
                  __typename
                }
                __typename
              }
              isFullDisbursement
              transferId
              deposit
              status
              cancel
              createdAt
              updatedAt
              achRelationshipDepositWithdrawalRequestsId
              __typename
            }
            nextToken
            __typename
          }
          reissueTries
          reissue
          createdAt
          updatedAt
          achRelationshipAchRelationshipStaticId
          achRelationshipAccountInformationId
          __typename
        }
        userProfileIds
        createdAt
        updatedAt
        userProfileAccountsId
        draftUserProfileAccountsId
        accountInformationBalanceId
        accountInformationPermissionsId
        accountInformationAchRelationshipId
        __typename
      }
      overnightBuyingPowerID
      firm
      totalEquity
      marginEquity
      marginRequirement
      marginExcessEquity
      cashEquity
      cashRequirement
      cashExcessEquity
      overnightBuyingPowerIssued
      dayTradeBuyingPowerIssued
      regTBuyingPowerIssued
      overnightFactorIssued
      dayTradeFactorIssued
      marginEquityPercent
      positionMarketValue
      longEquityMarketValue
      shortEquityMarketValue
      longOptionMarketValue
      shortOptionMarketValue
      totalTradeBalance
      totalSettleBalance
      cashTradeBalance
      marginTradeBalance
      shortTradeBalance
      cashSettleBalance
      marginSettleBalance
      shortSettleBalance
      moneyMarketSettleBalance
      moneyMarketTradeBalance
      freeCash
      sma
      availableToWithdraw
      optionsRequirement
      nonOptionsRequirement
      lastUpdate
      nonOptionsRequirementNotConcentrated
      typeIUnavailableCashProceeds
      typeIIUnavailableCashProceeds
      netBalance
      smaCommitted
      netLiquidity
      pendingDebitInterest
      pendingDebitDividends
      fullyPaidUnsettledFunds
      cashOnOrders
      buyingPowerOnOrders
      marginExcessEquitySod
      cashExcessEquitySod
      netBalanceSod
      optionBuyingPowerInternal
      stockBuyingPowerInternal
      updateFlag
      accountType
      pendingTransfers {
        deposit
        amount
        achDepositWithdrawalRequestId
        __typename
      }
      createdAt
      updatedAt
      balanceAccountInformationId
      __typename
    }
  }
`;
export const updateBalance = /* GraphQL */ `
  mutation UpdateBalance(
    $input: UpdateBalanceInput!
    $condition: ModelBalanceConditionInput
  ) {
    updateBalance(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      accountInformation {
        id
        primaryOwner
        owner
        accountNumber
        accountName
        accountType
        customerType
        accountRequestStatus
        investigationStatus
        apexId
        apexFdid
        apexCatAccountholderType
        apexJson
        accountStatus
        balance {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          overnightBuyingPowerID
          firm
          totalEquity
          marginEquity
          marginRequirement
          marginExcessEquity
          cashEquity
          cashRequirement
          cashExcessEquity
          overnightBuyingPowerIssued
          dayTradeBuyingPowerIssued
          regTBuyingPowerIssued
          overnightFactorIssued
          dayTradeFactorIssued
          marginEquityPercent
          positionMarketValue
          longEquityMarketValue
          shortEquityMarketValue
          longOptionMarketValue
          shortOptionMarketValue
          totalTradeBalance
          totalSettleBalance
          cashTradeBalance
          marginTradeBalance
          shortTradeBalance
          cashSettleBalance
          marginSettleBalance
          shortSettleBalance
          moneyMarketSettleBalance
          moneyMarketTradeBalance
          freeCash
          sma
          availableToWithdraw
          optionsRequirement
          nonOptionsRequirement
          lastUpdate
          nonOptionsRequirementNotConcentrated
          typeIUnavailableCashProceeds
          typeIIUnavailableCashProceeds
          netBalance
          smaCommitted
          netLiquidity
          pendingDebitInterest
          pendingDebitDividends
          fullyPaidUnsettledFunds
          cashOnOrders
          buyingPowerOnOrders
          marginExcessEquitySod
          cashExcessEquitySod
          netBalanceSod
          optionBuyingPowerInternal
          stockBuyingPowerInternal
          updateFlag
          accountType
          pendingTransfers {
            deposit
            amount
            achDepositWithdrawalRequestId
            __typename
          }
          createdAt
          updatedAt
          balanceAccountInformationId
          __typename
        }
        permissions {
          id
          accountNumber
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          owner
          systemAccess
          equityTrading
          optionsTrading
          cryptoTrading
          margin
          securitiesLending
          optionsLevel
          exitOnlyTrades
          restrictReason
          allowCancelOrder
          allowModifyOrder
          achWithdrawal
          patternDayTrader
          achApproval
          profileStatus
          betaFeatures
          achDeposit
          updatedBy
          createdAt
          updatedAt
          userPermissionsAccountInformationId
          __typename
        }
        userOrders {
          items {
            id
            accountNumber
            owner
            subAccountNumber
            cancel
            cancelReplace
            createdDate
            updatedDate
            commission
            feesAndCommission
            symbol
            side
            brokerSkipChecks
            brokerOverride
            brokerId
            quantity
            limitPrice
            stopPrice
            stockValue
            originalOrderId
            strategy
            avgPx
            orderType
            timeInForce
            instruction
            userOrderLegs {
              legType
              side
              quantity
              expiration
              strike
              openClose
              bid
              ask
              sharesPerContract
              avgPx
              __typename
            }
            cashSecured
            cashSecuredAmount
            message
            submitStatus
            status
            executionReports {
              items {
                id
                owner
                accountInformationId
                subAccountNumber
                orderID
                executionIncrementId
                secondaryOrderID
                clOrdID
                origClOrdID
                clientID
                execBroker
                listID
                execID
                execTransType
                execRefID
                execType
                ordStatus
                ordRejReason
                execRestatementReason
                account
                settlmntTyp
                futSettDate
                symbol
                symbolSfx
                securityID
                iDSource
                securityType
                maturityMonthYear
                maturityDay
                putOrCall
                strikePrice
                optAttribute
                contractMultiplier
                couponRate
                securityExchange
                issuer
                encodedIssuerLen
                encodedIssuer
                securityDesc
                encodedSecurityDescLen
                encodedSecurityDesc
                side
                orderQty
                cashOrderQty
                ordType
                price
                stopPx
                pegDifference
                discretionInst
                discretionOffset
                currency
                complianceID
                solicitedFlag
                timeInForce
                effectiveTime
                expireDate
                expireTime
                execInst
                rule80A
                lastShares
                lastPx
                lastSpotRate
                lastForwardPoints
                lastMkt
                tradingSessionID
                lastCapacity
                leavesQty
                cumQty
                avgPx
                dayOrderQty
                dayCumQty
                dayAvgPx
                gTBookingInst
                tradeDate
                transactTime
                reportToExch
                commission
                commType
                grossTradeAmt
                settlCurrAmt
                settlCurrency
                settlCurrFxRate
                settlCurrFxRateCalc
                handlInst
                minQty
                maxFloor
                openClose
                maxShow
                text
                encodedTextLen
                encodedText
                futSettDate2
                orderQty2
                clearingFirm
                clearingAccount
                multiLegReportingType
                legRefId
                uploadedToBackoffice
                fixMessage
                isAllocation
                groupUploadId
                processedAt
                createdDate
                createdAt
                updatedAt
                userOrderExecutionReportsId
                groupOrderExecutionReportsId
                __typename
              }
              nextToken
              __typename
            }
            cryptoOrder
            groupUploadOrderId
            reviewStatus
            createdAt
            updatedAt
            groupUpload {
              id
              name
              description
              orders {
                items {
                  id
                  groupUploadOrdersId
                  accountNumber
                  quantity
                  brokerOverride
                  commission
                  owner
                  userOrder {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  accountInformationId
                  failed
                  failedReason
                  orderIds
                  createdDate
                  createdAt
                  updatedAt
                  groupUploadOrderUserOrderId
                  __typename
                }
                nextToken
                __typename
              }
              owner
              isPlaced
              isPlacedString
              isAvgPx
              createdAt
              updatedAt
              __typename
            }
            accountInformationUserOrdersId
            userOrderGroupUploadId
            __typename
          }
          nextToken
          __typename
        }
        positions {
          items {
            id
            accountNumber
            owner
            underlying
            pricePaid
            isCryptoPosition
            quantity
            marginRequirement
            strategy
            positionLegs {
              side
              quantity
              ratioQuantity
              pricePaid
              legType
              cusip
              marginRequirement
              expiration
              strike
              __typename
            }
            subAccountNumber
            status
            groupUploadOrderId
            createdAt
            updatedAt
            accountInformationPositionsId
            __typename
          }
          nextToken
          __typename
        }
        subAccounts {
          items {
            id
            accountNumber
            owner
            subAccountName
            subAccountNumber
            selfDirected
            balance {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              accountType
              createdAt
              updatedAt
              __typename
            }
            transfers {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                toSubAccountNumber
                amount
                message
                deposit
                status
                cancel
                createdAt
                updatedAt
                subAccountTransfersId
                __typename
              }
              nextToken
              __typename
            }
            commissionCode
            repCode
            newsLetter {
              newsLetter
              portfolio
              __typename
            }
            stock {
              stockSignals
              maxDollarAllocationPerSignal
              maxNumberOfSharesPerSignal
              allOrNone
              roundLotsOnly
              multiplier
              __typename
            }
            option {
              optionSignals
              maxDollarAllocationPerSignal
              maxNumberOfContractsPerSignal
              allOrNone
              multiplier
              __typename
            }
            createdAt
            updatedAt
            accountInformationSubAccountsId
            subAccountBalanceId
            __typename
          }
          nextToken
          __typename
        }
        documentUpload {
          items {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            investigationId
            investigationNote
            submittedBy
            document {
              documentTag
              documentType
              s3uri
              __typename
            }
            approvedBy
            approvalStatus
            createdAt
            updatedAt
            accountInformationDocumentUploadId
            __typename
          }
          nextToken
          __typename
        }
        cryptoTransfer {
          items {
            id
            accountNumber
            owner
            blockchainHash
            clientTransactionId
            currency
            quantity
            receiveAddress {
              hotWalletAddress
              coin
              __typename
            }
            userWalletAddress {
              owner
              address
              nickname
              id
              createdAt
              updatedAt
              __typename
            }
            deposit
            status
            type
            version
            createdAt
            updatedAt
            accountInformationCryptoTransferId
            __typename
          }
          nextToken
          __typename
        }
        selectedWatchlist {
          items {
            id
            accountNumber
            owner
            watchListName
            selectedStocks
            createdAt
            updatedAt
            accountInformationSelectedWatchlistId
            __typename
          }
          nextToken
          __typename
        }
        notifications {
          items {
            id
            accountNumber
            owner
            notificationType
            message
            severity
            acknowledged
            star
            sent
            deleted
            toUser
            fromUser
            fromSystem
            ttl
            createdAt
            updatedAt
            accountInformationNotificationsId
            __typename
          }
          nextToken
          __typename
        }
        achRelationship {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          achRelationshipStatic {
            id
            accountNumber
            owner
            plaidProcessorToken
            plaidAccountId
            bankRoutingNumber
            bankAccount
            bankAccountOwnerName
            bankAccountType
            deleted
            approvalMethod
            relationshipId
            status
            statusCode
            statusJson
            createdAt
            updatedAt
            __typename
          }
          deleted
          nickname
          microDepositTries
          microDeposits
          microDepositStatus
          depositWithdrawalRequests {
            items {
              id
              accountNumber
              owner
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              relationshipId
              amount
              message
              memo
              reason
              iraContributionDistribution {
                contributionType
                applyToPriorYear
                distributionReason
                federalTaxWithholding {
                  valueType
                  value
                  __typename
                }
                stateTaxWithholding {
                  valueType
                  value
                  __typename
                }
                __typename
              }
              isFullDisbursement
              transferId
              deposit
              status
              cancel
              createdAt
              updatedAt
              achRelationshipDepositWithdrawalRequestsId
              __typename
            }
            nextToken
            __typename
          }
          reissueTries
          reissue
          createdAt
          updatedAt
          achRelationshipAchRelationshipStaticId
          achRelationshipAccountInformationId
          __typename
        }
        userProfileIds
        createdAt
        updatedAt
        userProfileAccountsId
        draftUserProfileAccountsId
        accountInformationBalanceId
        accountInformationPermissionsId
        accountInformationAchRelationshipId
        __typename
      }
      overnightBuyingPowerID
      firm
      totalEquity
      marginEquity
      marginRequirement
      marginExcessEquity
      cashEquity
      cashRequirement
      cashExcessEquity
      overnightBuyingPowerIssued
      dayTradeBuyingPowerIssued
      regTBuyingPowerIssued
      overnightFactorIssued
      dayTradeFactorIssued
      marginEquityPercent
      positionMarketValue
      longEquityMarketValue
      shortEquityMarketValue
      longOptionMarketValue
      shortOptionMarketValue
      totalTradeBalance
      totalSettleBalance
      cashTradeBalance
      marginTradeBalance
      shortTradeBalance
      cashSettleBalance
      marginSettleBalance
      shortSettleBalance
      moneyMarketSettleBalance
      moneyMarketTradeBalance
      freeCash
      sma
      availableToWithdraw
      optionsRequirement
      nonOptionsRequirement
      lastUpdate
      nonOptionsRequirementNotConcentrated
      typeIUnavailableCashProceeds
      typeIIUnavailableCashProceeds
      netBalance
      smaCommitted
      netLiquidity
      pendingDebitInterest
      pendingDebitDividends
      fullyPaidUnsettledFunds
      cashOnOrders
      buyingPowerOnOrders
      marginExcessEquitySod
      cashExcessEquitySod
      netBalanceSod
      optionBuyingPowerInternal
      stockBuyingPowerInternal
      updateFlag
      accountType
      pendingTransfers {
        deposit
        amount
        achDepositWithdrawalRequestId
        __typename
      }
      createdAt
      updatedAt
      balanceAccountInformationId
      __typename
    }
  }
`;
export const deleteBalance = /* GraphQL */ `
  mutation DeleteBalance(
    $input: DeleteBalanceInput!
    $condition: ModelBalanceConditionInput
  ) {
    deleteBalance(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      accountInformation {
        id
        primaryOwner
        owner
        accountNumber
        accountName
        accountType
        customerType
        accountRequestStatus
        investigationStatus
        apexId
        apexFdid
        apexCatAccountholderType
        apexJson
        accountStatus
        balance {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          overnightBuyingPowerID
          firm
          totalEquity
          marginEquity
          marginRequirement
          marginExcessEquity
          cashEquity
          cashRequirement
          cashExcessEquity
          overnightBuyingPowerIssued
          dayTradeBuyingPowerIssued
          regTBuyingPowerIssued
          overnightFactorIssued
          dayTradeFactorIssued
          marginEquityPercent
          positionMarketValue
          longEquityMarketValue
          shortEquityMarketValue
          longOptionMarketValue
          shortOptionMarketValue
          totalTradeBalance
          totalSettleBalance
          cashTradeBalance
          marginTradeBalance
          shortTradeBalance
          cashSettleBalance
          marginSettleBalance
          shortSettleBalance
          moneyMarketSettleBalance
          moneyMarketTradeBalance
          freeCash
          sma
          availableToWithdraw
          optionsRequirement
          nonOptionsRequirement
          lastUpdate
          nonOptionsRequirementNotConcentrated
          typeIUnavailableCashProceeds
          typeIIUnavailableCashProceeds
          netBalance
          smaCommitted
          netLiquidity
          pendingDebitInterest
          pendingDebitDividends
          fullyPaidUnsettledFunds
          cashOnOrders
          buyingPowerOnOrders
          marginExcessEquitySod
          cashExcessEquitySod
          netBalanceSod
          optionBuyingPowerInternal
          stockBuyingPowerInternal
          updateFlag
          accountType
          pendingTransfers {
            deposit
            amount
            achDepositWithdrawalRequestId
            __typename
          }
          createdAt
          updatedAt
          balanceAccountInformationId
          __typename
        }
        permissions {
          id
          accountNumber
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          owner
          systemAccess
          equityTrading
          optionsTrading
          cryptoTrading
          margin
          securitiesLending
          optionsLevel
          exitOnlyTrades
          restrictReason
          allowCancelOrder
          allowModifyOrder
          achWithdrawal
          patternDayTrader
          achApproval
          profileStatus
          betaFeatures
          achDeposit
          updatedBy
          createdAt
          updatedAt
          userPermissionsAccountInformationId
          __typename
        }
        userOrders {
          items {
            id
            accountNumber
            owner
            subAccountNumber
            cancel
            cancelReplace
            createdDate
            updatedDate
            commission
            feesAndCommission
            symbol
            side
            brokerSkipChecks
            brokerOverride
            brokerId
            quantity
            limitPrice
            stopPrice
            stockValue
            originalOrderId
            strategy
            avgPx
            orderType
            timeInForce
            instruction
            userOrderLegs {
              legType
              side
              quantity
              expiration
              strike
              openClose
              bid
              ask
              sharesPerContract
              avgPx
              __typename
            }
            cashSecured
            cashSecuredAmount
            message
            submitStatus
            status
            executionReports {
              items {
                id
                owner
                accountInformationId
                subAccountNumber
                orderID
                executionIncrementId
                secondaryOrderID
                clOrdID
                origClOrdID
                clientID
                execBroker
                listID
                execID
                execTransType
                execRefID
                execType
                ordStatus
                ordRejReason
                execRestatementReason
                account
                settlmntTyp
                futSettDate
                symbol
                symbolSfx
                securityID
                iDSource
                securityType
                maturityMonthYear
                maturityDay
                putOrCall
                strikePrice
                optAttribute
                contractMultiplier
                couponRate
                securityExchange
                issuer
                encodedIssuerLen
                encodedIssuer
                securityDesc
                encodedSecurityDescLen
                encodedSecurityDesc
                side
                orderQty
                cashOrderQty
                ordType
                price
                stopPx
                pegDifference
                discretionInst
                discretionOffset
                currency
                complianceID
                solicitedFlag
                timeInForce
                effectiveTime
                expireDate
                expireTime
                execInst
                rule80A
                lastShares
                lastPx
                lastSpotRate
                lastForwardPoints
                lastMkt
                tradingSessionID
                lastCapacity
                leavesQty
                cumQty
                avgPx
                dayOrderQty
                dayCumQty
                dayAvgPx
                gTBookingInst
                tradeDate
                transactTime
                reportToExch
                commission
                commType
                grossTradeAmt
                settlCurrAmt
                settlCurrency
                settlCurrFxRate
                settlCurrFxRateCalc
                handlInst
                minQty
                maxFloor
                openClose
                maxShow
                text
                encodedTextLen
                encodedText
                futSettDate2
                orderQty2
                clearingFirm
                clearingAccount
                multiLegReportingType
                legRefId
                uploadedToBackoffice
                fixMessage
                isAllocation
                groupUploadId
                processedAt
                createdDate
                createdAt
                updatedAt
                userOrderExecutionReportsId
                groupOrderExecutionReportsId
                __typename
              }
              nextToken
              __typename
            }
            cryptoOrder
            groupUploadOrderId
            reviewStatus
            createdAt
            updatedAt
            groupUpload {
              id
              name
              description
              orders {
                items {
                  id
                  groupUploadOrdersId
                  accountNumber
                  quantity
                  brokerOverride
                  commission
                  owner
                  userOrder {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  accountInformationId
                  failed
                  failedReason
                  orderIds
                  createdDate
                  createdAt
                  updatedAt
                  groupUploadOrderUserOrderId
                  __typename
                }
                nextToken
                __typename
              }
              owner
              isPlaced
              isPlacedString
              isAvgPx
              createdAt
              updatedAt
              __typename
            }
            accountInformationUserOrdersId
            userOrderGroupUploadId
            __typename
          }
          nextToken
          __typename
        }
        positions {
          items {
            id
            accountNumber
            owner
            underlying
            pricePaid
            isCryptoPosition
            quantity
            marginRequirement
            strategy
            positionLegs {
              side
              quantity
              ratioQuantity
              pricePaid
              legType
              cusip
              marginRequirement
              expiration
              strike
              __typename
            }
            subAccountNumber
            status
            groupUploadOrderId
            createdAt
            updatedAt
            accountInformationPositionsId
            __typename
          }
          nextToken
          __typename
        }
        subAccounts {
          items {
            id
            accountNumber
            owner
            subAccountName
            subAccountNumber
            selfDirected
            balance {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              accountType
              createdAt
              updatedAt
              __typename
            }
            transfers {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                toSubAccountNumber
                amount
                message
                deposit
                status
                cancel
                createdAt
                updatedAt
                subAccountTransfersId
                __typename
              }
              nextToken
              __typename
            }
            commissionCode
            repCode
            newsLetter {
              newsLetter
              portfolio
              __typename
            }
            stock {
              stockSignals
              maxDollarAllocationPerSignal
              maxNumberOfSharesPerSignal
              allOrNone
              roundLotsOnly
              multiplier
              __typename
            }
            option {
              optionSignals
              maxDollarAllocationPerSignal
              maxNumberOfContractsPerSignal
              allOrNone
              multiplier
              __typename
            }
            createdAt
            updatedAt
            accountInformationSubAccountsId
            subAccountBalanceId
            __typename
          }
          nextToken
          __typename
        }
        documentUpload {
          items {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            investigationId
            investigationNote
            submittedBy
            document {
              documentTag
              documentType
              s3uri
              __typename
            }
            approvedBy
            approvalStatus
            createdAt
            updatedAt
            accountInformationDocumentUploadId
            __typename
          }
          nextToken
          __typename
        }
        cryptoTransfer {
          items {
            id
            accountNumber
            owner
            blockchainHash
            clientTransactionId
            currency
            quantity
            receiveAddress {
              hotWalletAddress
              coin
              __typename
            }
            userWalletAddress {
              owner
              address
              nickname
              id
              createdAt
              updatedAt
              __typename
            }
            deposit
            status
            type
            version
            createdAt
            updatedAt
            accountInformationCryptoTransferId
            __typename
          }
          nextToken
          __typename
        }
        selectedWatchlist {
          items {
            id
            accountNumber
            owner
            watchListName
            selectedStocks
            createdAt
            updatedAt
            accountInformationSelectedWatchlistId
            __typename
          }
          nextToken
          __typename
        }
        notifications {
          items {
            id
            accountNumber
            owner
            notificationType
            message
            severity
            acknowledged
            star
            sent
            deleted
            toUser
            fromUser
            fromSystem
            ttl
            createdAt
            updatedAt
            accountInformationNotificationsId
            __typename
          }
          nextToken
          __typename
        }
        achRelationship {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          achRelationshipStatic {
            id
            accountNumber
            owner
            plaidProcessorToken
            plaidAccountId
            bankRoutingNumber
            bankAccount
            bankAccountOwnerName
            bankAccountType
            deleted
            approvalMethod
            relationshipId
            status
            statusCode
            statusJson
            createdAt
            updatedAt
            __typename
          }
          deleted
          nickname
          microDepositTries
          microDeposits
          microDepositStatus
          depositWithdrawalRequests {
            items {
              id
              accountNumber
              owner
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              relationshipId
              amount
              message
              memo
              reason
              iraContributionDistribution {
                contributionType
                applyToPriorYear
                distributionReason
                federalTaxWithholding {
                  valueType
                  value
                  __typename
                }
                stateTaxWithholding {
                  valueType
                  value
                  __typename
                }
                __typename
              }
              isFullDisbursement
              transferId
              deposit
              status
              cancel
              createdAt
              updatedAt
              achRelationshipDepositWithdrawalRequestsId
              __typename
            }
            nextToken
            __typename
          }
          reissueTries
          reissue
          createdAt
          updatedAt
          achRelationshipAchRelationshipStaticId
          achRelationshipAccountInformationId
          __typename
        }
        userProfileIds
        createdAt
        updatedAt
        userProfileAccountsId
        draftUserProfileAccountsId
        accountInformationBalanceId
        accountInformationPermissionsId
        accountInformationAchRelationshipId
        __typename
      }
      overnightBuyingPowerID
      firm
      totalEquity
      marginEquity
      marginRequirement
      marginExcessEquity
      cashEquity
      cashRequirement
      cashExcessEquity
      overnightBuyingPowerIssued
      dayTradeBuyingPowerIssued
      regTBuyingPowerIssued
      overnightFactorIssued
      dayTradeFactorIssued
      marginEquityPercent
      positionMarketValue
      longEquityMarketValue
      shortEquityMarketValue
      longOptionMarketValue
      shortOptionMarketValue
      totalTradeBalance
      totalSettleBalance
      cashTradeBalance
      marginTradeBalance
      shortTradeBalance
      cashSettleBalance
      marginSettleBalance
      shortSettleBalance
      moneyMarketSettleBalance
      moneyMarketTradeBalance
      freeCash
      sma
      availableToWithdraw
      optionsRequirement
      nonOptionsRequirement
      lastUpdate
      nonOptionsRequirementNotConcentrated
      typeIUnavailableCashProceeds
      typeIIUnavailableCashProceeds
      netBalance
      smaCommitted
      netLiquidity
      pendingDebitInterest
      pendingDebitDividends
      fullyPaidUnsettledFunds
      cashOnOrders
      buyingPowerOnOrders
      marginExcessEquitySod
      cashExcessEquitySod
      netBalanceSod
      optionBuyingPowerInternal
      stockBuyingPowerInternal
      updateFlag
      accountType
      pendingTransfers {
        deposit
        amount
        achDepositWithdrawalRequestId
        __typename
      }
      createdAt
      updatedAt
      balanceAccountInformationId
      __typename
    }
  }
`;
export const createPositionSod = /* GraphQL */ `
  mutation CreatePositionSod(
    $input: CreatePositionSodInput!
    $condition: ModelPositionSodConditionInput
  ) {
    createPositionSod(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      processDate
      officeCode
      registeredRepCode
      accountType
      symbol
      cusip
      tradeQuantity
      settleQuantity
      securityTypeCode
      description
      marginEligibleCode
      closingPrice
      conversionFactor
      underlyingCusip
      optionSymbolRoot
      optionContractDate
      strikePrice
      callPut
      expirationDeliveryDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePositionSod = /* GraphQL */ `
  mutation UpdatePositionSod(
    $input: UpdatePositionSodInput!
    $condition: ModelPositionSodConditionInput
  ) {
    updatePositionSod(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      processDate
      officeCode
      registeredRepCode
      accountType
      symbol
      cusip
      tradeQuantity
      settleQuantity
      securityTypeCode
      description
      marginEligibleCode
      closingPrice
      conversionFactor
      underlyingCusip
      optionSymbolRoot
      optionContractDate
      strikePrice
      callPut
      expirationDeliveryDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePositionSod = /* GraphQL */ `
  mutation DeletePositionSod(
    $input: DeletePositionSodInput!
    $condition: ModelPositionSodConditionInput
  ) {
    deletePositionSod(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      processDate
      officeCode
      registeredRepCode
      accountType
      symbol
      cusip
      tradeQuantity
      settleQuantity
      securityTypeCode
      description
      marginEligibleCode
      closingPrice
      conversionFactor
      underlyingCusip
      optionSymbolRoot
      optionContractDate
      strikePrice
      callPut
      expirationDeliveryDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPosition = /* GraphQL */ `
  mutation CreatePosition(
    $input: CreatePositionInput!
    $condition: ModelPositionConditionInput
  ) {
    createPosition(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      underlying
      pricePaid
      isCryptoPosition
      quantity
      marginRequirement
      strategy
      positionLegs {
        side
        quantity
        ratioQuantity
        pricePaid
        legType
        cusip
        marginRequirement
        expiration
        strike
        __typename
      }
      subAccountNumber
      status
      groupUploadOrderId
      createdAt
      updatedAt
      accountInformationPositionsId
      __typename
    }
  }
`;
export const updatePosition = /* GraphQL */ `
  mutation UpdatePosition(
    $input: UpdatePositionInput!
    $condition: ModelPositionConditionInput
  ) {
    updatePosition(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      underlying
      pricePaid
      isCryptoPosition
      quantity
      marginRequirement
      strategy
      positionLegs {
        side
        quantity
        ratioQuantity
        pricePaid
        legType
        cusip
        marginRequirement
        expiration
        strike
        __typename
      }
      subAccountNumber
      status
      groupUploadOrderId
      createdAt
      updatedAt
      accountInformationPositionsId
      __typename
    }
  }
`;
export const deletePosition = /* GraphQL */ `
  mutation DeletePosition(
    $input: DeletePositionInput!
    $condition: ModelPositionConditionInput
  ) {
    deletePosition(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      underlying
      pricePaid
      isCryptoPosition
      quantity
      marginRequirement
      strategy
      positionLegs {
        side
        quantity
        ratioQuantity
        pricePaid
        legType
        cusip
        marginRequirement
        expiration
        strike
        __typename
      }
      subAccountNumber
      status
      groupUploadOrderId
      createdAt
      updatedAt
      accountInformationPositionsId
      __typename
    }
  }
`;
export const createSubAccount = /* GraphQL */ `
  mutation CreateSubAccount(
    $input: CreateSubAccountInput!
    $condition: ModelSubAccountConditionInput
  ) {
    createSubAccount(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      subAccountName
      subAccountNumber
      selfDirected
      balance {
        id
        accountNumber
        owner
        subAccountName
        subAccountNumber
        overnightBuyingPowerID
        firm
        totalEquity
        marginEquity
        marginRequirement
        marginExcessEquity
        cashEquity
        cashRequirement
        cashExcessEquity
        overnightBuyingPowerIssued
        dayTradeBuyingPowerIssued
        regTBuyingPowerIssued
        overnightFactorIssued
        dayTradeFactorIssued
        marginEquityPercent
        positionMarketValue
        longEquityMarketValue
        shortEquityMarketValue
        longOptionMarketValue
        shortOptionMarketValue
        totalTradeBalance
        totalSettleBalance
        cashTradeBalance
        marginTradeBalance
        shortTradeBalance
        cashSettleBalance
        marginSettleBalance
        shortSettleBalance
        moneyMarketSettleBalance
        moneyMarketTradeBalance
        freeCash
        sma
        availableToWithdraw
        optionsRequirement
        nonOptionsRequirement
        lastUpdate
        nonOptionsRequirementNotConcentrated
        typeIUnavailableCashProceeds
        typeIIUnavailableCashProceeds
        netBalance
        smaCommitted
        netLiquidity
        pendingDebitInterest
        pendingDebitDividends
        fullyPaidUnsettledFunds
        cashOnOrders
        buyingPowerOnOrders
        marginExcessEquitySod
        cashExcessEquitySod
        netBalanceSod
        optionBuyingPowerInternal
        stockBuyingPowerInternal
        accountType
        createdAt
        updatedAt
        __typename
      }
      transfers {
        items {
          id
          accountNumber
          owner
          subAccountNumber
          toSubAccountNumber
          amount
          message
          deposit
          status
          cancel
          createdAt
          updatedAt
          subAccountTransfersId
          __typename
        }
        nextToken
        __typename
      }
      commissionCode
      repCode
      newsLetter {
        newsLetter
        portfolio
        __typename
      }
      stock {
        stockSignals
        maxDollarAllocationPerSignal
        maxNumberOfSharesPerSignal
        allOrNone
        roundLotsOnly
        multiplier
        __typename
      }
      option {
        optionSignals
        maxDollarAllocationPerSignal
        maxNumberOfContractsPerSignal
        allOrNone
        multiplier
        __typename
      }
      createdAt
      updatedAt
      accountInformationSubAccountsId
      subAccountBalanceId
      __typename
    }
  }
`;
export const updateSubAccount = /* GraphQL */ `
  mutation UpdateSubAccount(
    $input: UpdateSubAccountInput!
    $condition: ModelSubAccountConditionInput
  ) {
    updateSubAccount(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      subAccountName
      subAccountNumber
      selfDirected
      balance {
        id
        accountNumber
        owner
        subAccountName
        subAccountNumber
        overnightBuyingPowerID
        firm
        totalEquity
        marginEquity
        marginRequirement
        marginExcessEquity
        cashEquity
        cashRequirement
        cashExcessEquity
        overnightBuyingPowerIssued
        dayTradeBuyingPowerIssued
        regTBuyingPowerIssued
        overnightFactorIssued
        dayTradeFactorIssued
        marginEquityPercent
        positionMarketValue
        longEquityMarketValue
        shortEquityMarketValue
        longOptionMarketValue
        shortOptionMarketValue
        totalTradeBalance
        totalSettleBalance
        cashTradeBalance
        marginTradeBalance
        shortTradeBalance
        cashSettleBalance
        marginSettleBalance
        shortSettleBalance
        moneyMarketSettleBalance
        moneyMarketTradeBalance
        freeCash
        sma
        availableToWithdraw
        optionsRequirement
        nonOptionsRequirement
        lastUpdate
        nonOptionsRequirementNotConcentrated
        typeIUnavailableCashProceeds
        typeIIUnavailableCashProceeds
        netBalance
        smaCommitted
        netLiquidity
        pendingDebitInterest
        pendingDebitDividends
        fullyPaidUnsettledFunds
        cashOnOrders
        buyingPowerOnOrders
        marginExcessEquitySod
        cashExcessEquitySod
        netBalanceSod
        optionBuyingPowerInternal
        stockBuyingPowerInternal
        accountType
        createdAt
        updatedAt
        __typename
      }
      transfers {
        items {
          id
          accountNumber
          owner
          subAccountNumber
          toSubAccountNumber
          amount
          message
          deposit
          status
          cancel
          createdAt
          updatedAt
          subAccountTransfersId
          __typename
        }
        nextToken
        __typename
      }
      commissionCode
      repCode
      newsLetter {
        newsLetter
        portfolio
        __typename
      }
      stock {
        stockSignals
        maxDollarAllocationPerSignal
        maxNumberOfSharesPerSignal
        allOrNone
        roundLotsOnly
        multiplier
        __typename
      }
      option {
        optionSignals
        maxDollarAllocationPerSignal
        maxNumberOfContractsPerSignal
        allOrNone
        multiplier
        __typename
      }
      createdAt
      updatedAt
      accountInformationSubAccountsId
      subAccountBalanceId
      __typename
    }
  }
`;
export const deleteSubAccount = /* GraphQL */ `
  mutation DeleteSubAccount(
    $input: DeleteSubAccountInput!
    $condition: ModelSubAccountConditionInput
  ) {
    deleteSubAccount(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      subAccountName
      subAccountNumber
      selfDirected
      balance {
        id
        accountNumber
        owner
        subAccountName
        subAccountNumber
        overnightBuyingPowerID
        firm
        totalEquity
        marginEquity
        marginRequirement
        marginExcessEquity
        cashEquity
        cashRequirement
        cashExcessEquity
        overnightBuyingPowerIssued
        dayTradeBuyingPowerIssued
        regTBuyingPowerIssued
        overnightFactorIssued
        dayTradeFactorIssued
        marginEquityPercent
        positionMarketValue
        longEquityMarketValue
        shortEquityMarketValue
        longOptionMarketValue
        shortOptionMarketValue
        totalTradeBalance
        totalSettleBalance
        cashTradeBalance
        marginTradeBalance
        shortTradeBalance
        cashSettleBalance
        marginSettleBalance
        shortSettleBalance
        moneyMarketSettleBalance
        moneyMarketTradeBalance
        freeCash
        sma
        availableToWithdraw
        optionsRequirement
        nonOptionsRequirement
        lastUpdate
        nonOptionsRequirementNotConcentrated
        typeIUnavailableCashProceeds
        typeIIUnavailableCashProceeds
        netBalance
        smaCommitted
        netLiquidity
        pendingDebitInterest
        pendingDebitDividends
        fullyPaidUnsettledFunds
        cashOnOrders
        buyingPowerOnOrders
        marginExcessEquitySod
        cashExcessEquitySod
        netBalanceSod
        optionBuyingPowerInternal
        stockBuyingPowerInternal
        accountType
        createdAt
        updatedAt
        __typename
      }
      transfers {
        items {
          id
          accountNumber
          owner
          subAccountNumber
          toSubAccountNumber
          amount
          message
          deposit
          status
          cancel
          createdAt
          updatedAt
          subAccountTransfersId
          __typename
        }
        nextToken
        __typename
      }
      commissionCode
      repCode
      newsLetter {
        newsLetter
        portfolio
        __typename
      }
      stock {
        stockSignals
        maxDollarAllocationPerSignal
        maxNumberOfSharesPerSignal
        allOrNone
        roundLotsOnly
        multiplier
        __typename
      }
      option {
        optionSignals
        maxDollarAllocationPerSignal
        maxNumberOfContractsPerSignal
        allOrNone
        multiplier
        __typename
      }
      createdAt
      updatedAt
      accountInformationSubAccountsId
      subAccountBalanceId
      __typename
    }
  }
`;
export const createSubAccountTransfer = /* GraphQL */ `
  mutation CreateSubAccountTransfer(
    $input: CreateSubAccountTransferInput!
    $condition: ModelSubAccountTransferConditionInput
  ) {
    createSubAccountTransfer(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      subAccountNumber
      toSubAccountNumber
      amount
      message
      deposit
      status
      cancel
      createdAt
      updatedAt
      subAccountTransfersId
      __typename
    }
  }
`;
export const updateSubAccountTransfer = /* GraphQL */ `
  mutation UpdateSubAccountTransfer(
    $input: UpdateSubAccountTransferInput!
    $condition: ModelSubAccountTransferConditionInput
  ) {
    updateSubAccountTransfer(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      subAccountNumber
      toSubAccountNumber
      amount
      message
      deposit
      status
      cancel
      createdAt
      updatedAt
      subAccountTransfersId
      __typename
    }
  }
`;
export const deleteSubAccountTransfer = /* GraphQL */ `
  mutation DeleteSubAccountTransfer(
    $input: DeleteSubAccountTransferInput!
    $condition: ModelSubAccountTransferConditionInput
  ) {
    deleteSubAccountTransfer(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      subAccountNumber
      toSubAccountNumber
      amount
      message
      deposit
      status
      cancel
      createdAt
      updatedAt
      subAccountTransfersId
      __typename
    }
  }
`;
export const createSubAccountBalance = /* GraphQL */ `
  mutation CreateSubAccountBalance(
    $input: CreateSubAccountBalanceInput!
    $condition: ModelSubAccountBalanceConditionInput
  ) {
    createSubAccountBalance(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      subAccountName
      subAccountNumber
      overnightBuyingPowerID
      firm
      totalEquity
      marginEquity
      marginRequirement
      marginExcessEquity
      cashEquity
      cashRequirement
      cashExcessEquity
      overnightBuyingPowerIssued
      dayTradeBuyingPowerIssued
      regTBuyingPowerIssued
      overnightFactorIssued
      dayTradeFactorIssued
      marginEquityPercent
      positionMarketValue
      longEquityMarketValue
      shortEquityMarketValue
      longOptionMarketValue
      shortOptionMarketValue
      totalTradeBalance
      totalSettleBalance
      cashTradeBalance
      marginTradeBalance
      shortTradeBalance
      cashSettleBalance
      marginSettleBalance
      shortSettleBalance
      moneyMarketSettleBalance
      moneyMarketTradeBalance
      freeCash
      sma
      availableToWithdraw
      optionsRequirement
      nonOptionsRequirement
      lastUpdate
      nonOptionsRequirementNotConcentrated
      typeIUnavailableCashProceeds
      typeIIUnavailableCashProceeds
      netBalance
      smaCommitted
      netLiquidity
      pendingDebitInterest
      pendingDebitDividends
      fullyPaidUnsettledFunds
      cashOnOrders
      buyingPowerOnOrders
      marginExcessEquitySod
      cashExcessEquitySod
      netBalanceSod
      optionBuyingPowerInternal
      stockBuyingPowerInternal
      accountType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSubAccountBalance = /* GraphQL */ `
  mutation UpdateSubAccountBalance(
    $input: UpdateSubAccountBalanceInput!
    $condition: ModelSubAccountBalanceConditionInput
  ) {
    updateSubAccountBalance(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      subAccountName
      subAccountNumber
      overnightBuyingPowerID
      firm
      totalEquity
      marginEquity
      marginRequirement
      marginExcessEquity
      cashEquity
      cashRequirement
      cashExcessEquity
      overnightBuyingPowerIssued
      dayTradeBuyingPowerIssued
      regTBuyingPowerIssued
      overnightFactorIssued
      dayTradeFactorIssued
      marginEquityPercent
      positionMarketValue
      longEquityMarketValue
      shortEquityMarketValue
      longOptionMarketValue
      shortOptionMarketValue
      totalTradeBalance
      totalSettleBalance
      cashTradeBalance
      marginTradeBalance
      shortTradeBalance
      cashSettleBalance
      marginSettleBalance
      shortSettleBalance
      moneyMarketSettleBalance
      moneyMarketTradeBalance
      freeCash
      sma
      availableToWithdraw
      optionsRequirement
      nonOptionsRequirement
      lastUpdate
      nonOptionsRequirementNotConcentrated
      typeIUnavailableCashProceeds
      typeIIUnavailableCashProceeds
      netBalance
      smaCommitted
      netLiquidity
      pendingDebitInterest
      pendingDebitDividends
      fullyPaidUnsettledFunds
      cashOnOrders
      buyingPowerOnOrders
      marginExcessEquitySod
      cashExcessEquitySod
      netBalanceSod
      optionBuyingPowerInternal
      stockBuyingPowerInternal
      accountType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSubAccountBalance = /* GraphQL */ `
  mutation DeleteSubAccountBalance(
    $input: DeleteSubAccountBalanceInput!
    $condition: ModelSubAccountBalanceConditionInput
  ) {
    deleteSubAccountBalance(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      subAccountName
      subAccountNumber
      overnightBuyingPowerID
      firm
      totalEquity
      marginEquity
      marginRequirement
      marginExcessEquity
      cashEquity
      cashRequirement
      cashExcessEquity
      overnightBuyingPowerIssued
      dayTradeBuyingPowerIssued
      regTBuyingPowerIssued
      overnightFactorIssued
      dayTradeFactorIssued
      marginEquityPercent
      positionMarketValue
      longEquityMarketValue
      shortEquityMarketValue
      longOptionMarketValue
      shortOptionMarketValue
      totalTradeBalance
      totalSettleBalance
      cashTradeBalance
      marginTradeBalance
      shortTradeBalance
      cashSettleBalance
      marginSettleBalance
      shortSettleBalance
      moneyMarketSettleBalance
      moneyMarketTradeBalance
      freeCash
      sma
      availableToWithdraw
      optionsRequirement
      nonOptionsRequirement
      lastUpdate
      nonOptionsRequirementNotConcentrated
      typeIUnavailableCashProceeds
      typeIIUnavailableCashProceeds
      netBalance
      smaCommitted
      netLiquidity
      pendingDebitInterest
      pendingDebitDividends
      fullyPaidUnsettledFunds
      cashOnOrders
      buyingPowerOnOrders
      marginExcessEquitySod
      cashExcessEquitySod
      netBalanceSod
      optionBuyingPowerInternal
      stockBuyingPowerInternal
      accountType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUserPermissions = /* GraphQL */ `
  mutation CreateUserPermissions(
    $input: CreateUserPermissionsInput!
    $condition: ModelUserPermissionsConditionInput
  ) {
    createUserPermissions(input: $input, condition: $condition) {
      id
      accountNumber
      accountInformation {
        id
        primaryOwner
        owner
        accountNumber
        accountName
        accountType
        customerType
        accountRequestStatus
        investigationStatus
        apexId
        apexFdid
        apexCatAccountholderType
        apexJson
        accountStatus
        balance {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          overnightBuyingPowerID
          firm
          totalEquity
          marginEquity
          marginRequirement
          marginExcessEquity
          cashEquity
          cashRequirement
          cashExcessEquity
          overnightBuyingPowerIssued
          dayTradeBuyingPowerIssued
          regTBuyingPowerIssued
          overnightFactorIssued
          dayTradeFactorIssued
          marginEquityPercent
          positionMarketValue
          longEquityMarketValue
          shortEquityMarketValue
          longOptionMarketValue
          shortOptionMarketValue
          totalTradeBalance
          totalSettleBalance
          cashTradeBalance
          marginTradeBalance
          shortTradeBalance
          cashSettleBalance
          marginSettleBalance
          shortSettleBalance
          moneyMarketSettleBalance
          moneyMarketTradeBalance
          freeCash
          sma
          availableToWithdraw
          optionsRequirement
          nonOptionsRequirement
          lastUpdate
          nonOptionsRequirementNotConcentrated
          typeIUnavailableCashProceeds
          typeIIUnavailableCashProceeds
          netBalance
          smaCommitted
          netLiquidity
          pendingDebitInterest
          pendingDebitDividends
          fullyPaidUnsettledFunds
          cashOnOrders
          buyingPowerOnOrders
          marginExcessEquitySod
          cashExcessEquitySod
          netBalanceSod
          optionBuyingPowerInternal
          stockBuyingPowerInternal
          updateFlag
          accountType
          pendingTransfers {
            deposit
            amount
            achDepositWithdrawalRequestId
            __typename
          }
          createdAt
          updatedAt
          balanceAccountInformationId
          __typename
        }
        permissions {
          id
          accountNumber
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          owner
          systemAccess
          equityTrading
          optionsTrading
          cryptoTrading
          margin
          securitiesLending
          optionsLevel
          exitOnlyTrades
          restrictReason
          allowCancelOrder
          allowModifyOrder
          achWithdrawal
          patternDayTrader
          achApproval
          profileStatus
          betaFeatures
          achDeposit
          updatedBy
          createdAt
          updatedAt
          userPermissionsAccountInformationId
          __typename
        }
        userOrders {
          items {
            id
            accountNumber
            owner
            subAccountNumber
            cancel
            cancelReplace
            createdDate
            updatedDate
            commission
            feesAndCommission
            symbol
            side
            brokerSkipChecks
            brokerOverride
            brokerId
            quantity
            limitPrice
            stopPrice
            stockValue
            originalOrderId
            strategy
            avgPx
            orderType
            timeInForce
            instruction
            userOrderLegs {
              legType
              side
              quantity
              expiration
              strike
              openClose
              bid
              ask
              sharesPerContract
              avgPx
              __typename
            }
            cashSecured
            cashSecuredAmount
            message
            submitStatus
            status
            executionReports {
              items {
                id
                owner
                accountInformationId
                subAccountNumber
                orderID
                executionIncrementId
                secondaryOrderID
                clOrdID
                origClOrdID
                clientID
                execBroker
                listID
                execID
                execTransType
                execRefID
                execType
                ordStatus
                ordRejReason
                execRestatementReason
                account
                settlmntTyp
                futSettDate
                symbol
                symbolSfx
                securityID
                iDSource
                securityType
                maturityMonthYear
                maturityDay
                putOrCall
                strikePrice
                optAttribute
                contractMultiplier
                couponRate
                securityExchange
                issuer
                encodedIssuerLen
                encodedIssuer
                securityDesc
                encodedSecurityDescLen
                encodedSecurityDesc
                side
                orderQty
                cashOrderQty
                ordType
                price
                stopPx
                pegDifference
                discretionInst
                discretionOffset
                currency
                complianceID
                solicitedFlag
                timeInForce
                effectiveTime
                expireDate
                expireTime
                execInst
                rule80A
                lastShares
                lastPx
                lastSpotRate
                lastForwardPoints
                lastMkt
                tradingSessionID
                lastCapacity
                leavesQty
                cumQty
                avgPx
                dayOrderQty
                dayCumQty
                dayAvgPx
                gTBookingInst
                tradeDate
                transactTime
                reportToExch
                commission
                commType
                grossTradeAmt
                settlCurrAmt
                settlCurrency
                settlCurrFxRate
                settlCurrFxRateCalc
                handlInst
                minQty
                maxFloor
                openClose
                maxShow
                text
                encodedTextLen
                encodedText
                futSettDate2
                orderQty2
                clearingFirm
                clearingAccount
                multiLegReportingType
                legRefId
                uploadedToBackoffice
                fixMessage
                isAllocation
                groupUploadId
                processedAt
                createdDate
                createdAt
                updatedAt
                userOrderExecutionReportsId
                groupOrderExecutionReportsId
                __typename
              }
              nextToken
              __typename
            }
            cryptoOrder
            groupUploadOrderId
            reviewStatus
            createdAt
            updatedAt
            groupUpload {
              id
              name
              description
              orders {
                items {
                  id
                  groupUploadOrdersId
                  accountNumber
                  quantity
                  brokerOverride
                  commission
                  owner
                  userOrder {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  accountInformationId
                  failed
                  failedReason
                  orderIds
                  createdDate
                  createdAt
                  updatedAt
                  groupUploadOrderUserOrderId
                  __typename
                }
                nextToken
                __typename
              }
              owner
              isPlaced
              isPlacedString
              isAvgPx
              createdAt
              updatedAt
              __typename
            }
            accountInformationUserOrdersId
            userOrderGroupUploadId
            __typename
          }
          nextToken
          __typename
        }
        positions {
          items {
            id
            accountNumber
            owner
            underlying
            pricePaid
            isCryptoPosition
            quantity
            marginRequirement
            strategy
            positionLegs {
              side
              quantity
              ratioQuantity
              pricePaid
              legType
              cusip
              marginRequirement
              expiration
              strike
              __typename
            }
            subAccountNumber
            status
            groupUploadOrderId
            createdAt
            updatedAt
            accountInformationPositionsId
            __typename
          }
          nextToken
          __typename
        }
        subAccounts {
          items {
            id
            accountNumber
            owner
            subAccountName
            subAccountNumber
            selfDirected
            balance {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              accountType
              createdAt
              updatedAt
              __typename
            }
            transfers {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                toSubAccountNumber
                amount
                message
                deposit
                status
                cancel
                createdAt
                updatedAt
                subAccountTransfersId
                __typename
              }
              nextToken
              __typename
            }
            commissionCode
            repCode
            newsLetter {
              newsLetter
              portfolio
              __typename
            }
            stock {
              stockSignals
              maxDollarAllocationPerSignal
              maxNumberOfSharesPerSignal
              allOrNone
              roundLotsOnly
              multiplier
              __typename
            }
            option {
              optionSignals
              maxDollarAllocationPerSignal
              maxNumberOfContractsPerSignal
              allOrNone
              multiplier
              __typename
            }
            createdAt
            updatedAt
            accountInformationSubAccountsId
            subAccountBalanceId
            __typename
          }
          nextToken
          __typename
        }
        documentUpload {
          items {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            investigationId
            investigationNote
            submittedBy
            document {
              documentTag
              documentType
              s3uri
              __typename
            }
            approvedBy
            approvalStatus
            createdAt
            updatedAt
            accountInformationDocumentUploadId
            __typename
          }
          nextToken
          __typename
        }
        cryptoTransfer {
          items {
            id
            accountNumber
            owner
            blockchainHash
            clientTransactionId
            currency
            quantity
            receiveAddress {
              hotWalletAddress
              coin
              __typename
            }
            userWalletAddress {
              owner
              address
              nickname
              id
              createdAt
              updatedAt
              __typename
            }
            deposit
            status
            type
            version
            createdAt
            updatedAt
            accountInformationCryptoTransferId
            __typename
          }
          nextToken
          __typename
        }
        selectedWatchlist {
          items {
            id
            accountNumber
            owner
            watchListName
            selectedStocks
            createdAt
            updatedAt
            accountInformationSelectedWatchlistId
            __typename
          }
          nextToken
          __typename
        }
        notifications {
          items {
            id
            accountNumber
            owner
            notificationType
            message
            severity
            acknowledged
            star
            sent
            deleted
            toUser
            fromUser
            fromSystem
            ttl
            createdAt
            updatedAt
            accountInformationNotificationsId
            __typename
          }
          nextToken
          __typename
        }
        achRelationship {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          achRelationshipStatic {
            id
            accountNumber
            owner
            plaidProcessorToken
            plaidAccountId
            bankRoutingNumber
            bankAccount
            bankAccountOwnerName
            bankAccountType
            deleted
            approvalMethod
            relationshipId
            status
            statusCode
            statusJson
            createdAt
            updatedAt
            __typename
          }
          deleted
          nickname
          microDepositTries
          microDeposits
          microDepositStatus
          depositWithdrawalRequests {
            items {
              id
              accountNumber
              owner
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              relationshipId
              amount
              message
              memo
              reason
              iraContributionDistribution {
                contributionType
                applyToPriorYear
                distributionReason
                federalTaxWithholding {
                  valueType
                  value
                  __typename
                }
                stateTaxWithholding {
                  valueType
                  value
                  __typename
                }
                __typename
              }
              isFullDisbursement
              transferId
              deposit
              status
              cancel
              createdAt
              updatedAt
              achRelationshipDepositWithdrawalRequestsId
              __typename
            }
            nextToken
            __typename
          }
          reissueTries
          reissue
          createdAt
          updatedAt
          achRelationshipAchRelationshipStaticId
          achRelationshipAccountInformationId
          __typename
        }
        userProfileIds
        createdAt
        updatedAt
        userProfileAccountsId
        draftUserProfileAccountsId
        accountInformationBalanceId
        accountInformationPermissionsId
        accountInformationAchRelationshipId
        __typename
      }
      owner
      systemAccess
      equityTrading
      optionsTrading
      cryptoTrading
      margin
      securitiesLending
      optionsLevel
      exitOnlyTrades
      restrictReason
      allowCancelOrder
      allowModifyOrder
      achWithdrawal
      patternDayTrader
      achApproval
      profileStatus
      betaFeatures
      achDeposit
      updatedBy
      createdAt
      updatedAt
      userPermissionsAccountInformationId
      __typename
    }
  }
`;
export const updateUserPermissions = /* GraphQL */ `
  mutation UpdateUserPermissions(
    $input: UpdateUserPermissionsInput!
    $condition: ModelUserPermissionsConditionInput
  ) {
    updateUserPermissions(input: $input, condition: $condition) {
      id
      accountNumber
      accountInformation {
        id
        primaryOwner
        owner
        accountNumber
        accountName
        accountType
        customerType
        accountRequestStatus
        investigationStatus
        apexId
        apexFdid
        apexCatAccountholderType
        apexJson
        accountStatus
        balance {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          overnightBuyingPowerID
          firm
          totalEquity
          marginEquity
          marginRequirement
          marginExcessEquity
          cashEquity
          cashRequirement
          cashExcessEquity
          overnightBuyingPowerIssued
          dayTradeBuyingPowerIssued
          regTBuyingPowerIssued
          overnightFactorIssued
          dayTradeFactorIssued
          marginEquityPercent
          positionMarketValue
          longEquityMarketValue
          shortEquityMarketValue
          longOptionMarketValue
          shortOptionMarketValue
          totalTradeBalance
          totalSettleBalance
          cashTradeBalance
          marginTradeBalance
          shortTradeBalance
          cashSettleBalance
          marginSettleBalance
          shortSettleBalance
          moneyMarketSettleBalance
          moneyMarketTradeBalance
          freeCash
          sma
          availableToWithdraw
          optionsRequirement
          nonOptionsRequirement
          lastUpdate
          nonOptionsRequirementNotConcentrated
          typeIUnavailableCashProceeds
          typeIIUnavailableCashProceeds
          netBalance
          smaCommitted
          netLiquidity
          pendingDebitInterest
          pendingDebitDividends
          fullyPaidUnsettledFunds
          cashOnOrders
          buyingPowerOnOrders
          marginExcessEquitySod
          cashExcessEquitySod
          netBalanceSod
          optionBuyingPowerInternal
          stockBuyingPowerInternal
          updateFlag
          accountType
          pendingTransfers {
            deposit
            amount
            achDepositWithdrawalRequestId
            __typename
          }
          createdAt
          updatedAt
          balanceAccountInformationId
          __typename
        }
        permissions {
          id
          accountNumber
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          owner
          systemAccess
          equityTrading
          optionsTrading
          cryptoTrading
          margin
          securitiesLending
          optionsLevel
          exitOnlyTrades
          restrictReason
          allowCancelOrder
          allowModifyOrder
          achWithdrawal
          patternDayTrader
          achApproval
          profileStatus
          betaFeatures
          achDeposit
          updatedBy
          createdAt
          updatedAt
          userPermissionsAccountInformationId
          __typename
        }
        userOrders {
          items {
            id
            accountNumber
            owner
            subAccountNumber
            cancel
            cancelReplace
            createdDate
            updatedDate
            commission
            feesAndCommission
            symbol
            side
            brokerSkipChecks
            brokerOverride
            brokerId
            quantity
            limitPrice
            stopPrice
            stockValue
            originalOrderId
            strategy
            avgPx
            orderType
            timeInForce
            instruction
            userOrderLegs {
              legType
              side
              quantity
              expiration
              strike
              openClose
              bid
              ask
              sharesPerContract
              avgPx
              __typename
            }
            cashSecured
            cashSecuredAmount
            message
            submitStatus
            status
            executionReports {
              items {
                id
                owner
                accountInformationId
                subAccountNumber
                orderID
                executionIncrementId
                secondaryOrderID
                clOrdID
                origClOrdID
                clientID
                execBroker
                listID
                execID
                execTransType
                execRefID
                execType
                ordStatus
                ordRejReason
                execRestatementReason
                account
                settlmntTyp
                futSettDate
                symbol
                symbolSfx
                securityID
                iDSource
                securityType
                maturityMonthYear
                maturityDay
                putOrCall
                strikePrice
                optAttribute
                contractMultiplier
                couponRate
                securityExchange
                issuer
                encodedIssuerLen
                encodedIssuer
                securityDesc
                encodedSecurityDescLen
                encodedSecurityDesc
                side
                orderQty
                cashOrderQty
                ordType
                price
                stopPx
                pegDifference
                discretionInst
                discretionOffset
                currency
                complianceID
                solicitedFlag
                timeInForce
                effectiveTime
                expireDate
                expireTime
                execInst
                rule80A
                lastShares
                lastPx
                lastSpotRate
                lastForwardPoints
                lastMkt
                tradingSessionID
                lastCapacity
                leavesQty
                cumQty
                avgPx
                dayOrderQty
                dayCumQty
                dayAvgPx
                gTBookingInst
                tradeDate
                transactTime
                reportToExch
                commission
                commType
                grossTradeAmt
                settlCurrAmt
                settlCurrency
                settlCurrFxRate
                settlCurrFxRateCalc
                handlInst
                minQty
                maxFloor
                openClose
                maxShow
                text
                encodedTextLen
                encodedText
                futSettDate2
                orderQty2
                clearingFirm
                clearingAccount
                multiLegReportingType
                legRefId
                uploadedToBackoffice
                fixMessage
                isAllocation
                groupUploadId
                processedAt
                createdDate
                createdAt
                updatedAt
                userOrderExecutionReportsId
                groupOrderExecutionReportsId
                __typename
              }
              nextToken
              __typename
            }
            cryptoOrder
            groupUploadOrderId
            reviewStatus
            createdAt
            updatedAt
            groupUpload {
              id
              name
              description
              orders {
                items {
                  id
                  groupUploadOrdersId
                  accountNumber
                  quantity
                  brokerOverride
                  commission
                  owner
                  userOrder {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  accountInformationId
                  failed
                  failedReason
                  orderIds
                  createdDate
                  createdAt
                  updatedAt
                  groupUploadOrderUserOrderId
                  __typename
                }
                nextToken
                __typename
              }
              owner
              isPlaced
              isPlacedString
              isAvgPx
              createdAt
              updatedAt
              __typename
            }
            accountInformationUserOrdersId
            userOrderGroupUploadId
            __typename
          }
          nextToken
          __typename
        }
        positions {
          items {
            id
            accountNumber
            owner
            underlying
            pricePaid
            isCryptoPosition
            quantity
            marginRequirement
            strategy
            positionLegs {
              side
              quantity
              ratioQuantity
              pricePaid
              legType
              cusip
              marginRequirement
              expiration
              strike
              __typename
            }
            subAccountNumber
            status
            groupUploadOrderId
            createdAt
            updatedAt
            accountInformationPositionsId
            __typename
          }
          nextToken
          __typename
        }
        subAccounts {
          items {
            id
            accountNumber
            owner
            subAccountName
            subAccountNumber
            selfDirected
            balance {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              accountType
              createdAt
              updatedAt
              __typename
            }
            transfers {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                toSubAccountNumber
                amount
                message
                deposit
                status
                cancel
                createdAt
                updatedAt
                subAccountTransfersId
                __typename
              }
              nextToken
              __typename
            }
            commissionCode
            repCode
            newsLetter {
              newsLetter
              portfolio
              __typename
            }
            stock {
              stockSignals
              maxDollarAllocationPerSignal
              maxNumberOfSharesPerSignal
              allOrNone
              roundLotsOnly
              multiplier
              __typename
            }
            option {
              optionSignals
              maxDollarAllocationPerSignal
              maxNumberOfContractsPerSignal
              allOrNone
              multiplier
              __typename
            }
            createdAt
            updatedAt
            accountInformationSubAccountsId
            subAccountBalanceId
            __typename
          }
          nextToken
          __typename
        }
        documentUpload {
          items {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            investigationId
            investigationNote
            submittedBy
            document {
              documentTag
              documentType
              s3uri
              __typename
            }
            approvedBy
            approvalStatus
            createdAt
            updatedAt
            accountInformationDocumentUploadId
            __typename
          }
          nextToken
          __typename
        }
        cryptoTransfer {
          items {
            id
            accountNumber
            owner
            blockchainHash
            clientTransactionId
            currency
            quantity
            receiveAddress {
              hotWalletAddress
              coin
              __typename
            }
            userWalletAddress {
              owner
              address
              nickname
              id
              createdAt
              updatedAt
              __typename
            }
            deposit
            status
            type
            version
            createdAt
            updatedAt
            accountInformationCryptoTransferId
            __typename
          }
          nextToken
          __typename
        }
        selectedWatchlist {
          items {
            id
            accountNumber
            owner
            watchListName
            selectedStocks
            createdAt
            updatedAt
            accountInformationSelectedWatchlistId
            __typename
          }
          nextToken
          __typename
        }
        notifications {
          items {
            id
            accountNumber
            owner
            notificationType
            message
            severity
            acknowledged
            star
            sent
            deleted
            toUser
            fromUser
            fromSystem
            ttl
            createdAt
            updatedAt
            accountInformationNotificationsId
            __typename
          }
          nextToken
          __typename
        }
        achRelationship {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          achRelationshipStatic {
            id
            accountNumber
            owner
            plaidProcessorToken
            plaidAccountId
            bankRoutingNumber
            bankAccount
            bankAccountOwnerName
            bankAccountType
            deleted
            approvalMethod
            relationshipId
            status
            statusCode
            statusJson
            createdAt
            updatedAt
            __typename
          }
          deleted
          nickname
          microDepositTries
          microDeposits
          microDepositStatus
          depositWithdrawalRequests {
            items {
              id
              accountNumber
              owner
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              relationshipId
              amount
              message
              memo
              reason
              iraContributionDistribution {
                contributionType
                applyToPriorYear
                distributionReason
                federalTaxWithholding {
                  valueType
                  value
                  __typename
                }
                stateTaxWithholding {
                  valueType
                  value
                  __typename
                }
                __typename
              }
              isFullDisbursement
              transferId
              deposit
              status
              cancel
              createdAt
              updatedAt
              achRelationshipDepositWithdrawalRequestsId
              __typename
            }
            nextToken
            __typename
          }
          reissueTries
          reissue
          createdAt
          updatedAt
          achRelationshipAchRelationshipStaticId
          achRelationshipAccountInformationId
          __typename
        }
        userProfileIds
        createdAt
        updatedAt
        userProfileAccountsId
        draftUserProfileAccountsId
        accountInformationBalanceId
        accountInformationPermissionsId
        accountInformationAchRelationshipId
        __typename
      }
      owner
      systemAccess
      equityTrading
      optionsTrading
      cryptoTrading
      margin
      securitiesLending
      optionsLevel
      exitOnlyTrades
      restrictReason
      allowCancelOrder
      allowModifyOrder
      achWithdrawal
      patternDayTrader
      achApproval
      profileStatus
      betaFeatures
      achDeposit
      updatedBy
      createdAt
      updatedAt
      userPermissionsAccountInformationId
      __typename
    }
  }
`;
export const deleteUserPermissions = /* GraphQL */ `
  mutation DeleteUserPermissions(
    $input: DeleteUserPermissionsInput!
    $condition: ModelUserPermissionsConditionInput
  ) {
    deleteUserPermissions(input: $input, condition: $condition) {
      id
      accountNumber
      accountInformation {
        id
        primaryOwner
        owner
        accountNumber
        accountName
        accountType
        customerType
        accountRequestStatus
        investigationStatus
        apexId
        apexFdid
        apexCatAccountholderType
        apexJson
        accountStatus
        balance {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          overnightBuyingPowerID
          firm
          totalEquity
          marginEquity
          marginRequirement
          marginExcessEquity
          cashEquity
          cashRequirement
          cashExcessEquity
          overnightBuyingPowerIssued
          dayTradeBuyingPowerIssued
          regTBuyingPowerIssued
          overnightFactorIssued
          dayTradeFactorIssued
          marginEquityPercent
          positionMarketValue
          longEquityMarketValue
          shortEquityMarketValue
          longOptionMarketValue
          shortOptionMarketValue
          totalTradeBalance
          totalSettleBalance
          cashTradeBalance
          marginTradeBalance
          shortTradeBalance
          cashSettleBalance
          marginSettleBalance
          shortSettleBalance
          moneyMarketSettleBalance
          moneyMarketTradeBalance
          freeCash
          sma
          availableToWithdraw
          optionsRequirement
          nonOptionsRequirement
          lastUpdate
          nonOptionsRequirementNotConcentrated
          typeIUnavailableCashProceeds
          typeIIUnavailableCashProceeds
          netBalance
          smaCommitted
          netLiquidity
          pendingDebitInterest
          pendingDebitDividends
          fullyPaidUnsettledFunds
          cashOnOrders
          buyingPowerOnOrders
          marginExcessEquitySod
          cashExcessEquitySod
          netBalanceSod
          optionBuyingPowerInternal
          stockBuyingPowerInternal
          updateFlag
          accountType
          pendingTransfers {
            deposit
            amount
            achDepositWithdrawalRequestId
            __typename
          }
          createdAt
          updatedAt
          balanceAccountInformationId
          __typename
        }
        permissions {
          id
          accountNumber
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          owner
          systemAccess
          equityTrading
          optionsTrading
          cryptoTrading
          margin
          securitiesLending
          optionsLevel
          exitOnlyTrades
          restrictReason
          allowCancelOrder
          allowModifyOrder
          achWithdrawal
          patternDayTrader
          achApproval
          profileStatus
          betaFeatures
          achDeposit
          updatedBy
          createdAt
          updatedAt
          userPermissionsAccountInformationId
          __typename
        }
        userOrders {
          items {
            id
            accountNumber
            owner
            subAccountNumber
            cancel
            cancelReplace
            createdDate
            updatedDate
            commission
            feesAndCommission
            symbol
            side
            brokerSkipChecks
            brokerOverride
            brokerId
            quantity
            limitPrice
            stopPrice
            stockValue
            originalOrderId
            strategy
            avgPx
            orderType
            timeInForce
            instruction
            userOrderLegs {
              legType
              side
              quantity
              expiration
              strike
              openClose
              bid
              ask
              sharesPerContract
              avgPx
              __typename
            }
            cashSecured
            cashSecuredAmount
            message
            submitStatus
            status
            executionReports {
              items {
                id
                owner
                accountInformationId
                subAccountNumber
                orderID
                executionIncrementId
                secondaryOrderID
                clOrdID
                origClOrdID
                clientID
                execBroker
                listID
                execID
                execTransType
                execRefID
                execType
                ordStatus
                ordRejReason
                execRestatementReason
                account
                settlmntTyp
                futSettDate
                symbol
                symbolSfx
                securityID
                iDSource
                securityType
                maturityMonthYear
                maturityDay
                putOrCall
                strikePrice
                optAttribute
                contractMultiplier
                couponRate
                securityExchange
                issuer
                encodedIssuerLen
                encodedIssuer
                securityDesc
                encodedSecurityDescLen
                encodedSecurityDesc
                side
                orderQty
                cashOrderQty
                ordType
                price
                stopPx
                pegDifference
                discretionInst
                discretionOffset
                currency
                complianceID
                solicitedFlag
                timeInForce
                effectiveTime
                expireDate
                expireTime
                execInst
                rule80A
                lastShares
                lastPx
                lastSpotRate
                lastForwardPoints
                lastMkt
                tradingSessionID
                lastCapacity
                leavesQty
                cumQty
                avgPx
                dayOrderQty
                dayCumQty
                dayAvgPx
                gTBookingInst
                tradeDate
                transactTime
                reportToExch
                commission
                commType
                grossTradeAmt
                settlCurrAmt
                settlCurrency
                settlCurrFxRate
                settlCurrFxRateCalc
                handlInst
                minQty
                maxFloor
                openClose
                maxShow
                text
                encodedTextLen
                encodedText
                futSettDate2
                orderQty2
                clearingFirm
                clearingAccount
                multiLegReportingType
                legRefId
                uploadedToBackoffice
                fixMessage
                isAllocation
                groupUploadId
                processedAt
                createdDate
                createdAt
                updatedAt
                userOrderExecutionReportsId
                groupOrderExecutionReportsId
                __typename
              }
              nextToken
              __typename
            }
            cryptoOrder
            groupUploadOrderId
            reviewStatus
            createdAt
            updatedAt
            groupUpload {
              id
              name
              description
              orders {
                items {
                  id
                  groupUploadOrdersId
                  accountNumber
                  quantity
                  brokerOverride
                  commission
                  owner
                  userOrder {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  accountInformationId
                  failed
                  failedReason
                  orderIds
                  createdDate
                  createdAt
                  updatedAt
                  groupUploadOrderUserOrderId
                  __typename
                }
                nextToken
                __typename
              }
              owner
              isPlaced
              isPlacedString
              isAvgPx
              createdAt
              updatedAt
              __typename
            }
            accountInformationUserOrdersId
            userOrderGroupUploadId
            __typename
          }
          nextToken
          __typename
        }
        positions {
          items {
            id
            accountNumber
            owner
            underlying
            pricePaid
            isCryptoPosition
            quantity
            marginRequirement
            strategy
            positionLegs {
              side
              quantity
              ratioQuantity
              pricePaid
              legType
              cusip
              marginRequirement
              expiration
              strike
              __typename
            }
            subAccountNumber
            status
            groupUploadOrderId
            createdAt
            updatedAt
            accountInformationPositionsId
            __typename
          }
          nextToken
          __typename
        }
        subAccounts {
          items {
            id
            accountNumber
            owner
            subAccountName
            subAccountNumber
            selfDirected
            balance {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              accountType
              createdAt
              updatedAt
              __typename
            }
            transfers {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                toSubAccountNumber
                amount
                message
                deposit
                status
                cancel
                createdAt
                updatedAt
                subAccountTransfersId
                __typename
              }
              nextToken
              __typename
            }
            commissionCode
            repCode
            newsLetter {
              newsLetter
              portfolio
              __typename
            }
            stock {
              stockSignals
              maxDollarAllocationPerSignal
              maxNumberOfSharesPerSignal
              allOrNone
              roundLotsOnly
              multiplier
              __typename
            }
            option {
              optionSignals
              maxDollarAllocationPerSignal
              maxNumberOfContractsPerSignal
              allOrNone
              multiplier
              __typename
            }
            createdAt
            updatedAt
            accountInformationSubAccountsId
            subAccountBalanceId
            __typename
          }
          nextToken
          __typename
        }
        documentUpload {
          items {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            investigationId
            investigationNote
            submittedBy
            document {
              documentTag
              documentType
              s3uri
              __typename
            }
            approvedBy
            approvalStatus
            createdAt
            updatedAt
            accountInformationDocumentUploadId
            __typename
          }
          nextToken
          __typename
        }
        cryptoTransfer {
          items {
            id
            accountNumber
            owner
            blockchainHash
            clientTransactionId
            currency
            quantity
            receiveAddress {
              hotWalletAddress
              coin
              __typename
            }
            userWalletAddress {
              owner
              address
              nickname
              id
              createdAt
              updatedAt
              __typename
            }
            deposit
            status
            type
            version
            createdAt
            updatedAt
            accountInformationCryptoTransferId
            __typename
          }
          nextToken
          __typename
        }
        selectedWatchlist {
          items {
            id
            accountNumber
            owner
            watchListName
            selectedStocks
            createdAt
            updatedAt
            accountInformationSelectedWatchlistId
            __typename
          }
          nextToken
          __typename
        }
        notifications {
          items {
            id
            accountNumber
            owner
            notificationType
            message
            severity
            acknowledged
            star
            sent
            deleted
            toUser
            fromUser
            fromSystem
            ttl
            createdAt
            updatedAt
            accountInformationNotificationsId
            __typename
          }
          nextToken
          __typename
        }
        achRelationship {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          achRelationshipStatic {
            id
            accountNumber
            owner
            plaidProcessorToken
            plaidAccountId
            bankRoutingNumber
            bankAccount
            bankAccountOwnerName
            bankAccountType
            deleted
            approvalMethod
            relationshipId
            status
            statusCode
            statusJson
            createdAt
            updatedAt
            __typename
          }
          deleted
          nickname
          microDepositTries
          microDeposits
          microDepositStatus
          depositWithdrawalRequests {
            items {
              id
              accountNumber
              owner
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              relationshipId
              amount
              message
              memo
              reason
              iraContributionDistribution {
                contributionType
                applyToPriorYear
                distributionReason
                federalTaxWithholding {
                  valueType
                  value
                  __typename
                }
                stateTaxWithholding {
                  valueType
                  value
                  __typename
                }
                __typename
              }
              isFullDisbursement
              transferId
              deposit
              status
              cancel
              createdAt
              updatedAt
              achRelationshipDepositWithdrawalRequestsId
              __typename
            }
            nextToken
            __typename
          }
          reissueTries
          reissue
          createdAt
          updatedAt
          achRelationshipAchRelationshipStaticId
          achRelationshipAccountInformationId
          __typename
        }
        userProfileIds
        createdAt
        updatedAt
        userProfileAccountsId
        draftUserProfileAccountsId
        accountInformationBalanceId
        accountInformationPermissionsId
        accountInformationAchRelationshipId
        __typename
      }
      owner
      systemAccess
      equityTrading
      optionsTrading
      cryptoTrading
      margin
      securitiesLending
      optionsLevel
      exitOnlyTrades
      restrictReason
      allowCancelOrder
      allowModifyOrder
      achWithdrawal
      patternDayTrader
      achApproval
      profileStatus
      betaFeatures
      achDeposit
      updatedBy
      createdAt
      updatedAt
      userPermissionsAccountInformationId
      __typename
    }
  }
`;
export const createDocumentUpload = /* GraphQL */ `
  mutation CreateDocumentUpload(
    $input: CreateDocumentUploadInput!
    $condition: ModelDocumentUploadConditionInput
  ) {
    createDocumentUpload(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      accountInformation {
        id
        primaryOwner
        owner
        accountNumber
        accountName
        accountType
        customerType
        accountRequestStatus
        investigationStatus
        apexId
        apexFdid
        apexCatAccountholderType
        apexJson
        accountStatus
        balance {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          overnightBuyingPowerID
          firm
          totalEquity
          marginEquity
          marginRequirement
          marginExcessEquity
          cashEquity
          cashRequirement
          cashExcessEquity
          overnightBuyingPowerIssued
          dayTradeBuyingPowerIssued
          regTBuyingPowerIssued
          overnightFactorIssued
          dayTradeFactorIssued
          marginEquityPercent
          positionMarketValue
          longEquityMarketValue
          shortEquityMarketValue
          longOptionMarketValue
          shortOptionMarketValue
          totalTradeBalance
          totalSettleBalance
          cashTradeBalance
          marginTradeBalance
          shortTradeBalance
          cashSettleBalance
          marginSettleBalance
          shortSettleBalance
          moneyMarketSettleBalance
          moneyMarketTradeBalance
          freeCash
          sma
          availableToWithdraw
          optionsRequirement
          nonOptionsRequirement
          lastUpdate
          nonOptionsRequirementNotConcentrated
          typeIUnavailableCashProceeds
          typeIIUnavailableCashProceeds
          netBalance
          smaCommitted
          netLiquidity
          pendingDebitInterest
          pendingDebitDividends
          fullyPaidUnsettledFunds
          cashOnOrders
          buyingPowerOnOrders
          marginExcessEquitySod
          cashExcessEquitySod
          netBalanceSod
          optionBuyingPowerInternal
          stockBuyingPowerInternal
          updateFlag
          accountType
          pendingTransfers {
            deposit
            amount
            achDepositWithdrawalRequestId
            __typename
          }
          createdAt
          updatedAt
          balanceAccountInformationId
          __typename
        }
        permissions {
          id
          accountNumber
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          owner
          systemAccess
          equityTrading
          optionsTrading
          cryptoTrading
          margin
          securitiesLending
          optionsLevel
          exitOnlyTrades
          restrictReason
          allowCancelOrder
          allowModifyOrder
          achWithdrawal
          patternDayTrader
          achApproval
          profileStatus
          betaFeatures
          achDeposit
          updatedBy
          createdAt
          updatedAt
          userPermissionsAccountInformationId
          __typename
        }
        userOrders {
          items {
            id
            accountNumber
            owner
            subAccountNumber
            cancel
            cancelReplace
            createdDate
            updatedDate
            commission
            feesAndCommission
            symbol
            side
            brokerSkipChecks
            brokerOverride
            brokerId
            quantity
            limitPrice
            stopPrice
            stockValue
            originalOrderId
            strategy
            avgPx
            orderType
            timeInForce
            instruction
            userOrderLegs {
              legType
              side
              quantity
              expiration
              strike
              openClose
              bid
              ask
              sharesPerContract
              avgPx
              __typename
            }
            cashSecured
            cashSecuredAmount
            message
            submitStatus
            status
            executionReports {
              items {
                id
                owner
                accountInformationId
                subAccountNumber
                orderID
                executionIncrementId
                secondaryOrderID
                clOrdID
                origClOrdID
                clientID
                execBroker
                listID
                execID
                execTransType
                execRefID
                execType
                ordStatus
                ordRejReason
                execRestatementReason
                account
                settlmntTyp
                futSettDate
                symbol
                symbolSfx
                securityID
                iDSource
                securityType
                maturityMonthYear
                maturityDay
                putOrCall
                strikePrice
                optAttribute
                contractMultiplier
                couponRate
                securityExchange
                issuer
                encodedIssuerLen
                encodedIssuer
                securityDesc
                encodedSecurityDescLen
                encodedSecurityDesc
                side
                orderQty
                cashOrderQty
                ordType
                price
                stopPx
                pegDifference
                discretionInst
                discretionOffset
                currency
                complianceID
                solicitedFlag
                timeInForce
                effectiveTime
                expireDate
                expireTime
                execInst
                rule80A
                lastShares
                lastPx
                lastSpotRate
                lastForwardPoints
                lastMkt
                tradingSessionID
                lastCapacity
                leavesQty
                cumQty
                avgPx
                dayOrderQty
                dayCumQty
                dayAvgPx
                gTBookingInst
                tradeDate
                transactTime
                reportToExch
                commission
                commType
                grossTradeAmt
                settlCurrAmt
                settlCurrency
                settlCurrFxRate
                settlCurrFxRateCalc
                handlInst
                minQty
                maxFloor
                openClose
                maxShow
                text
                encodedTextLen
                encodedText
                futSettDate2
                orderQty2
                clearingFirm
                clearingAccount
                multiLegReportingType
                legRefId
                uploadedToBackoffice
                fixMessage
                isAllocation
                groupUploadId
                processedAt
                createdDate
                createdAt
                updatedAt
                userOrderExecutionReportsId
                groupOrderExecutionReportsId
                __typename
              }
              nextToken
              __typename
            }
            cryptoOrder
            groupUploadOrderId
            reviewStatus
            createdAt
            updatedAt
            groupUpload {
              id
              name
              description
              orders {
                items {
                  id
                  groupUploadOrdersId
                  accountNumber
                  quantity
                  brokerOverride
                  commission
                  owner
                  userOrder {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  accountInformationId
                  failed
                  failedReason
                  orderIds
                  createdDate
                  createdAt
                  updatedAt
                  groupUploadOrderUserOrderId
                  __typename
                }
                nextToken
                __typename
              }
              owner
              isPlaced
              isPlacedString
              isAvgPx
              createdAt
              updatedAt
              __typename
            }
            accountInformationUserOrdersId
            userOrderGroupUploadId
            __typename
          }
          nextToken
          __typename
        }
        positions {
          items {
            id
            accountNumber
            owner
            underlying
            pricePaid
            isCryptoPosition
            quantity
            marginRequirement
            strategy
            positionLegs {
              side
              quantity
              ratioQuantity
              pricePaid
              legType
              cusip
              marginRequirement
              expiration
              strike
              __typename
            }
            subAccountNumber
            status
            groupUploadOrderId
            createdAt
            updatedAt
            accountInformationPositionsId
            __typename
          }
          nextToken
          __typename
        }
        subAccounts {
          items {
            id
            accountNumber
            owner
            subAccountName
            subAccountNumber
            selfDirected
            balance {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              accountType
              createdAt
              updatedAt
              __typename
            }
            transfers {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                toSubAccountNumber
                amount
                message
                deposit
                status
                cancel
                createdAt
                updatedAt
                subAccountTransfersId
                __typename
              }
              nextToken
              __typename
            }
            commissionCode
            repCode
            newsLetter {
              newsLetter
              portfolio
              __typename
            }
            stock {
              stockSignals
              maxDollarAllocationPerSignal
              maxNumberOfSharesPerSignal
              allOrNone
              roundLotsOnly
              multiplier
              __typename
            }
            option {
              optionSignals
              maxDollarAllocationPerSignal
              maxNumberOfContractsPerSignal
              allOrNone
              multiplier
              __typename
            }
            createdAt
            updatedAt
            accountInformationSubAccountsId
            subAccountBalanceId
            __typename
          }
          nextToken
          __typename
        }
        documentUpload {
          items {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            investigationId
            investigationNote
            submittedBy
            document {
              documentTag
              documentType
              s3uri
              __typename
            }
            approvedBy
            approvalStatus
            createdAt
            updatedAt
            accountInformationDocumentUploadId
            __typename
          }
          nextToken
          __typename
        }
        cryptoTransfer {
          items {
            id
            accountNumber
            owner
            blockchainHash
            clientTransactionId
            currency
            quantity
            receiveAddress {
              hotWalletAddress
              coin
              __typename
            }
            userWalletAddress {
              owner
              address
              nickname
              id
              createdAt
              updatedAt
              __typename
            }
            deposit
            status
            type
            version
            createdAt
            updatedAt
            accountInformationCryptoTransferId
            __typename
          }
          nextToken
          __typename
        }
        selectedWatchlist {
          items {
            id
            accountNumber
            owner
            watchListName
            selectedStocks
            createdAt
            updatedAt
            accountInformationSelectedWatchlistId
            __typename
          }
          nextToken
          __typename
        }
        notifications {
          items {
            id
            accountNumber
            owner
            notificationType
            message
            severity
            acknowledged
            star
            sent
            deleted
            toUser
            fromUser
            fromSystem
            ttl
            createdAt
            updatedAt
            accountInformationNotificationsId
            __typename
          }
          nextToken
          __typename
        }
        achRelationship {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          achRelationshipStatic {
            id
            accountNumber
            owner
            plaidProcessorToken
            plaidAccountId
            bankRoutingNumber
            bankAccount
            bankAccountOwnerName
            bankAccountType
            deleted
            approvalMethod
            relationshipId
            status
            statusCode
            statusJson
            createdAt
            updatedAt
            __typename
          }
          deleted
          nickname
          microDepositTries
          microDeposits
          microDepositStatus
          depositWithdrawalRequests {
            items {
              id
              accountNumber
              owner
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              relationshipId
              amount
              message
              memo
              reason
              iraContributionDistribution {
                contributionType
                applyToPriorYear
                distributionReason
                federalTaxWithholding {
                  valueType
                  value
                  __typename
                }
                stateTaxWithholding {
                  valueType
                  value
                  __typename
                }
                __typename
              }
              isFullDisbursement
              transferId
              deposit
              status
              cancel
              createdAt
              updatedAt
              achRelationshipDepositWithdrawalRequestsId
              __typename
            }
            nextToken
            __typename
          }
          reissueTries
          reissue
          createdAt
          updatedAt
          achRelationshipAchRelationshipStaticId
          achRelationshipAccountInformationId
          __typename
        }
        userProfileIds
        createdAt
        updatedAt
        userProfileAccountsId
        draftUserProfileAccountsId
        accountInformationBalanceId
        accountInformationPermissionsId
        accountInformationAchRelationshipId
        __typename
      }
      investigationId
      investigationNote
      submittedBy
      document {
        documentTag
        documentType
        s3uri
        __typename
      }
      approvedBy
      approvalStatus
      createdAt
      updatedAt
      accountInformationDocumentUploadId
      __typename
    }
  }
`;
export const updateDocumentUpload = /* GraphQL */ `
  mutation UpdateDocumentUpload(
    $input: UpdateDocumentUploadInput!
    $condition: ModelDocumentUploadConditionInput
  ) {
    updateDocumentUpload(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      accountInformation {
        id
        primaryOwner
        owner
        accountNumber
        accountName
        accountType
        customerType
        accountRequestStatus
        investigationStatus
        apexId
        apexFdid
        apexCatAccountholderType
        apexJson
        accountStatus
        balance {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          overnightBuyingPowerID
          firm
          totalEquity
          marginEquity
          marginRequirement
          marginExcessEquity
          cashEquity
          cashRequirement
          cashExcessEquity
          overnightBuyingPowerIssued
          dayTradeBuyingPowerIssued
          regTBuyingPowerIssued
          overnightFactorIssued
          dayTradeFactorIssued
          marginEquityPercent
          positionMarketValue
          longEquityMarketValue
          shortEquityMarketValue
          longOptionMarketValue
          shortOptionMarketValue
          totalTradeBalance
          totalSettleBalance
          cashTradeBalance
          marginTradeBalance
          shortTradeBalance
          cashSettleBalance
          marginSettleBalance
          shortSettleBalance
          moneyMarketSettleBalance
          moneyMarketTradeBalance
          freeCash
          sma
          availableToWithdraw
          optionsRequirement
          nonOptionsRequirement
          lastUpdate
          nonOptionsRequirementNotConcentrated
          typeIUnavailableCashProceeds
          typeIIUnavailableCashProceeds
          netBalance
          smaCommitted
          netLiquidity
          pendingDebitInterest
          pendingDebitDividends
          fullyPaidUnsettledFunds
          cashOnOrders
          buyingPowerOnOrders
          marginExcessEquitySod
          cashExcessEquitySod
          netBalanceSod
          optionBuyingPowerInternal
          stockBuyingPowerInternal
          updateFlag
          accountType
          pendingTransfers {
            deposit
            amount
            achDepositWithdrawalRequestId
            __typename
          }
          createdAt
          updatedAt
          balanceAccountInformationId
          __typename
        }
        permissions {
          id
          accountNumber
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          owner
          systemAccess
          equityTrading
          optionsTrading
          cryptoTrading
          margin
          securitiesLending
          optionsLevel
          exitOnlyTrades
          restrictReason
          allowCancelOrder
          allowModifyOrder
          achWithdrawal
          patternDayTrader
          achApproval
          profileStatus
          betaFeatures
          achDeposit
          updatedBy
          createdAt
          updatedAt
          userPermissionsAccountInformationId
          __typename
        }
        userOrders {
          items {
            id
            accountNumber
            owner
            subAccountNumber
            cancel
            cancelReplace
            createdDate
            updatedDate
            commission
            feesAndCommission
            symbol
            side
            brokerSkipChecks
            brokerOverride
            brokerId
            quantity
            limitPrice
            stopPrice
            stockValue
            originalOrderId
            strategy
            avgPx
            orderType
            timeInForce
            instruction
            userOrderLegs {
              legType
              side
              quantity
              expiration
              strike
              openClose
              bid
              ask
              sharesPerContract
              avgPx
              __typename
            }
            cashSecured
            cashSecuredAmount
            message
            submitStatus
            status
            executionReports {
              items {
                id
                owner
                accountInformationId
                subAccountNumber
                orderID
                executionIncrementId
                secondaryOrderID
                clOrdID
                origClOrdID
                clientID
                execBroker
                listID
                execID
                execTransType
                execRefID
                execType
                ordStatus
                ordRejReason
                execRestatementReason
                account
                settlmntTyp
                futSettDate
                symbol
                symbolSfx
                securityID
                iDSource
                securityType
                maturityMonthYear
                maturityDay
                putOrCall
                strikePrice
                optAttribute
                contractMultiplier
                couponRate
                securityExchange
                issuer
                encodedIssuerLen
                encodedIssuer
                securityDesc
                encodedSecurityDescLen
                encodedSecurityDesc
                side
                orderQty
                cashOrderQty
                ordType
                price
                stopPx
                pegDifference
                discretionInst
                discretionOffset
                currency
                complianceID
                solicitedFlag
                timeInForce
                effectiveTime
                expireDate
                expireTime
                execInst
                rule80A
                lastShares
                lastPx
                lastSpotRate
                lastForwardPoints
                lastMkt
                tradingSessionID
                lastCapacity
                leavesQty
                cumQty
                avgPx
                dayOrderQty
                dayCumQty
                dayAvgPx
                gTBookingInst
                tradeDate
                transactTime
                reportToExch
                commission
                commType
                grossTradeAmt
                settlCurrAmt
                settlCurrency
                settlCurrFxRate
                settlCurrFxRateCalc
                handlInst
                minQty
                maxFloor
                openClose
                maxShow
                text
                encodedTextLen
                encodedText
                futSettDate2
                orderQty2
                clearingFirm
                clearingAccount
                multiLegReportingType
                legRefId
                uploadedToBackoffice
                fixMessage
                isAllocation
                groupUploadId
                processedAt
                createdDate
                createdAt
                updatedAt
                userOrderExecutionReportsId
                groupOrderExecutionReportsId
                __typename
              }
              nextToken
              __typename
            }
            cryptoOrder
            groupUploadOrderId
            reviewStatus
            createdAt
            updatedAt
            groupUpload {
              id
              name
              description
              orders {
                items {
                  id
                  groupUploadOrdersId
                  accountNumber
                  quantity
                  brokerOverride
                  commission
                  owner
                  userOrder {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  accountInformationId
                  failed
                  failedReason
                  orderIds
                  createdDate
                  createdAt
                  updatedAt
                  groupUploadOrderUserOrderId
                  __typename
                }
                nextToken
                __typename
              }
              owner
              isPlaced
              isPlacedString
              isAvgPx
              createdAt
              updatedAt
              __typename
            }
            accountInformationUserOrdersId
            userOrderGroupUploadId
            __typename
          }
          nextToken
          __typename
        }
        positions {
          items {
            id
            accountNumber
            owner
            underlying
            pricePaid
            isCryptoPosition
            quantity
            marginRequirement
            strategy
            positionLegs {
              side
              quantity
              ratioQuantity
              pricePaid
              legType
              cusip
              marginRequirement
              expiration
              strike
              __typename
            }
            subAccountNumber
            status
            groupUploadOrderId
            createdAt
            updatedAt
            accountInformationPositionsId
            __typename
          }
          nextToken
          __typename
        }
        subAccounts {
          items {
            id
            accountNumber
            owner
            subAccountName
            subAccountNumber
            selfDirected
            balance {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              accountType
              createdAt
              updatedAt
              __typename
            }
            transfers {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                toSubAccountNumber
                amount
                message
                deposit
                status
                cancel
                createdAt
                updatedAt
                subAccountTransfersId
                __typename
              }
              nextToken
              __typename
            }
            commissionCode
            repCode
            newsLetter {
              newsLetter
              portfolio
              __typename
            }
            stock {
              stockSignals
              maxDollarAllocationPerSignal
              maxNumberOfSharesPerSignal
              allOrNone
              roundLotsOnly
              multiplier
              __typename
            }
            option {
              optionSignals
              maxDollarAllocationPerSignal
              maxNumberOfContractsPerSignal
              allOrNone
              multiplier
              __typename
            }
            createdAt
            updatedAt
            accountInformationSubAccountsId
            subAccountBalanceId
            __typename
          }
          nextToken
          __typename
        }
        documentUpload {
          items {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            investigationId
            investigationNote
            submittedBy
            document {
              documentTag
              documentType
              s3uri
              __typename
            }
            approvedBy
            approvalStatus
            createdAt
            updatedAt
            accountInformationDocumentUploadId
            __typename
          }
          nextToken
          __typename
        }
        cryptoTransfer {
          items {
            id
            accountNumber
            owner
            blockchainHash
            clientTransactionId
            currency
            quantity
            receiveAddress {
              hotWalletAddress
              coin
              __typename
            }
            userWalletAddress {
              owner
              address
              nickname
              id
              createdAt
              updatedAt
              __typename
            }
            deposit
            status
            type
            version
            createdAt
            updatedAt
            accountInformationCryptoTransferId
            __typename
          }
          nextToken
          __typename
        }
        selectedWatchlist {
          items {
            id
            accountNumber
            owner
            watchListName
            selectedStocks
            createdAt
            updatedAt
            accountInformationSelectedWatchlistId
            __typename
          }
          nextToken
          __typename
        }
        notifications {
          items {
            id
            accountNumber
            owner
            notificationType
            message
            severity
            acknowledged
            star
            sent
            deleted
            toUser
            fromUser
            fromSystem
            ttl
            createdAt
            updatedAt
            accountInformationNotificationsId
            __typename
          }
          nextToken
          __typename
        }
        achRelationship {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          achRelationshipStatic {
            id
            accountNumber
            owner
            plaidProcessorToken
            plaidAccountId
            bankRoutingNumber
            bankAccount
            bankAccountOwnerName
            bankAccountType
            deleted
            approvalMethod
            relationshipId
            status
            statusCode
            statusJson
            createdAt
            updatedAt
            __typename
          }
          deleted
          nickname
          microDepositTries
          microDeposits
          microDepositStatus
          depositWithdrawalRequests {
            items {
              id
              accountNumber
              owner
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              relationshipId
              amount
              message
              memo
              reason
              iraContributionDistribution {
                contributionType
                applyToPriorYear
                distributionReason
                federalTaxWithholding {
                  valueType
                  value
                  __typename
                }
                stateTaxWithholding {
                  valueType
                  value
                  __typename
                }
                __typename
              }
              isFullDisbursement
              transferId
              deposit
              status
              cancel
              createdAt
              updatedAt
              achRelationshipDepositWithdrawalRequestsId
              __typename
            }
            nextToken
            __typename
          }
          reissueTries
          reissue
          createdAt
          updatedAt
          achRelationshipAchRelationshipStaticId
          achRelationshipAccountInformationId
          __typename
        }
        userProfileIds
        createdAt
        updatedAt
        userProfileAccountsId
        draftUserProfileAccountsId
        accountInformationBalanceId
        accountInformationPermissionsId
        accountInformationAchRelationshipId
        __typename
      }
      investigationId
      investigationNote
      submittedBy
      document {
        documentTag
        documentType
        s3uri
        __typename
      }
      approvedBy
      approvalStatus
      createdAt
      updatedAt
      accountInformationDocumentUploadId
      __typename
    }
  }
`;
export const deleteDocumentUpload = /* GraphQL */ `
  mutation DeleteDocumentUpload(
    $input: DeleteDocumentUploadInput!
    $condition: ModelDocumentUploadConditionInput
  ) {
    deleteDocumentUpload(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      accountInformation {
        id
        primaryOwner
        owner
        accountNumber
        accountName
        accountType
        customerType
        accountRequestStatus
        investigationStatus
        apexId
        apexFdid
        apexCatAccountholderType
        apexJson
        accountStatus
        balance {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          overnightBuyingPowerID
          firm
          totalEquity
          marginEquity
          marginRequirement
          marginExcessEquity
          cashEquity
          cashRequirement
          cashExcessEquity
          overnightBuyingPowerIssued
          dayTradeBuyingPowerIssued
          regTBuyingPowerIssued
          overnightFactorIssued
          dayTradeFactorIssued
          marginEquityPercent
          positionMarketValue
          longEquityMarketValue
          shortEquityMarketValue
          longOptionMarketValue
          shortOptionMarketValue
          totalTradeBalance
          totalSettleBalance
          cashTradeBalance
          marginTradeBalance
          shortTradeBalance
          cashSettleBalance
          marginSettleBalance
          shortSettleBalance
          moneyMarketSettleBalance
          moneyMarketTradeBalance
          freeCash
          sma
          availableToWithdraw
          optionsRequirement
          nonOptionsRequirement
          lastUpdate
          nonOptionsRequirementNotConcentrated
          typeIUnavailableCashProceeds
          typeIIUnavailableCashProceeds
          netBalance
          smaCommitted
          netLiquidity
          pendingDebitInterest
          pendingDebitDividends
          fullyPaidUnsettledFunds
          cashOnOrders
          buyingPowerOnOrders
          marginExcessEquitySod
          cashExcessEquitySod
          netBalanceSod
          optionBuyingPowerInternal
          stockBuyingPowerInternal
          updateFlag
          accountType
          pendingTransfers {
            deposit
            amount
            achDepositWithdrawalRequestId
            __typename
          }
          createdAt
          updatedAt
          balanceAccountInformationId
          __typename
        }
        permissions {
          id
          accountNumber
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          owner
          systemAccess
          equityTrading
          optionsTrading
          cryptoTrading
          margin
          securitiesLending
          optionsLevel
          exitOnlyTrades
          restrictReason
          allowCancelOrder
          allowModifyOrder
          achWithdrawal
          patternDayTrader
          achApproval
          profileStatus
          betaFeatures
          achDeposit
          updatedBy
          createdAt
          updatedAt
          userPermissionsAccountInformationId
          __typename
        }
        userOrders {
          items {
            id
            accountNumber
            owner
            subAccountNumber
            cancel
            cancelReplace
            createdDate
            updatedDate
            commission
            feesAndCommission
            symbol
            side
            brokerSkipChecks
            brokerOverride
            brokerId
            quantity
            limitPrice
            stopPrice
            stockValue
            originalOrderId
            strategy
            avgPx
            orderType
            timeInForce
            instruction
            userOrderLegs {
              legType
              side
              quantity
              expiration
              strike
              openClose
              bid
              ask
              sharesPerContract
              avgPx
              __typename
            }
            cashSecured
            cashSecuredAmount
            message
            submitStatus
            status
            executionReports {
              items {
                id
                owner
                accountInformationId
                subAccountNumber
                orderID
                executionIncrementId
                secondaryOrderID
                clOrdID
                origClOrdID
                clientID
                execBroker
                listID
                execID
                execTransType
                execRefID
                execType
                ordStatus
                ordRejReason
                execRestatementReason
                account
                settlmntTyp
                futSettDate
                symbol
                symbolSfx
                securityID
                iDSource
                securityType
                maturityMonthYear
                maturityDay
                putOrCall
                strikePrice
                optAttribute
                contractMultiplier
                couponRate
                securityExchange
                issuer
                encodedIssuerLen
                encodedIssuer
                securityDesc
                encodedSecurityDescLen
                encodedSecurityDesc
                side
                orderQty
                cashOrderQty
                ordType
                price
                stopPx
                pegDifference
                discretionInst
                discretionOffset
                currency
                complianceID
                solicitedFlag
                timeInForce
                effectiveTime
                expireDate
                expireTime
                execInst
                rule80A
                lastShares
                lastPx
                lastSpotRate
                lastForwardPoints
                lastMkt
                tradingSessionID
                lastCapacity
                leavesQty
                cumQty
                avgPx
                dayOrderQty
                dayCumQty
                dayAvgPx
                gTBookingInst
                tradeDate
                transactTime
                reportToExch
                commission
                commType
                grossTradeAmt
                settlCurrAmt
                settlCurrency
                settlCurrFxRate
                settlCurrFxRateCalc
                handlInst
                minQty
                maxFloor
                openClose
                maxShow
                text
                encodedTextLen
                encodedText
                futSettDate2
                orderQty2
                clearingFirm
                clearingAccount
                multiLegReportingType
                legRefId
                uploadedToBackoffice
                fixMessage
                isAllocation
                groupUploadId
                processedAt
                createdDate
                createdAt
                updatedAt
                userOrderExecutionReportsId
                groupOrderExecutionReportsId
                __typename
              }
              nextToken
              __typename
            }
            cryptoOrder
            groupUploadOrderId
            reviewStatus
            createdAt
            updatedAt
            groupUpload {
              id
              name
              description
              orders {
                items {
                  id
                  groupUploadOrdersId
                  accountNumber
                  quantity
                  brokerOverride
                  commission
                  owner
                  userOrder {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  accountInformationId
                  failed
                  failedReason
                  orderIds
                  createdDate
                  createdAt
                  updatedAt
                  groupUploadOrderUserOrderId
                  __typename
                }
                nextToken
                __typename
              }
              owner
              isPlaced
              isPlacedString
              isAvgPx
              createdAt
              updatedAt
              __typename
            }
            accountInformationUserOrdersId
            userOrderGroupUploadId
            __typename
          }
          nextToken
          __typename
        }
        positions {
          items {
            id
            accountNumber
            owner
            underlying
            pricePaid
            isCryptoPosition
            quantity
            marginRequirement
            strategy
            positionLegs {
              side
              quantity
              ratioQuantity
              pricePaid
              legType
              cusip
              marginRequirement
              expiration
              strike
              __typename
            }
            subAccountNumber
            status
            groupUploadOrderId
            createdAt
            updatedAt
            accountInformationPositionsId
            __typename
          }
          nextToken
          __typename
        }
        subAccounts {
          items {
            id
            accountNumber
            owner
            subAccountName
            subAccountNumber
            selfDirected
            balance {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              accountType
              createdAt
              updatedAt
              __typename
            }
            transfers {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                toSubAccountNumber
                amount
                message
                deposit
                status
                cancel
                createdAt
                updatedAt
                subAccountTransfersId
                __typename
              }
              nextToken
              __typename
            }
            commissionCode
            repCode
            newsLetter {
              newsLetter
              portfolio
              __typename
            }
            stock {
              stockSignals
              maxDollarAllocationPerSignal
              maxNumberOfSharesPerSignal
              allOrNone
              roundLotsOnly
              multiplier
              __typename
            }
            option {
              optionSignals
              maxDollarAllocationPerSignal
              maxNumberOfContractsPerSignal
              allOrNone
              multiplier
              __typename
            }
            createdAt
            updatedAt
            accountInformationSubAccountsId
            subAccountBalanceId
            __typename
          }
          nextToken
          __typename
        }
        documentUpload {
          items {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            investigationId
            investigationNote
            submittedBy
            document {
              documentTag
              documentType
              s3uri
              __typename
            }
            approvedBy
            approvalStatus
            createdAt
            updatedAt
            accountInformationDocumentUploadId
            __typename
          }
          nextToken
          __typename
        }
        cryptoTransfer {
          items {
            id
            accountNumber
            owner
            blockchainHash
            clientTransactionId
            currency
            quantity
            receiveAddress {
              hotWalletAddress
              coin
              __typename
            }
            userWalletAddress {
              owner
              address
              nickname
              id
              createdAt
              updatedAt
              __typename
            }
            deposit
            status
            type
            version
            createdAt
            updatedAt
            accountInformationCryptoTransferId
            __typename
          }
          nextToken
          __typename
        }
        selectedWatchlist {
          items {
            id
            accountNumber
            owner
            watchListName
            selectedStocks
            createdAt
            updatedAt
            accountInformationSelectedWatchlistId
            __typename
          }
          nextToken
          __typename
        }
        notifications {
          items {
            id
            accountNumber
            owner
            notificationType
            message
            severity
            acknowledged
            star
            sent
            deleted
            toUser
            fromUser
            fromSystem
            ttl
            createdAt
            updatedAt
            accountInformationNotificationsId
            __typename
          }
          nextToken
          __typename
        }
        achRelationship {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          achRelationshipStatic {
            id
            accountNumber
            owner
            plaidProcessorToken
            plaidAccountId
            bankRoutingNumber
            bankAccount
            bankAccountOwnerName
            bankAccountType
            deleted
            approvalMethod
            relationshipId
            status
            statusCode
            statusJson
            createdAt
            updatedAt
            __typename
          }
          deleted
          nickname
          microDepositTries
          microDeposits
          microDepositStatus
          depositWithdrawalRequests {
            items {
              id
              accountNumber
              owner
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              relationshipId
              amount
              message
              memo
              reason
              iraContributionDistribution {
                contributionType
                applyToPriorYear
                distributionReason
                federalTaxWithholding {
                  valueType
                  value
                  __typename
                }
                stateTaxWithholding {
                  valueType
                  value
                  __typename
                }
                __typename
              }
              isFullDisbursement
              transferId
              deposit
              status
              cancel
              createdAt
              updatedAt
              achRelationshipDepositWithdrawalRequestsId
              __typename
            }
            nextToken
            __typename
          }
          reissueTries
          reissue
          createdAt
          updatedAt
          achRelationshipAchRelationshipStaticId
          achRelationshipAccountInformationId
          __typename
        }
        userProfileIds
        createdAt
        updatedAt
        userProfileAccountsId
        draftUserProfileAccountsId
        accountInformationBalanceId
        accountInformationPermissionsId
        accountInformationAchRelationshipId
        __typename
      }
      investigationId
      investigationNote
      submittedBy
      document {
        documentTag
        documentType
        s3uri
        __typename
      }
      approvedBy
      approvalStatus
      createdAt
      updatedAt
      accountInformationDocumentUploadId
      __typename
    }
  }
`;
export const createUserStatements = /* GraphQL */ `
  mutation CreateUserStatements(
    $input: CreateUserStatementsInput!
    $condition: ModelUserStatementsConditionInput
  ) {
    createUserStatements(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      documentId
      correspondentCode
      branchCode
      documentCategory
      documentType
      taxIds
      fileName
      documentDate
      documentUrl
      pageCount
      pageCountDisplay
      ttl
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserStatements = /* GraphQL */ `
  mutation UpdateUserStatements(
    $input: UpdateUserStatementsInput!
    $condition: ModelUserStatementsConditionInput
  ) {
    updateUserStatements(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      documentId
      correspondentCode
      branchCode
      documentCategory
      documentType
      taxIds
      fileName
      documentDate
      documentUrl
      pageCount
      pageCountDisplay
      ttl
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserStatements = /* GraphQL */ `
  mutation DeleteUserStatements(
    $input: DeleteUserStatementsInput!
    $condition: ModelUserStatementsConditionInput
  ) {
    deleteUserStatements(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      documentId
      correspondentCode
      branchCode
      documentCategory
      documentType
      taxIds
      fileName
      documentDate
      documentUrl
      pageCount
      pageCountDisplay
      ttl
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createForm = /* GraphQL */ `
  mutation CreateForm(
    $input: CreateFormInput!
    $condition: ModelFormConditionInput
  ) {
    createForm(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      userProfileId
      onboardingRequested
      marginRequested
      cryptoRequested
      formsRequested
      requestedOptionLevels
      approvedOptionLevels
      terms
      approvalStatus
      marginStatus
      cryptoStatus
      approvedBy
      message
      foreignDueDiligence {
        initialContact
        referredName
        referredRelationship
        businessNature
        accountActivityType
        referredToBroker
        primaryBanking
        initialDepositType
        valueInitialDeposit
        expectedWithdrawals
        __typename
      }
      entityDueDiligence {
        accountName
        countryOfIncorporation
        businessLocations
        hasRelatedAccounts
        relatedAccounts {
          accountNumber
          entityName
          __typename
        }
        politicallyExposedPersons {
          legalName
          role
          politicalTitle
          politicalOrganization
          immediateFamily
          __typename
        }
        primaryEntityAccountActivity
        expectedWithdrawalFrequency
        willTransactForeignBonds
        willTransactLowPricedSecurities
        initialDepositAmount
        initialDepositSource
        additionalAccounts {
          institutionNames
          scopeOfBusiness
          scopeOfBusinessClarification
          primaryOngoingFundingSource
          confirmEntityDoesNotIssueBearerShares
          __typename
        }
        entityOrAssociatesHaveNegativeNews
        entityOrAssociatesNegativeNewsInfo
        registeredRepresentativeApproverName
        assessedRiskRating
        __typename
      }
      updatedBy
      source
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateForm = /* GraphQL */ `
  mutation UpdateForm(
    $input: UpdateFormInput!
    $condition: ModelFormConditionInput
  ) {
    updateForm(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      userProfileId
      onboardingRequested
      marginRequested
      cryptoRequested
      formsRequested
      requestedOptionLevels
      approvedOptionLevels
      terms
      approvalStatus
      marginStatus
      cryptoStatus
      approvedBy
      message
      foreignDueDiligence {
        initialContact
        referredName
        referredRelationship
        businessNature
        accountActivityType
        referredToBroker
        primaryBanking
        initialDepositType
        valueInitialDeposit
        expectedWithdrawals
        __typename
      }
      entityDueDiligence {
        accountName
        countryOfIncorporation
        businessLocations
        hasRelatedAccounts
        relatedAccounts {
          accountNumber
          entityName
          __typename
        }
        politicallyExposedPersons {
          legalName
          role
          politicalTitle
          politicalOrganization
          immediateFamily
          __typename
        }
        primaryEntityAccountActivity
        expectedWithdrawalFrequency
        willTransactForeignBonds
        willTransactLowPricedSecurities
        initialDepositAmount
        initialDepositSource
        additionalAccounts {
          institutionNames
          scopeOfBusiness
          scopeOfBusinessClarification
          primaryOngoingFundingSource
          confirmEntityDoesNotIssueBearerShares
          __typename
        }
        entityOrAssociatesHaveNegativeNews
        entityOrAssociatesNegativeNewsInfo
        registeredRepresentativeApproverName
        assessedRiskRating
        __typename
      }
      updatedBy
      source
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteForm = /* GraphQL */ `
  mutation DeleteForm(
    $input: DeleteFormInput!
    $condition: ModelFormConditionInput
  ) {
    deleteForm(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      userProfileId
      onboardingRequested
      marginRequested
      cryptoRequested
      formsRequested
      requestedOptionLevels
      approvedOptionLevels
      terms
      approvalStatus
      marginStatus
      cryptoStatus
      approvedBy
      message
      foreignDueDiligence {
        initialContact
        referredName
        referredRelationship
        businessNature
        accountActivityType
        referredToBroker
        primaryBanking
        initialDepositType
        valueInitialDeposit
        expectedWithdrawals
        __typename
      }
      entityDueDiligence {
        accountName
        countryOfIncorporation
        businessLocations
        hasRelatedAccounts
        relatedAccounts {
          accountNumber
          entityName
          __typename
        }
        politicallyExposedPersons {
          legalName
          role
          politicalTitle
          politicalOrganization
          immediateFamily
          __typename
        }
        primaryEntityAccountActivity
        expectedWithdrawalFrequency
        willTransactForeignBonds
        willTransactLowPricedSecurities
        initialDepositAmount
        initialDepositSource
        additionalAccounts {
          institutionNames
          scopeOfBusiness
          scopeOfBusinessClarification
          primaryOngoingFundingSource
          confirmEntityDoesNotIssueBearerShares
          __typename
        }
        entityOrAssociatesHaveNegativeNews
        entityOrAssociatesNegativeNewsInfo
        registeredRepresentativeApproverName
        assessedRiskRating
        __typename
      }
      updatedBy
      source
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createWatchlist = /* GraphQL */ `
  mutation CreateWatchlist(
    $input: CreateWatchlistInput!
    $condition: ModelWatchlistConditionInput
  ) {
    createWatchlist(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      watchListName
      selectedStocks
      createdAt
      updatedAt
      accountInformationSelectedWatchlistId
      __typename
    }
  }
`;
export const updateWatchlist = /* GraphQL */ `
  mutation UpdateWatchlist(
    $input: UpdateWatchlistInput!
    $condition: ModelWatchlistConditionInput
  ) {
    updateWatchlist(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      watchListName
      selectedStocks
      createdAt
      updatedAt
      accountInformationSelectedWatchlistId
      __typename
    }
  }
`;
export const deleteWatchlist = /* GraphQL */ `
  mutation DeleteWatchlist(
    $input: DeleteWatchlistInput!
    $condition: ModelWatchlistConditionInput
  ) {
    deleteWatchlist(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      watchListName
      selectedStocks
      createdAt
      updatedAt
      accountInformationSelectedWatchlistId
      __typename
    }
  }
`;
export const createNotifications = /* GraphQL */ `
  mutation CreateNotifications(
    $input: CreateNotificationsInput!
    $condition: ModelNotificationsConditionInput
  ) {
    createNotifications(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      notificationType
      message
      severity
      acknowledged
      star
      sent
      deleted
      toUser
      fromUser
      fromSystem
      ttl
      createdAt
      updatedAt
      accountInformationNotificationsId
      __typename
    }
  }
`;
export const updateNotifications = /* GraphQL */ `
  mutation UpdateNotifications(
    $input: UpdateNotificationsInput!
    $condition: ModelNotificationsConditionInput
  ) {
    updateNotifications(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      notificationType
      message
      severity
      acknowledged
      star
      sent
      deleted
      toUser
      fromUser
      fromSystem
      ttl
      createdAt
      updatedAt
      accountInformationNotificationsId
      __typename
    }
  }
`;
export const deleteNotifications = /* GraphQL */ `
  mutation DeleteNotifications(
    $input: DeleteNotificationsInput!
    $condition: ModelNotificationsConditionInput
  ) {
    deleteNotifications(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      notificationType
      message
      severity
      acknowledged
      star
      sent
      deleted
      toUser
      fromUser
      fromSystem
      ttl
      createdAt
      updatedAt
      accountInformationNotificationsId
      __typename
    }
  }
`;
export const createUserStatementsRequest = /* GraphQL */ `
  mutation CreateUserStatementsRequest(
    $input: CreateUserStatementsRequestInput!
    $condition: ModelUserStatementsRequestConditionInput
  ) {
    createUserStatementsRequest(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      documentCategory
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserStatementsRequest = /* GraphQL */ `
  mutation UpdateUserStatementsRequest(
    $input: UpdateUserStatementsRequestInput!
    $condition: ModelUserStatementsRequestConditionInput
  ) {
    updateUserStatementsRequest(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      documentCategory
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserStatementsRequest = /* GraphQL */ `
  mutation DeleteUserStatementsRequest(
    $input: DeleteUserStatementsRequestInput!
    $condition: ModelUserStatementsRequestConditionInput
  ) {
    deleteUserStatementsRequest(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      documentCategory
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUserStatementDocuments = /* GraphQL */ `
  mutation CreateUserStatementDocuments(
    $input: CreateUserStatementDocumentsInput!
    $condition: ModelUserStatementDocumentsConditionInput
  ) {
    createUserStatementDocuments(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      documentId
      correspondentCode
      branchCode
      documentCategory
      documentType
      taxIds
      fileName
      documentDate
      documentUrl
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserStatementDocuments = /* GraphQL */ `
  mutation UpdateUserStatementDocuments(
    $input: UpdateUserStatementDocumentsInput!
    $condition: ModelUserStatementDocumentsConditionInput
  ) {
    updateUserStatementDocuments(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      documentId
      correspondentCode
      branchCode
      documentCategory
      documentType
      taxIds
      fileName
      documentDate
      documentUrl
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserStatementDocuments = /* GraphQL */ `
  mutation DeleteUserStatementDocuments(
    $input: DeleteUserStatementDocumentsInput!
    $condition: ModelUserStatementDocumentsConditionInput
  ) {
    deleteUserStatementDocuments(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      documentId
      correspondentCode
      branchCode
      documentCategory
      documentType
      taxIds
      fileName
      documentDate
      documentUrl
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCryptoTransfer = /* GraphQL */ `
  mutation CreateCryptoTransfer(
    $input: CreateCryptoTransferInput!
    $condition: ModelCryptoTransferConditionInput
  ) {
    createCryptoTransfer(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      blockchainHash
      clientTransactionId
      currency
      quantity
      receiveAddress {
        hotWalletAddress
        coin
        __typename
      }
      userWalletAddress {
        owner
        address
        nickname
        id
        createdAt
        updatedAt
        __typename
      }
      deposit
      status
      type
      version
      createdAt
      updatedAt
      accountInformationCryptoTransferId
      __typename
    }
  }
`;
export const updateCryptoTransfer = /* GraphQL */ `
  mutation UpdateCryptoTransfer(
    $input: UpdateCryptoTransferInput!
    $condition: ModelCryptoTransferConditionInput
  ) {
    updateCryptoTransfer(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      blockchainHash
      clientTransactionId
      currency
      quantity
      receiveAddress {
        hotWalletAddress
        coin
        __typename
      }
      userWalletAddress {
        owner
        address
        nickname
        id
        createdAt
        updatedAt
        __typename
      }
      deposit
      status
      type
      version
      createdAt
      updatedAt
      accountInformationCryptoTransferId
      __typename
    }
  }
`;
export const deleteCryptoTransfer = /* GraphQL */ `
  mutation DeleteCryptoTransfer(
    $input: DeleteCryptoTransferInput!
    $condition: ModelCryptoTransferConditionInput
  ) {
    deleteCryptoTransfer(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      blockchainHash
      clientTransactionId
      currency
      quantity
      receiveAddress {
        hotWalletAddress
        coin
        __typename
      }
      userWalletAddress {
        owner
        address
        nickname
        id
        createdAt
        updatedAt
        __typename
      }
      deposit
      status
      type
      version
      createdAt
      updatedAt
      accountInformationCryptoTransferId
      __typename
    }
  }
`;
export const createUserWalletAddress = /* GraphQL */ `
  mutation CreateUserWalletAddress(
    $input: CreateUserWalletAddressInput!
    $condition: ModelUserWalletAddressConditionInput
  ) {
    createUserWalletAddress(input: $input, condition: $condition) {
      owner
      address
      nickname
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserWalletAddress = /* GraphQL */ `
  mutation UpdateUserWalletAddress(
    $input: UpdateUserWalletAddressInput!
    $condition: ModelUserWalletAddressConditionInput
  ) {
    updateUserWalletAddress(input: $input, condition: $condition) {
      owner
      address
      nickname
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserWalletAddress = /* GraphQL */ `
  mutation DeleteUserWalletAddress(
    $input: DeleteUserWalletAddressInput!
    $condition: ModelUserWalletAddressConditionInput
  ) {
    deleteUserWalletAddress(input: $input, condition: $condition) {
      owner
      address
      nickname
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createStock = /* GraphQL */ `
  mutation CreateStock(
    $input: CreateStockInput!
    $condition: ModelStockConditionInput
  ) {
    createStock(input: $input, condition: $condition) {
      id
      ttl
      symbol
      description
      country
      opol
      currency
      cfi
      priceIncrements
      tradingHours
      autocompleteWeight
      msIndustryCode
      msNaics
      msSic
      nasdaqRawType
      subtypes
      testInstrument
      options {
        items {
          id
          ttl
          underlying
          symbol
          country
          opol
          currency
          cfi
          multiplier
          spc
          mmy
          expiration
          lastTrade
          strike
          optionType
          expirationStyle
          settlementStyle
          priceIncrements
          tradingHours
          autocompleteWeight
          shortSaleRestriction
          tradingStatus
          statusReason
          haltStartTime
          haltEndTime
          high52WeekPrice
          low52WeekPrice
          highLimitPrice
          lowLimitPrice
          bidTime
          bidExchangeCode
          bidPrice
          bidSize
          askTime
          askExchangeCode
          askPrice
          askSize
          tradeTime
          tradeExchangeCode
          tradePrice
          tradeChange
          tradeSize
          tradeDayVolume
          tradeDayTurnover
          tradeTickTime
          extendedTradingHours
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirations {
        items {
          id
          ttl
          symbol
          expiration
          expirationStyle
          settlementStyle
          strikes
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      shortSaleRestriction
      tradingStatus
      statusReason
      haltStartTime
      haltEndTime
      high52WeekPrice
      low52WeekPrice
      highLimitPrice
      lowLimitPrice
      bidTime
      bidExchangeCode
      bidPrice
      bidSize
      askTime
      askExchangeCode
      askPrice
      askSize
      tradeTime
      tradeExchangeCode
      tradePrice
      tradeChange
      tradeSize
      tradeDayVolume
      tradeDayTurnover
      tradeTickTime
      extendedTradingHours
      price
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateStock = /* GraphQL */ `
  mutation UpdateStock(
    $input: UpdateStockInput!
    $condition: ModelStockConditionInput
  ) {
    updateStock(input: $input, condition: $condition) {
      id
      ttl
      symbol
      description
      country
      opol
      currency
      cfi
      priceIncrements
      tradingHours
      autocompleteWeight
      msIndustryCode
      msNaics
      msSic
      nasdaqRawType
      subtypes
      testInstrument
      options {
        items {
          id
          ttl
          underlying
          symbol
          country
          opol
          currency
          cfi
          multiplier
          spc
          mmy
          expiration
          lastTrade
          strike
          optionType
          expirationStyle
          settlementStyle
          priceIncrements
          tradingHours
          autocompleteWeight
          shortSaleRestriction
          tradingStatus
          statusReason
          haltStartTime
          haltEndTime
          high52WeekPrice
          low52WeekPrice
          highLimitPrice
          lowLimitPrice
          bidTime
          bidExchangeCode
          bidPrice
          bidSize
          askTime
          askExchangeCode
          askPrice
          askSize
          tradeTime
          tradeExchangeCode
          tradePrice
          tradeChange
          tradeSize
          tradeDayVolume
          tradeDayTurnover
          tradeTickTime
          extendedTradingHours
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirations {
        items {
          id
          ttl
          symbol
          expiration
          expirationStyle
          settlementStyle
          strikes
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      shortSaleRestriction
      tradingStatus
      statusReason
      haltStartTime
      haltEndTime
      high52WeekPrice
      low52WeekPrice
      highLimitPrice
      lowLimitPrice
      bidTime
      bidExchangeCode
      bidPrice
      bidSize
      askTime
      askExchangeCode
      askPrice
      askSize
      tradeTime
      tradeExchangeCode
      tradePrice
      tradeChange
      tradeSize
      tradeDayVolume
      tradeDayTurnover
      tradeTickTime
      extendedTradingHours
      price
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteStock = /* GraphQL */ `
  mutation DeleteStock(
    $input: DeleteStockInput!
    $condition: ModelStockConditionInput
  ) {
    deleteStock(input: $input, condition: $condition) {
      id
      ttl
      symbol
      description
      country
      opol
      currency
      cfi
      priceIncrements
      tradingHours
      autocompleteWeight
      msIndustryCode
      msNaics
      msSic
      nasdaqRawType
      subtypes
      testInstrument
      options {
        items {
          id
          ttl
          underlying
          symbol
          country
          opol
          currency
          cfi
          multiplier
          spc
          mmy
          expiration
          lastTrade
          strike
          optionType
          expirationStyle
          settlementStyle
          priceIncrements
          tradingHours
          autocompleteWeight
          shortSaleRestriction
          tradingStatus
          statusReason
          haltStartTime
          haltEndTime
          high52WeekPrice
          low52WeekPrice
          highLimitPrice
          lowLimitPrice
          bidTime
          bidExchangeCode
          bidPrice
          bidSize
          askTime
          askExchangeCode
          askPrice
          askSize
          tradeTime
          tradeExchangeCode
          tradePrice
          tradeChange
          tradeSize
          tradeDayVolume
          tradeDayTurnover
          tradeTickTime
          extendedTradingHours
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirations {
        items {
          id
          ttl
          symbol
          expiration
          expirationStyle
          settlementStyle
          strikes
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      shortSaleRestriction
      tradingStatus
      statusReason
      haltStartTime
      haltEndTime
      high52WeekPrice
      low52WeekPrice
      highLimitPrice
      lowLimitPrice
      bidTime
      bidExchangeCode
      bidPrice
      bidSize
      askTime
      askExchangeCode
      askPrice
      askSize
      tradeTime
      tradeExchangeCode
      tradePrice
      tradeChange
      tradeSize
      tradeDayVolume
      tradeDayTurnover
      tradeTickTime
      extendedTradingHours
      price
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createOptionUnderlying = /* GraphQL */ `
  mutation CreateOptionUnderlying(
    $input: CreateOptionUnderlyingInput!
    $condition: ModelOptionUnderlyingConditionInput
  ) {
    createOptionUnderlying(input: $input, condition: $condition) {
      id
      ttl
      underlying
      description
      autocompleteWeight
      price
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOptionUnderlying = /* GraphQL */ `
  mutation UpdateOptionUnderlying(
    $input: UpdateOptionUnderlyingInput!
    $condition: ModelOptionUnderlyingConditionInput
  ) {
    updateOptionUnderlying(input: $input, condition: $condition) {
      id
      ttl
      underlying
      description
      autocompleteWeight
      price
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOptionUnderlying = /* GraphQL */ `
  mutation DeleteOptionUnderlying(
    $input: DeleteOptionUnderlyingInput!
    $condition: ModelOptionUnderlyingConditionInput
  ) {
    deleteOptionUnderlying(input: $input, condition: $condition) {
      id
      ttl
      underlying
      description
      autocompleteWeight
      price
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createExpiration = /* GraphQL */ `
  mutation CreateExpiration(
    $input: CreateExpirationInput!
    $condition: ModelExpirationConditionInput
  ) {
    createExpiration(input: $input, condition: $condition) {
      id
      ttl
      symbol
      expiration
      expirationStyle
      settlementStyle
      strikes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateExpiration = /* GraphQL */ `
  mutation UpdateExpiration(
    $input: UpdateExpirationInput!
    $condition: ModelExpirationConditionInput
  ) {
    updateExpiration(input: $input, condition: $condition) {
      id
      ttl
      symbol
      expiration
      expirationStyle
      settlementStyle
      strikes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteExpiration = /* GraphQL */ `
  mutation DeleteExpiration(
    $input: DeleteExpirationInput!
    $condition: ModelExpirationConditionInput
  ) {
    deleteExpiration(input: $input, condition: $condition) {
      id
      ttl
      symbol
      expiration
      expirationStyle
      settlementStyle
      strikes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createOption = /* GraphQL */ `
  mutation CreateOption(
    $input: CreateOptionInput!
    $condition: ModelOptionConditionInput
  ) {
    createOption(input: $input, condition: $condition) {
      id
      ttl
      underlying
      symbol
      country
      opol
      currency
      cfi
      multiplier
      spc
      mmy
      expiration
      lastTrade
      strike
      optionType
      expirationStyle
      settlementStyle
      priceIncrements
      tradingHours
      autocompleteWeight
      shortSaleRestriction
      tradingStatus
      statusReason
      haltStartTime
      haltEndTime
      high52WeekPrice
      low52WeekPrice
      highLimitPrice
      lowLimitPrice
      bidTime
      bidExchangeCode
      bidPrice
      bidSize
      askTime
      askExchangeCode
      askPrice
      askSize
      tradeTime
      tradeExchangeCode
      tradePrice
      tradeChange
      tradeSize
      tradeDayVolume
      tradeDayTurnover
      tradeTickTime
      extendedTradingHours
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOption = /* GraphQL */ `
  mutation UpdateOption(
    $input: UpdateOptionInput!
    $condition: ModelOptionConditionInput
  ) {
    updateOption(input: $input, condition: $condition) {
      id
      ttl
      underlying
      symbol
      country
      opol
      currency
      cfi
      multiplier
      spc
      mmy
      expiration
      lastTrade
      strike
      optionType
      expirationStyle
      settlementStyle
      priceIncrements
      tradingHours
      autocompleteWeight
      shortSaleRestriction
      tradingStatus
      statusReason
      haltStartTime
      haltEndTime
      high52WeekPrice
      low52WeekPrice
      highLimitPrice
      lowLimitPrice
      bidTime
      bidExchangeCode
      bidPrice
      bidSize
      askTime
      askExchangeCode
      askPrice
      askSize
      tradeTime
      tradeExchangeCode
      tradePrice
      tradeChange
      tradeSize
      tradeDayVolume
      tradeDayTurnover
      tradeTickTime
      extendedTradingHours
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOption = /* GraphQL */ `
  mutation DeleteOption(
    $input: DeleteOptionInput!
    $condition: ModelOptionConditionInput
  ) {
    deleteOption(input: $input, condition: $condition) {
      id
      ttl
      underlying
      symbol
      country
      opol
      currency
      cfi
      multiplier
      spc
      mmy
      expiration
      lastTrade
      strike
      optionType
      expirationStyle
      settlementStyle
      priceIncrements
      tradingHours
      autocompleteWeight
      shortSaleRestriction
      tradingStatus
      statusReason
      haltStartTime
      haltEndTime
      high52WeekPrice
      low52WeekPrice
      highLimitPrice
      lowLimitPrice
      bidTime
      bidExchangeCode
      bidPrice
      bidSize
      askTime
      askExchangeCode
      askPrice
      askSize
      tradeTime
      tradeExchangeCode
      tradePrice
      tradeChange
      tradeSize
      tradeDayVolume
      tradeDayTurnover
      tradeTickTime
      extendedTradingHours
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createActiveAsset = /* GraphQL */ `
  mutation CreateActiveAsset(
    $input: CreateActiveAssetInput!
    $condition: ModelActiveAssetConditionInput
  ) {
    createActiveAsset(input: $input, condition: $condition) {
      id
      symbol
      underlying
      expiration
      updatedAt
      createdAt
      __typename
    }
  }
`;
export const updateActiveAsset = /* GraphQL */ `
  mutation UpdateActiveAsset(
    $input: UpdateActiveAssetInput!
    $condition: ModelActiveAssetConditionInput
  ) {
    updateActiveAsset(input: $input, condition: $condition) {
      id
      symbol
      underlying
      expiration
      updatedAt
      createdAt
      __typename
    }
  }
`;
export const deleteActiveAsset = /* GraphQL */ `
  mutation DeleteActiveAsset(
    $input: DeleteActiveAssetInput!
    $condition: ModelActiveAssetConditionInput
  ) {
    deleteActiveAsset(input: $input, condition: $condition) {
      id
      symbol
      underlying
      expiration
      updatedAt
      createdAt
      __typename
    }
  }
`;
export const createCryptoAsset = /* GraphQL */ `
  mutation CreateCryptoAsset(
    $input: CreateCryptoAssetInput!
    $condition: ModelCryptoAssetConditionInput
  ) {
    createCryptoAsset(input: $input, condition: $condition) {
      id
      symbol
      updatedAt
      createdAt
      bid
      ask
      bidSize
      askSize
      __typename
    }
  }
`;
export const updateCryptoAsset = /* GraphQL */ `
  mutation UpdateCryptoAsset(
    $input: UpdateCryptoAssetInput!
    $condition: ModelCryptoAssetConditionInput
  ) {
    updateCryptoAsset(input: $input, condition: $condition) {
      id
      symbol
      updatedAt
      createdAt
      bid
      ask
      bidSize
      askSize
      __typename
    }
  }
`;
export const deleteCryptoAsset = /* GraphQL */ `
  mutation DeleteCryptoAsset(
    $input: DeleteCryptoAssetInput!
    $condition: ModelCryptoAssetConditionInput
  ) {
    deleteCryptoAsset(input: $input, condition: $condition) {
      id
      symbol
      updatedAt
      createdAt
      bid
      ask
      bidSize
      askSize
      __typename
    }
  }
`;
export const createNewsLetter = /* GraphQL */ `
  mutation CreateNewsLetter(
    $input: CreateNewsLetterInput!
    $condition: ModelNewsLetterConditionInput
  ) {
    createNewsLetter(input: $input, condition: $condition) {
      id
      newsLetter
      portfolios
      subAccountNumbers
      deleted
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateNewsLetter = /* GraphQL */ `
  mutation UpdateNewsLetter(
    $input: UpdateNewsLetterInput!
    $condition: ModelNewsLetterConditionInput
  ) {
    updateNewsLetter(input: $input, condition: $condition) {
      id
      newsLetter
      portfolios
      subAccountNumbers
      deleted
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteNewsLetter = /* GraphQL */ `
  mutation DeleteNewsLetter(
    $input: DeleteNewsLetterInput!
    $condition: ModelNewsLetterConditionInput
  ) {
    deleteNewsLetter(input: $input, condition: $condition) {
      id
      newsLetter
      portfolios
      subAccountNumbers
      deleted
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createActiveAssetsFeed = /* GraphQL */ `
  mutation CreateActiveAssetsFeed(
    $input: CreateActiveAssetsFeedInput!
    $condition: ModelActiveAssetsFeedConditionInput
  ) {
    createActiveAssetsFeed(input: $input, condition: $condition) {
      symbol
      timestamp
      bidPrice
      askPrice
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createGroupUpload = /* GraphQL */ `
  mutation CreateGroupUpload(
    $input: CreateGroupUploadInput!
    $condition: ModelGroupUploadConditionInput
  ) {
    createGroupUpload(input: $input, condition: $condition) {
      id
      name
      description
      orders {
        items {
          id
          groupUploadOrdersId
          accountNumber
          quantity
          brokerOverride
          commission
          owner
          userOrder {
            id
            accountNumber
            owner
            subAccountNumber
            cancel
            cancelReplace
            createdDate
            updatedDate
            commission
            feesAndCommission
            symbol
            side
            brokerSkipChecks
            brokerOverride
            brokerId
            quantity
            limitPrice
            stopPrice
            stockValue
            originalOrderId
            strategy
            avgPx
            orderType
            timeInForce
            instruction
            userOrderLegs {
              legType
              side
              quantity
              expiration
              strike
              openClose
              bid
              ask
              sharesPerContract
              avgPx
              __typename
            }
            cashSecured
            cashSecuredAmount
            message
            submitStatus
            status
            executionReports {
              items {
                id
                owner
                accountInformationId
                subAccountNumber
                orderID
                executionIncrementId
                secondaryOrderID
                clOrdID
                origClOrdID
                clientID
                execBroker
                listID
                execID
                execTransType
                execRefID
                execType
                ordStatus
                ordRejReason
                execRestatementReason
                account
                settlmntTyp
                futSettDate
                symbol
                symbolSfx
                securityID
                iDSource
                securityType
                maturityMonthYear
                maturityDay
                putOrCall
                strikePrice
                optAttribute
                contractMultiplier
                couponRate
                securityExchange
                issuer
                encodedIssuerLen
                encodedIssuer
                securityDesc
                encodedSecurityDescLen
                encodedSecurityDesc
                side
                orderQty
                cashOrderQty
                ordType
                price
                stopPx
                pegDifference
                discretionInst
                discretionOffset
                currency
                complianceID
                solicitedFlag
                timeInForce
                effectiveTime
                expireDate
                expireTime
                execInst
                rule80A
                lastShares
                lastPx
                lastSpotRate
                lastForwardPoints
                lastMkt
                tradingSessionID
                lastCapacity
                leavesQty
                cumQty
                avgPx
                dayOrderQty
                dayCumQty
                dayAvgPx
                gTBookingInst
                tradeDate
                transactTime
                reportToExch
                commission
                commType
                grossTradeAmt
                settlCurrAmt
                settlCurrency
                settlCurrFxRate
                settlCurrFxRateCalc
                handlInst
                minQty
                maxFloor
                openClose
                maxShow
                text
                encodedTextLen
                encodedText
                futSettDate2
                orderQty2
                clearingFirm
                clearingAccount
                multiLegReportingType
                legRefId
                uploadedToBackoffice
                fixMessage
                isAllocation
                groupUploadId
                processedAt
                createdDate
                createdAt
                updatedAt
                userOrderExecutionReportsId
                groupOrderExecutionReportsId
                __typename
              }
              nextToken
              __typename
            }
            cryptoOrder
            groupUploadOrderId
            reviewStatus
            createdAt
            updatedAt
            groupUpload {
              id
              name
              description
              orders {
                items {
                  id
                  groupUploadOrdersId
                  accountNumber
                  quantity
                  brokerOverride
                  commission
                  owner
                  userOrder {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  accountInformationId
                  failed
                  failedReason
                  orderIds
                  createdDate
                  createdAt
                  updatedAt
                  groupUploadOrderUserOrderId
                  __typename
                }
                nextToken
                __typename
              }
              owner
              isPlaced
              isPlacedString
              isAvgPx
              createdAt
              updatedAt
              __typename
            }
            accountInformationUserOrdersId
            userOrderGroupUploadId
            __typename
          }
          accountInformationId
          failed
          failedReason
          orderIds
          createdDate
          createdAt
          updatedAt
          groupUploadOrderUserOrderId
          __typename
        }
        nextToken
        __typename
      }
      owner
      isPlaced
      isPlacedString
      isAvgPx
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateGroupUpload = /* GraphQL */ `
  mutation UpdateGroupUpload(
    $input: UpdateGroupUploadInput!
    $condition: ModelGroupUploadConditionInput
  ) {
    updateGroupUpload(input: $input, condition: $condition) {
      id
      name
      description
      orders {
        items {
          id
          groupUploadOrdersId
          accountNumber
          quantity
          brokerOverride
          commission
          owner
          userOrder {
            id
            accountNumber
            owner
            subAccountNumber
            cancel
            cancelReplace
            createdDate
            updatedDate
            commission
            feesAndCommission
            symbol
            side
            brokerSkipChecks
            brokerOverride
            brokerId
            quantity
            limitPrice
            stopPrice
            stockValue
            originalOrderId
            strategy
            avgPx
            orderType
            timeInForce
            instruction
            userOrderLegs {
              legType
              side
              quantity
              expiration
              strike
              openClose
              bid
              ask
              sharesPerContract
              avgPx
              __typename
            }
            cashSecured
            cashSecuredAmount
            message
            submitStatus
            status
            executionReports {
              items {
                id
                owner
                accountInformationId
                subAccountNumber
                orderID
                executionIncrementId
                secondaryOrderID
                clOrdID
                origClOrdID
                clientID
                execBroker
                listID
                execID
                execTransType
                execRefID
                execType
                ordStatus
                ordRejReason
                execRestatementReason
                account
                settlmntTyp
                futSettDate
                symbol
                symbolSfx
                securityID
                iDSource
                securityType
                maturityMonthYear
                maturityDay
                putOrCall
                strikePrice
                optAttribute
                contractMultiplier
                couponRate
                securityExchange
                issuer
                encodedIssuerLen
                encodedIssuer
                securityDesc
                encodedSecurityDescLen
                encodedSecurityDesc
                side
                orderQty
                cashOrderQty
                ordType
                price
                stopPx
                pegDifference
                discretionInst
                discretionOffset
                currency
                complianceID
                solicitedFlag
                timeInForce
                effectiveTime
                expireDate
                expireTime
                execInst
                rule80A
                lastShares
                lastPx
                lastSpotRate
                lastForwardPoints
                lastMkt
                tradingSessionID
                lastCapacity
                leavesQty
                cumQty
                avgPx
                dayOrderQty
                dayCumQty
                dayAvgPx
                gTBookingInst
                tradeDate
                transactTime
                reportToExch
                commission
                commType
                grossTradeAmt
                settlCurrAmt
                settlCurrency
                settlCurrFxRate
                settlCurrFxRateCalc
                handlInst
                minQty
                maxFloor
                openClose
                maxShow
                text
                encodedTextLen
                encodedText
                futSettDate2
                orderQty2
                clearingFirm
                clearingAccount
                multiLegReportingType
                legRefId
                uploadedToBackoffice
                fixMessage
                isAllocation
                groupUploadId
                processedAt
                createdDate
                createdAt
                updatedAt
                userOrderExecutionReportsId
                groupOrderExecutionReportsId
                __typename
              }
              nextToken
              __typename
            }
            cryptoOrder
            groupUploadOrderId
            reviewStatus
            createdAt
            updatedAt
            groupUpload {
              id
              name
              description
              orders {
                items {
                  id
                  groupUploadOrdersId
                  accountNumber
                  quantity
                  brokerOverride
                  commission
                  owner
                  userOrder {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  accountInformationId
                  failed
                  failedReason
                  orderIds
                  createdDate
                  createdAt
                  updatedAt
                  groupUploadOrderUserOrderId
                  __typename
                }
                nextToken
                __typename
              }
              owner
              isPlaced
              isPlacedString
              isAvgPx
              createdAt
              updatedAt
              __typename
            }
            accountInformationUserOrdersId
            userOrderGroupUploadId
            __typename
          }
          accountInformationId
          failed
          failedReason
          orderIds
          createdDate
          createdAt
          updatedAt
          groupUploadOrderUserOrderId
          __typename
        }
        nextToken
        __typename
      }
      owner
      isPlaced
      isPlacedString
      isAvgPx
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteGroupUpload = /* GraphQL */ `
  mutation DeleteGroupUpload(
    $input: DeleteGroupUploadInput!
    $condition: ModelGroupUploadConditionInput
  ) {
    deleteGroupUpload(input: $input, condition: $condition) {
      id
      name
      description
      orders {
        items {
          id
          groupUploadOrdersId
          accountNumber
          quantity
          brokerOverride
          commission
          owner
          userOrder {
            id
            accountNumber
            owner
            subAccountNumber
            cancel
            cancelReplace
            createdDate
            updatedDate
            commission
            feesAndCommission
            symbol
            side
            brokerSkipChecks
            brokerOverride
            brokerId
            quantity
            limitPrice
            stopPrice
            stockValue
            originalOrderId
            strategy
            avgPx
            orderType
            timeInForce
            instruction
            userOrderLegs {
              legType
              side
              quantity
              expiration
              strike
              openClose
              bid
              ask
              sharesPerContract
              avgPx
              __typename
            }
            cashSecured
            cashSecuredAmount
            message
            submitStatus
            status
            executionReports {
              items {
                id
                owner
                accountInformationId
                subAccountNumber
                orderID
                executionIncrementId
                secondaryOrderID
                clOrdID
                origClOrdID
                clientID
                execBroker
                listID
                execID
                execTransType
                execRefID
                execType
                ordStatus
                ordRejReason
                execRestatementReason
                account
                settlmntTyp
                futSettDate
                symbol
                symbolSfx
                securityID
                iDSource
                securityType
                maturityMonthYear
                maturityDay
                putOrCall
                strikePrice
                optAttribute
                contractMultiplier
                couponRate
                securityExchange
                issuer
                encodedIssuerLen
                encodedIssuer
                securityDesc
                encodedSecurityDescLen
                encodedSecurityDesc
                side
                orderQty
                cashOrderQty
                ordType
                price
                stopPx
                pegDifference
                discretionInst
                discretionOffset
                currency
                complianceID
                solicitedFlag
                timeInForce
                effectiveTime
                expireDate
                expireTime
                execInst
                rule80A
                lastShares
                lastPx
                lastSpotRate
                lastForwardPoints
                lastMkt
                tradingSessionID
                lastCapacity
                leavesQty
                cumQty
                avgPx
                dayOrderQty
                dayCumQty
                dayAvgPx
                gTBookingInst
                tradeDate
                transactTime
                reportToExch
                commission
                commType
                grossTradeAmt
                settlCurrAmt
                settlCurrency
                settlCurrFxRate
                settlCurrFxRateCalc
                handlInst
                minQty
                maxFloor
                openClose
                maxShow
                text
                encodedTextLen
                encodedText
                futSettDate2
                orderQty2
                clearingFirm
                clearingAccount
                multiLegReportingType
                legRefId
                uploadedToBackoffice
                fixMessage
                isAllocation
                groupUploadId
                processedAt
                createdDate
                createdAt
                updatedAt
                userOrderExecutionReportsId
                groupOrderExecutionReportsId
                __typename
              }
              nextToken
              __typename
            }
            cryptoOrder
            groupUploadOrderId
            reviewStatus
            createdAt
            updatedAt
            groupUpload {
              id
              name
              description
              orders {
                items {
                  id
                  groupUploadOrdersId
                  accountNumber
                  quantity
                  brokerOverride
                  commission
                  owner
                  userOrder {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  accountInformationId
                  failed
                  failedReason
                  orderIds
                  createdDate
                  createdAt
                  updatedAt
                  groupUploadOrderUserOrderId
                  __typename
                }
                nextToken
                __typename
              }
              owner
              isPlaced
              isPlacedString
              isAvgPx
              createdAt
              updatedAt
              __typename
            }
            accountInformationUserOrdersId
            userOrderGroupUploadId
            __typename
          }
          accountInformationId
          failed
          failedReason
          orderIds
          createdDate
          createdAt
          updatedAt
          groupUploadOrderUserOrderId
          __typename
        }
        nextToken
        __typename
      }
      owner
      isPlaced
      isPlacedString
      isAvgPx
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createGroupUploadOrder = /* GraphQL */ `
  mutation CreateGroupUploadOrder(
    $input: CreateGroupUploadOrderInput!
    $condition: ModelGroupUploadOrderConditionInput
  ) {
    createGroupUploadOrder(input: $input, condition: $condition) {
      id
      groupUploadOrdersId
      accountNumber
      quantity
      brokerOverride
      commission
      owner
      userOrder {
        id
        accountNumber
        owner
        subAccountNumber
        cancel
        cancelReplace
        createdDate
        updatedDate
        commission
        feesAndCommission
        symbol
        side
        brokerSkipChecks
        brokerOverride
        brokerId
        quantity
        limitPrice
        stopPrice
        stockValue
        originalOrderId
        strategy
        avgPx
        orderType
        timeInForce
        instruction
        userOrderLegs {
          legType
          side
          quantity
          expiration
          strike
          openClose
          bid
          ask
          sharesPerContract
          avgPx
          __typename
        }
        cashSecured
        cashSecuredAmount
        message
        submitStatus
        status
        executionReports {
          items {
            id
            owner
            accountInformationId
            subAccountNumber
            orderID
            executionIncrementId
            secondaryOrderID
            clOrdID
            origClOrdID
            clientID
            execBroker
            listID
            execID
            execTransType
            execRefID
            execType
            ordStatus
            ordRejReason
            execRestatementReason
            account
            settlmntTyp
            futSettDate
            symbol
            symbolSfx
            securityID
            iDSource
            securityType
            maturityMonthYear
            maturityDay
            putOrCall
            strikePrice
            optAttribute
            contractMultiplier
            couponRate
            securityExchange
            issuer
            encodedIssuerLen
            encodedIssuer
            securityDesc
            encodedSecurityDescLen
            encodedSecurityDesc
            side
            orderQty
            cashOrderQty
            ordType
            price
            stopPx
            pegDifference
            discretionInst
            discretionOffset
            currency
            complianceID
            solicitedFlag
            timeInForce
            effectiveTime
            expireDate
            expireTime
            execInst
            rule80A
            lastShares
            lastPx
            lastSpotRate
            lastForwardPoints
            lastMkt
            tradingSessionID
            lastCapacity
            leavesQty
            cumQty
            avgPx
            dayOrderQty
            dayCumQty
            dayAvgPx
            gTBookingInst
            tradeDate
            transactTime
            reportToExch
            commission
            commType
            grossTradeAmt
            settlCurrAmt
            settlCurrency
            settlCurrFxRate
            settlCurrFxRateCalc
            handlInst
            minQty
            maxFloor
            openClose
            maxShow
            text
            encodedTextLen
            encodedText
            futSettDate2
            orderQty2
            clearingFirm
            clearingAccount
            multiLegReportingType
            legRefId
            uploadedToBackoffice
            fixMessage
            isAllocation
            groupUploadId
            processedAt
            createdDate
            createdAt
            updatedAt
            userOrderExecutionReportsId
            groupOrderExecutionReportsId
            __typename
          }
          nextToken
          __typename
        }
        cryptoOrder
        groupUploadOrderId
        reviewStatus
        createdAt
        updatedAt
        groupUpload {
          id
          name
          description
          orders {
            items {
              id
              groupUploadOrdersId
              accountNumber
              quantity
              brokerOverride
              commission
              owner
              userOrder {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              accountInformationId
              failed
              failedReason
              orderIds
              createdDate
              createdAt
              updatedAt
              groupUploadOrderUserOrderId
              __typename
            }
            nextToken
            __typename
          }
          owner
          isPlaced
          isPlacedString
          isAvgPx
          createdAt
          updatedAt
          __typename
        }
        accountInformationUserOrdersId
        userOrderGroupUploadId
        __typename
      }
      accountInformationId
      failed
      failedReason
      orderIds
      createdDate
      createdAt
      updatedAt
      groupUploadOrderUserOrderId
      __typename
    }
  }
`;
export const updateGroupUploadOrder = /* GraphQL */ `
  mutation UpdateGroupUploadOrder(
    $input: UpdateGroupUploadOrderInput!
    $condition: ModelGroupUploadOrderConditionInput
  ) {
    updateGroupUploadOrder(input: $input, condition: $condition) {
      id
      groupUploadOrdersId
      accountNumber
      quantity
      brokerOverride
      commission
      owner
      userOrder {
        id
        accountNumber
        owner
        subAccountNumber
        cancel
        cancelReplace
        createdDate
        updatedDate
        commission
        feesAndCommission
        symbol
        side
        brokerSkipChecks
        brokerOverride
        brokerId
        quantity
        limitPrice
        stopPrice
        stockValue
        originalOrderId
        strategy
        avgPx
        orderType
        timeInForce
        instruction
        userOrderLegs {
          legType
          side
          quantity
          expiration
          strike
          openClose
          bid
          ask
          sharesPerContract
          avgPx
          __typename
        }
        cashSecured
        cashSecuredAmount
        message
        submitStatus
        status
        executionReports {
          items {
            id
            owner
            accountInformationId
            subAccountNumber
            orderID
            executionIncrementId
            secondaryOrderID
            clOrdID
            origClOrdID
            clientID
            execBroker
            listID
            execID
            execTransType
            execRefID
            execType
            ordStatus
            ordRejReason
            execRestatementReason
            account
            settlmntTyp
            futSettDate
            symbol
            symbolSfx
            securityID
            iDSource
            securityType
            maturityMonthYear
            maturityDay
            putOrCall
            strikePrice
            optAttribute
            contractMultiplier
            couponRate
            securityExchange
            issuer
            encodedIssuerLen
            encodedIssuer
            securityDesc
            encodedSecurityDescLen
            encodedSecurityDesc
            side
            orderQty
            cashOrderQty
            ordType
            price
            stopPx
            pegDifference
            discretionInst
            discretionOffset
            currency
            complianceID
            solicitedFlag
            timeInForce
            effectiveTime
            expireDate
            expireTime
            execInst
            rule80A
            lastShares
            lastPx
            lastSpotRate
            lastForwardPoints
            lastMkt
            tradingSessionID
            lastCapacity
            leavesQty
            cumQty
            avgPx
            dayOrderQty
            dayCumQty
            dayAvgPx
            gTBookingInst
            tradeDate
            transactTime
            reportToExch
            commission
            commType
            grossTradeAmt
            settlCurrAmt
            settlCurrency
            settlCurrFxRate
            settlCurrFxRateCalc
            handlInst
            minQty
            maxFloor
            openClose
            maxShow
            text
            encodedTextLen
            encodedText
            futSettDate2
            orderQty2
            clearingFirm
            clearingAccount
            multiLegReportingType
            legRefId
            uploadedToBackoffice
            fixMessage
            isAllocation
            groupUploadId
            processedAt
            createdDate
            createdAt
            updatedAt
            userOrderExecutionReportsId
            groupOrderExecutionReportsId
            __typename
          }
          nextToken
          __typename
        }
        cryptoOrder
        groupUploadOrderId
        reviewStatus
        createdAt
        updatedAt
        groupUpload {
          id
          name
          description
          orders {
            items {
              id
              groupUploadOrdersId
              accountNumber
              quantity
              brokerOverride
              commission
              owner
              userOrder {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              accountInformationId
              failed
              failedReason
              orderIds
              createdDate
              createdAt
              updatedAt
              groupUploadOrderUserOrderId
              __typename
            }
            nextToken
            __typename
          }
          owner
          isPlaced
          isPlacedString
          isAvgPx
          createdAt
          updatedAt
          __typename
        }
        accountInformationUserOrdersId
        userOrderGroupUploadId
        __typename
      }
      accountInformationId
      failed
      failedReason
      orderIds
      createdDate
      createdAt
      updatedAt
      groupUploadOrderUserOrderId
      __typename
    }
  }
`;
export const deleteGroupUploadOrder = /* GraphQL */ `
  mutation DeleteGroupUploadOrder(
    $input: DeleteGroupUploadOrderInput!
    $condition: ModelGroupUploadOrderConditionInput
  ) {
    deleteGroupUploadOrder(input: $input, condition: $condition) {
      id
      groupUploadOrdersId
      accountNumber
      quantity
      brokerOverride
      commission
      owner
      userOrder {
        id
        accountNumber
        owner
        subAccountNumber
        cancel
        cancelReplace
        createdDate
        updatedDate
        commission
        feesAndCommission
        symbol
        side
        brokerSkipChecks
        brokerOverride
        brokerId
        quantity
        limitPrice
        stopPrice
        stockValue
        originalOrderId
        strategy
        avgPx
        orderType
        timeInForce
        instruction
        userOrderLegs {
          legType
          side
          quantity
          expiration
          strike
          openClose
          bid
          ask
          sharesPerContract
          avgPx
          __typename
        }
        cashSecured
        cashSecuredAmount
        message
        submitStatus
        status
        executionReports {
          items {
            id
            owner
            accountInformationId
            subAccountNumber
            orderID
            executionIncrementId
            secondaryOrderID
            clOrdID
            origClOrdID
            clientID
            execBroker
            listID
            execID
            execTransType
            execRefID
            execType
            ordStatus
            ordRejReason
            execRestatementReason
            account
            settlmntTyp
            futSettDate
            symbol
            symbolSfx
            securityID
            iDSource
            securityType
            maturityMonthYear
            maturityDay
            putOrCall
            strikePrice
            optAttribute
            contractMultiplier
            couponRate
            securityExchange
            issuer
            encodedIssuerLen
            encodedIssuer
            securityDesc
            encodedSecurityDescLen
            encodedSecurityDesc
            side
            orderQty
            cashOrderQty
            ordType
            price
            stopPx
            pegDifference
            discretionInst
            discretionOffset
            currency
            complianceID
            solicitedFlag
            timeInForce
            effectiveTime
            expireDate
            expireTime
            execInst
            rule80A
            lastShares
            lastPx
            lastSpotRate
            lastForwardPoints
            lastMkt
            tradingSessionID
            lastCapacity
            leavesQty
            cumQty
            avgPx
            dayOrderQty
            dayCumQty
            dayAvgPx
            gTBookingInst
            tradeDate
            transactTime
            reportToExch
            commission
            commType
            grossTradeAmt
            settlCurrAmt
            settlCurrency
            settlCurrFxRate
            settlCurrFxRateCalc
            handlInst
            minQty
            maxFloor
            openClose
            maxShow
            text
            encodedTextLen
            encodedText
            futSettDate2
            orderQty2
            clearingFirm
            clearingAccount
            multiLegReportingType
            legRefId
            uploadedToBackoffice
            fixMessage
            isAllocation
            groupUploadId
            processedAt
            createdDate
            createdAt
            updatedAt
            userOrderExecutionReportsId
            groupOrderExecutionReportsId
            __typename
          }
          nextToken
          __typename
        }
        cryptoOrder
        groupUploadOrderId
        reviewStatus
        createdAt
        updatedAt
        groupUpload {
          id
          name
          description
          orders {
            items {
              id
              groupUploadOrdersId
              accountNumber
              quantity
              brokerOverride
              commission
              owner
              userOrder {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              accountInformationId
              failed
              failedReason
              orderIds
              createdDate
              createdAt
              updatedAt
              groupUploadOrderUserOrderId
              __typename
            }
            nextToken
            __typename
          }
          owner
          isPlaced
          isPlacedString
          isAvgPx
          createdAt
          updatedAt
          __typename
        }
        accountInformationUserOrdersId
        userOrderGroupUploadId
        __typename
      }
      accountInformationId
      failed
      failedReason
      orderIds
      createdDate
      createdAt
      updatedAt
      groupUploadOrderUserOrderId
      __typename
    }
  }
`;
export const createUserOrder = /* GraphQL */ `
  mutation CreateUserOrder(
    $input: CreateUserOrderInput!
    $condition: ModelUserOrderConditionInput
  ) {
    createUserOrder(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      subAccountNumber
      cancel
      cancelReplace
      createdDate
      updatedDate
      commission
      feesAndCommission
      symbol
      side
      brokerSkipChecks
      brokerOverride
      brokerId
      quantity
      limitPrice
      stopPrice
      stockValue
      originalOrderId
      strategy
      avgPx
      orderType
      timeInForce
      instruction
      userOrderLegs {
        legType
        side
        quantity
        expiration
        strike
        openClose
        bid
        ask
        sharesPerContract
        avgPx
        __typename
      }
      cashSecured
      cashSecuredAmount
      message
      submitStatus
      status
      executionReports {
        items {
          id
          owner
          accountInformationId
          subAccountNumber
          orderID
          executionIncrementId
          secondaryOrderID
          clOrdID
          origClOrdID
          clientID
          execBroker
          listID
          execID
          execTransType
          execRefID
          execType
          ordStatus
          ordRejReason
          execRestatementReason
          account
          settlmntTyp
          futSettDate
          symbol
          symbolSfx
          securityID
          iDSource
          securityType
          maturityMonthYear
          maturityDay
          putOrCall
          strikePrice
          optAttribute
          contractMultiplier
          couponRate
          securityExchange
          issuer
          encodedIssuerLen
          encodedIssuer
          securityDesc
          encodedSecurityDescLen
          encodedSecurityDesc
          side
          orderQty
          cashOrderQty
          ordType
          price
          stopPx
          pegDifference
          discretionInst
          discretionOffset
          currency
          complianceID
          solicitedFlag
          timeInForce
          effectiveTime
          expireDate
          expireTime
          execInst
          rule80A
          lastShares
          lastPx
          lastSpotRate
          lastForwardPoints
          lastMkt
          tradingSessionID
          lastCapacity
          leavesQty
          cumQty
          avgPx
          dayOrderQty
          dayCumQty
          dayAvgPx
          gTBookingInst
          tradeDate
          transactTime
          reportToExch
          commission
          commType
          grossTradeAmt
          settlCurrAmt
          settlCurrency
          settlCurrFxRate
          settlCurrFxRateCalc
          handlInst
          minQty
          maxFloor
          openClose
          maxShow
          text
          encodedTextLen
          encodedText
          futSettDate2
          orderQty2
          clearingFirm
          clearingAccount
          multiLegReportingType
          legRefId
          uploadedToBackoffice
          fixMessage
          isAllocation
          groupUploadId
          processedAt
          createdDate
          createdAt
          updatedAt
          userOrderExecutionReportsId
          groupOrderExecutionReportsId
          __typename
        }
        nextToken
        __typename
      }
      cryptoOrder
      groupUploadOrderId
      reviewStatus
      createdAt
      updatedAt
      groupUpload {
        id
        name
        description
        orders {
          items {
            id
            groupUploadOrdersId
            accountNumber
            quantity
            brokerOverride
            commission
            owner
            userOrder {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            accountInformationId
            failed
            failedReason
            orderIds
            createdDate
            createdAt
            updatedAt
            groupUploadOrderUserOrderId
            __typename
          }
          nextToken
          __typename
        }
        owner
        isPlaced
        isPlacedString
        isAvgPx
        createdAt
        updatedAt
        __typename
      }
      accountInformationUserOrdersId
      userOrderGroupUploadId
      __typename
    }
  }
`;
export const updateUserOrder = /* GraphQL */ `
  mutation UpdateUserOrder(
    $input: UpdateUserOrderInput!
    $condition: ModelUserOrderConditionInput
  ) {
    updateUserOrder(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      subAccountNumber
      cancel
      cancelReplace
      createdDate
      updatedDate
      commission
      feesAndCommission
      symbol
      side
      brokerSkipChecks
      brokerOverride
      brokerId
      quantity
      limitPrice
      stopPrice
      stockValue
      originalOrderId
      strategy
      avgPx
      orderType
      timeInForce
      instruction
      userOrderLegs {
        legType
        side
        quantity
        expiration
        strike
        openClose
        bid
        ask
        sharesPerContract
        avgPx
        __typename
      }
      cashSecured
      cashSecuredAmount
      message
      submitStatus
      status
      executionReports {
        items {
          id
          owner
          accountInformationId
          subAccountNumber
          orderID
          executionIncrementId
          secondaryOrderID
          clOrdID
          origClOrdID
          clientID
          execBroker
          listID
          execID
          execTransType
          execRefID
          execType
          ordStatus
          ordRejReason
          execRestatementReason
          account
          settlmntTyp
          futSettDate
          symbol
          symbolSfx
          securityID
          iDSource
          securityType
          maturityMonthYear
          maturityDay
          putOrCall
          strikePrice
          optAttribute
          contractMultiplier
          couponRate
          securityExchange
          issuer
          encodedIssuerLen
          encodedIssuer
          securityDesc
          encodedSecurityDescLen
          encodedSecurityDesc
          side
          orderQty
          cashOrderQty
          ordType
          price
          stopPx
          pegDifference
          discretionInst
          discretionOffset
          currency
          complianceID
          solicitedFlag
          timeInForce
          effectiveTime
          expireDate
          expireTime
          execInst
          rule80A
          lastShares
          lastPx
          lastSpotRate
          lastForwardPoints
          lastMkt
          tradingSessionID
          lastCapacity
          leavesQty
          cumQty
          avgPx
          dayOrderQty
          dayCumQty
          dayAvgPx
          gTBookingInst
          tradeDate
          transactTime
          reportToExch
          commission
          commType
          grossTradeAmt
          settlCurrAmt
          settlCurrency
          settlCurrFxRate
          settlCurrFxRateCalc
          handlInst
          minQty
          maxFloor
          openClose
          maxShow
          text
          encodedTextLen
          encodedText
          futSettDate2
          orderQty2
          clearingFirm
          clearingAccount
          multiLegReportingType
          legRefId
          uploadedToBackoffice
          fixMessage
          isAllocation
          groupUploadId
          processedAt
          createdDate
          createdAt
          updatedAt
          userOrderExecutionReportsId
          groupOrderExecutionReportsId
          __typename
        }
        nextToken
        __typename
      }
      cryptoOrder
      groupUploadOrderId
      reviewStatus
      createdAt
      updatedAt
      groupUpload {
        id
        name
        description
        orders {
          items {
            id
            groupUploadOrdersId
            accountNumber
            quantity
            brokerOverride
            commission
            owner
            userOrder {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            accountInformationId
            failed
            failedReason
            orderIds
            createdDate
            createdAt
            updatedAt
            groupUploadOrderUserOrderId
            __typename
          }
          nextToken
          __typename
        }
        owner
        isPlaced
        isPlacedString
        isAvgPx
        createdAt
        updatedAt
        __typename
      }
      accountInformationUserOrdersId
      userOrderGroupUploadId
      __typename
    }
  }
`;
export const deleteUserOrder = /* GraphQL */ `
  mutation DeleteUserOrder(
    $input: DeleteUserOrderInput!
    $condition: ModelUserOrderConditionInput
  ) {
    deleteUserOrder(input: $input, condition: $condition) {
      id
      accountNumber
      owner
      subAccountNumber
      cancel
      cancelReplace
      createdDate
      updatedDate
      commission
      feesAndCommission
      symbol
      side
      brokerSkipChecks
      brokerOverride
      brokerId
      quantity
      limitPrice
      stopPrice
      stockValue
      originalOrderId
      strategy
      avgPx
      orderType
      timeInForce
      instruction
      userOrderLegs {
        legType
        side
        quantity
        expiration
        strike
        openClose
        bid
        ask
        sharesPerContract
        avgPx
        __typename
      }
      cashSecured
      cashSecuredAmount
      message
      submitStatus
      status
      executionReports {
        items {
          id
          owner
          accountInformationId
          subAccountNumber
          orderID
          executionIncrementId
          secondaryOrderID
          clOrdID
          origClOrdID
          clientID
          execBroker
          listID
          execID
          execTransType
          execRefID
          execType
          ordStatus
          ordRejReason
          execRestatementReason
          account
          settlmntTyp
          futSettDate
          symbol
          symbolSfx
          securityID
          iDSource
          securityType
          maturityMonthYear
          maturityDay
          putOrCall
          strikePrice
          optAttribute
          contractMultiplier
          couponRate
          securityExchange
          issuer
          encodedIssuerLen
          encodedIssuer
          securityDesc
          encodedSecurityDescLen
          encodedSecurityDesc
          side
          orderQty
          cashOrderQty
          ordType
          price
          stopPx
          pegDifference
          discretionInst
          discretionOffset
          currency
          complianceID
          solicitedFlag
          timeInForce
          effectiveTime
          expireDate
          expireTime
          execInst
          rule80A
          lastShares
          lastPx
          lastSpotRate
          lastForwardPoints
          lastMkt
          tradingSessionID
          lastCapacity
          leavesQty
          cumQty
          avgPx
          dayOrderQty
          dayCumQty
          dayAvgPx
          gTBookingInst
          tradeDate
          transactTime
          reportToExch
          commission
          commType
          grossTradeAmt
          settlCurrAmt
          settlCurrency
          settlCurrFxRate
          settlCurrFxRateCalc
          handlInst
          minQty
          maxFloor
          openClose
          maxShow
          text
          encodedTextLen
          encodedText
          futSettDate2
          orderQty2
          clearingFirm
          clearingAccount
          multiLegReportingType
          legRefId
          uploadedToBackoffice
          fixMessage
          isAllocation
          groupUploadId
          processedAt
          createdDate
          createdAt
          updatedAt
          userOrderExecutionReportsId
          groupOrderExecutionReportsId
          __typename
        }
        nextToken
        __typename
      }
      cryptoOrder
      groupUploadOrderId
      reviewStatus
      createdAt
      updatedAt
      groupUpload {
        id
        name
        description
        orders {
          items {
            id
            groupUploadOrdersId
            accountNumber
            quantity
            brokerOverride
            commission
            owner
            userOrder {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            accountInformationId
            failed
            failedReason
            orderIds
            createdDate
            createdAt
            updatedAt
            groupUploadOrderUserOrderId
            __typename
          }
          nextToken
          __typename
        }
        owner
        isPlaced
        isPlacedString
        isAvgPx
        createdAt
        updatedAt
        __typename
      }
      accountInformationUserOrdersId
      userOrderGroupUploadId
      __typename
    }
  }
`;
export const createOrder = /* GraphQL */ `
  mutation CreateOrder(
    $input: CreateOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    createOrder(input: $input, condition: $condition) {
      id
      owner
      accountNumber
      subAccountNumber
      side
      accountInformationId
      orderIncrementId
      symbol
      feesAndCommission
      cancel
      cancelReplace
      quantity
      limitPrice
      stopPrice
      orderType
      timeInForce
      instruction
      originalOrderId
      orderStatus
      orderLeg {
        ratioQuantity
        legType
        side
        openClose
        expiration
        strike
        price
        __typename
      }
      userOrderId
      tradeAmount
      marginRequirement
      apexFdid
      apexCatAccountholderType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOrder = /* GraphQL */ `
  mutation UpdateOrder(
    $input: UpdateOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    updateOrder(input: $input, condition: $condition) {
      id
      owner
      accountNumber
      subAccountNumber
      side
      accountInformationId
      orderIncrementId
      symbol
      feesAndCommission
      cancel
      cancelReplace
      quantity
      limitPrice
      stopPrice
      orderType
      timeInForce
      instruction
      originalOrderId
      orderStatus
      orderLeg {
        ratioQuantity
        legType
        side
        openClose
        expiration
        strike
        price
        __typename
      }
      userOrderId
      tradeAmount
      marginRequirement
      apexFdid
      apexCatAccountholderType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOrder = /* GraphQL */ `
  mutation DeleteOrder(
    $input: DeleteOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    deleteOrder(input: $input, condition: $condition) {
      id
      owner
      accountNumber
      subAccountNumber
      side
      accountInformationId
      orderIncrementId
      symbol
      feesAndCommission
      cancel
      cancelReplace
      quantity
      limitPrice
      stopPrice
      orderType
      timeInForce
      instruction
      originalOrderId
      orderStatus
      orderLeg {
        ratioQuantity
        legType
        side
        openClose
        expiration
        strike
        price
        __typename
      }
      userOrderId
      tradeAmount
      marginRequirement
      apexFdid
      apexCatAccountholderType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createExecutionReport = /* GraphQL */ `
  mutation CreateExecutionReport(
    $input: CreateExecutionReportInput!
    $condition: ModelExecutionReportConditionInput
  ) {
    createExecutionReport(input: $input, condition: $condition) {
      id
      owner
      accountInformationId
      subAccountNumber
      orderID
      executionIncrementId
      secondaryOrderID
      clOrdID
      origClOrdID
      clientID
      execBroker
      listID
      execID
      execTransType
      execRefID
      execType
      ordStatus
      ordRejReason
      execRestatementReason
      account
      settlmntTyp
      futSettDate
      symbol
      symbolSfx
      securityID
      iDSource
      securityType
      maturityMonthYear
      maturityDay
      putOrCall
      strikePrice
      optAttribute
      contractMultiplier
      couponRate
      securityExchange
      issuer
      encodedIssuerLen
      encodedIssuer
      securityDesc
      encodedSecurityDescLen
      encodedSecurityDesc
      side
      orderQty
      cashOrderQty
      ordType
      price
      stopPx
      pegDifference
      discretionInst
      discretionOffset
      currency
      complianceID
      solicitedFlag
      timeInForce
      effectiveTime
      expireDate
      expireTime
      execInst
      rule80A
      lastShares
      lastPx
      lastSpotRate
      lastForwardPoints
      lastMkt
      tradingSessionID
      lastCapacity
      leavesQty
      cumQty
      avgPx
      dayOrderQty
      dayCumQty
      dayAvgPx
      gTBookingInst
      tradeDate
      transactTime
      reportToExch
      commission
      commType
      grossTradeAmt
      settlCurrAmt
      settlCurrency
      settlCurrFxRate
      settlCurrFxRateCalc
      handlInst
      minQty
      maxFloor
      openClose
      maxShow
      text
      encodedTextLen
      encodedText
      futSettDate2
      orderQty2
      clearingFirm
      clearingAccount
      multiLegReportingType
      legRefId
      uploadedToBackoffice
      fixMessage
      isAllocation
      groupUploadId
      processedAt
      createdDate
      createdAt
      updatedAt
      userOrderExecutionReportsId
      groupOrderExecutionReportsId
      __typename
    }
  }
`;
export const updateExecutionReport = /* GraphQL */ `
  mutation UpdateExecutionReport(
    $input: UpdateExecutionReportInput!
    $condition: ModelExecutionReportConditionInput
  ) {
    updateExecutionReport(input: $input, condition: $condition) {
      id
      owner
      accountInformationId
      subAccountNumber
      orderID
      executionIncrementId
      secondaryOrderID
      clOrdID
      origClOrdID
      clientID
      execBroker
      listID
      execID
      execTransType
      execRefID
      execType
      ordStatus
      ordRejReason
      execRestatementReason
      account
      settlmntTyp
      futSettDate
      symbol
      symbolSfx
      securityID
      iDSource
      securityType
      maturityMonthYear
      maturityDay
      putOrCall
      strikePrice
      optAttribute
      contractMultiplier
      couponRate
      securityExchange
      issuer
      encodedIssuerLen
      encodedIssuer
      securityDesc
      encodedSecurityDescLen
      encodedSecurityDesc
      side
      orderQty
      cashOrderQty
      ordType
      price
      stopPx
      pegDifference
      discretionInst
      discretionOffset
      currency
      complianceID
      solicitedFlag
      timeInForce
      effectiveTime
      expireDate
      expireTime
      execInst
      rule80A
      lastShares
      lastPx
      lastSpotRate
      lastForwardPoints
      lastMkt
      tradingSessionID
      lastCapacity
      leavesQty
      cumQty
      avgPx
      dayOrderQty
      dayCumQty
      dayAvgPx
      gTBookingInst
      tradeDate
      transactTime
      reportToExch
      commission
      commType
      grossTradeAmt
      settlCurrAmt
      settlCurrency
      settlCurrFxRate
      settlCurrFxRateCalc
      handlInst
      minQty
      maxFloor
      openClose
      maxShow
      text
      encodedTextLen
      encodedText
      futSettDate2
      orderQty2
      clearingFirm
      clearingAccount
      multiLegReportingType
      legRefId
      uploadedToBackoffice
      fixMessage
      isAllocation
      groupUploadId
      processedAt
      createdDate
      createdAt
      updatedAt
      userOrderExecutionReportsId
      groupOrderExecutionReportsId
      __typename
    }
  }
`;
export const deleteExecutionReport = /* GraphQL */ `
  mutation DeleteExecutionReport(
    $input: DeleteExecutionReportInput!
    $condition: ModelExecutionReportConditionInput
  ) {
    deleteExecutionReport(input: $input, condition: $condition) {
      id
      owner
      accountInformationId
      subAccountNumber
      orderID
      executionIncrementId
      secondaryOrderID
      clOrdID
      origClOrdID
      clientID
      execBroker
      listID
      execID
      execTransType
      execRefID
      execType
      ordStatus
      ordRejReason
      execRestatementReason
      account
      settlmntTyp
      futSettDate
      symbol
      symbolSfx
      securityID
      iDSource
      securityType
      maturityMonthYear
      maturityDay
      putOrCall
      strikePrice
      optAttribute
      contractMultiplier
      couponRate
      securityExchange
      issuer
      encodedIssuerLen
      encodedIssuer
      securityDesc
      encodedSecurityDescLen
      encodedSecurityDesc
      side
      orderQty
      cashOrderQty
      ordType
      price
      stopPx
      pegDifference
      discretionInst
      discretionOffset
      currency
      complianceID
      solicitedFlag
      timeInForce
      effectiveTime
      expireDate
      expireTime
      execInst
      rule80A
      lastShares
      lastPx
      lastSpotRate
      lastForwardPoints
      lastMkt
      tradingSessionID
      lastCapacity
      leavesQty
      cumQty
      avgPx
      dayOrderQty
      dayCumQty
      dayAvgPx
      gTBookingInst
      tradeDate
      transactTime
      reportToExch
      commission
      commType
      grossTradeAmt
      settlCurrAmt
      settlCurrency
      settlCurrFxRate
      settlCurrFxRateCalc
      handlInst
      minQty
      maxFloor
      openClose
      maxShow
      text
      encodedTextLen
      encodedText
      futSettDate2
      orderQty2
      clearingFirm
      clearingAccount
      multiLegReportingType
      legRefId
      uploadedToBackoffice
      fixMessage
      isAllocation
      groupUploadId
      processedAt
      createdDate
      createdAt
      updatedAt
      userOrderExecutionReportsId
      groupOrderExecutionReportsId
      __typename
    }
  }
`;
export const createGroupOrder = /* GraphQL */ `
  mutation CreateGroupOrder(
    $input: CreateGroupOrderInput!
    $condition: ModelGroupOrderConditionInput
  ) {
    createGroupOrder(input: $input, condition: $condition) {
      id
      accountNumber
      allocation {
        subAccountNumber
        accountNumber
        allocation
        filledAllocation
        account_information_id
        user_profile_id
        balance_id
        sub_account_balance_id
        position_ids
        individualOrderStatus
        __typename
      }
      portfolio
      brokerSkipChecks
      brokerOverride
      newsLetter
      owner
      subAccountNumbers
      cancel
      cancelReplace
      commission
      symbol
      side
      quantity
      limitPrice
      stopPrice
      stockValue
      originalGroupOrderId
      originalOrderId
      strategy
      orderType
      timeInForce
      instruction
      userOrderLegs {
        legType
        side
        quantity
        expiration
        strike
        openClose
        bid
        ask
        sharesPerContract
        avgPx
        __typename
      }
      message
      submitStatus
      status
      executionReports {
        items {
          id
          owner
          accountInformationId
          subAccountNumber
          orderID
          executionIncrementId
          secondaryOrderID
          clOrdID
          origClOrdID
          clientID
          execBroker
          listID
          execID
          execTransType
          execRefID
          execType
          ordStatus
          ordRejReason
          execRestatementReason
          account
          settlmntTyp
          futSettDate
          symbol
          symbolSfx
          securityID
          iDSource
          securityType
          maturityMonthYear
          maturityDay
          putOrCall
          strikePrice
          optAttribute
          contractMultiplier
          couponRate
          securityExchange
          issuer
          encodedIssuerLen
          encodedIssuer
          securityDesc
          encodedSecurityDescLen
          encodedSecurityDesc
          side
          orderQty
          cashOrderQty
          ordType
          price
          stopPx
          pegDifference
          discretionInst
          discretionOffset
          currency
          complianceID
          solicitedFlag
          timeInForce
          effectiveTime
          expireDate
          expireTime
          execInst
          rule80A
          lastShares
          lastPx
          lastSpotRate
          lastForwardPoints
          lastMkt
          tradingSessionID
          lastCapacity
          leavesQty
          cumQty
          avgPx
          dayOrderQty
          dayCumQty
          dayAvgPx
          gTBookingInst
          tradeDate
          transactTime
          reportToExch
          commission
          commType
          grossTradeAmt
          settlCurrAmt
          settlCurrency
          settlCurrFxRate
          settlCurrFxRateCalc
          handlInst
          minQty
          maxFloor
          openClose
          maxShow
          text
          encodedTextLen
          encodedText
          futSettDate2
          orderQty2
          clearingFirm
          clearingAccount
          multiLegReportingType
          legRefId
          uploadedToBackoffice
          fixMessage
          isAllocation
          groupUploadId
          processedAt
          createdDate
          createdAt
          updatedAt
          userOrderExecutionReportsId
          groupOrderExecutionReportsId
          __typename
        }
        nextToken
        __typename
      }
      cryptoOrder
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateGroupOrder = /* GraphQL */ `
  mutation UpdateGroupOrder(
    $input: UpdateGroupOrderInput!
    $condition: ModelGroupOrderConditionInput
  ) {
    updateGroupOrder(input: $input, condition: $condition) {
      id
      accountNumber
      allocation {
        subAccountNumber
        accountNumber
        allocation
        filledAllocation
        account_information_id
        user_profile_id
        balance_id
        sub_account_balance_id
        position_ids
        individualOrderStatus
        __typename
      }
      portfolio
      brokerSkipChecks
      brokerOverride
      newsLetter
      owner
      subAccountNumbers
      cancel
      cancelReplace
      commission
      symbol
      side
      quantity
      limitPrice
      stopPrice
      stockValue
      originalGroupOrderId
      originalOrderId
      strategy
      orderType
      timeInForce
      instruction
      userOrderLegs {
        legType
        side
        quantity
        expiration
        strike
        openClose
        bid
        ask
        sharesPerContract
        avgPx
        __typename
      }
      message
      submitStatus
      status
      executionReports {
        items {
          id
          owner
          accountInformationId
          subAccountNumber
          orderID
          executionIncrementId
          secondaryOrderID
          clOrdID
          origClOrdID
          clientID
          execBroker
          listID
          execID
          execTransType
          execRefID
          execType
          ordStatus
          ordRejReason
          execRestatementReason
          account
          settlmntTyp
          futSettDate
          symbol
          symbolSfx
          securityID
          iDSource
          securityType
          maturityMonthYear
          maturityDay
          putOrCall
          strikePrice
          optAttribute
          contractMultiplier
          couponRate
          securityExchange
          issuer
          encodedIssuerLen
          encodedIssuer
          securityDesc
          encodedSecurityDescLen
          encodedSecurityDesc
          side
          orderQty
          cashOrderQty
          ordType
          price
          stopPx
          pegDifference
          discretionInst
          discretionOffset
          currency
          complianceID
          solicitedFlag
          timeInForce
          effectiveTime
          expireDate
          expireTime
          execInst
          rule80A
          lastShares
          lastPx
          lastSpotRate
          lastForwardPoints
          lastMkt
          tradingSessionID
          lastCapacity
          leavesQty
          cumQty
          avgPx
          dayOrderQty
          dayCumQty
          dayAvgPx
          gTBookingInst
          tradeDate
          transactTime
          reportToExch
          commission
          commType
          grossTradeAmt
          settlCurrAmt
          settlCurrency
          settlCurrFxRate
          settlCurrFxRateCalc
          handlInst
          minQty
          maxFloor
          openClose
          maxShow
          text
          encodedTextLen
          encodedText
          futSettDate2
          orderQty2
          clearingFirm
          clearingAccount
          multiLegReportingType
          legRefId
          uploadedToBackoffice
          fixMessage
          isAllocation
          groupUploadId
          processedAt
          createdDate
          createdAt
          updatedAt
          userOrderExecutionReportsId
          groupOrderExecutionReportsId
          __typename
        }
        nextToken
        __typename
      }
      cryptoOrder
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteGroupOrder = /* GraphQL */ `
  mutation DeleteGroupOrder(
    $input: DeleteGroupOrderInput!
    $condition: ModelGroupOrderConditionInput
  ) {
    deleteGroupOrder(input: $input, condition: $condition) {
      id
      accountNumber
      allocation {
        subAccountNumber
        accountNumber
        allocation
        filledAllocation
        account_information_id
        user_profile_id
        balance_id
        sub_account_balance_id
        position_ids
        individualOrderStatus
        __typename
      }
      portfolio
      brokerSkipChecks
      brokerOverride
      newsLetter
      owner
      subAccountNumbers
      cancel
      cancelReplace
      commission
      symbol
      side
      quantity
      limitPrice
      stopPrice
      stockValue
      originalGroupOrderId
      originalOrderId
      strategy
      orderType
      timeInForce
      instruction
      userOrderLegs {
        legType
        side
        quantity
        expiration
        strike
        openClose
        bid
        ask
        sharesPerContract
        avgPx
        __typename
      }
      message
      submitStatus
      status
      executionReports {
        items {
          id
          owner
          accountInformationId
          subAccountNumber
          orderID
          executionIncrementId
          secondaryOrderID
          clOrdID
          origClOrdID
          clientID
          execBroker
          listID
          execID
          execTransType
          execRefID
          execType
          ordStatus
          ordRejReason
          execRestatementReason
          account
          settlmntTyp
          futSettDate
          symbol
          symbolSfx
          securityID
          iDSource
          securityType
          maturityMonthYear
          maturityDay
          putOrCall
          strikePrice
          optAttribute
          contractMultiplier
          couponRate
          securityExchange
          issuer
          encodedIssuerLen
          encodedIssuer
          securityDesc
          encodedSecurityDescLen
          encodedSecurityDesc
          side
          orderQty
          cashOrderQty
          ordType
          price
          stopPx
          pegDifference
          discretionInst
          discretionOffset
          currency
          complianceID
          solicitedFlag
          timeInForce
          effectiveTime
          expireDate
          expireTime
          execInst
          rule80A
          lastShares
          lastPx
          lastSpotRate
          lastForwardPoints
          lastMkt
          tradingSessionID
          lastCapacity
          leavesQty
          cumQty
          avgPx
          dayOrderQty
          dayCumQty
          dayAvgPx
          gTBookingInst
          tradeDate
          transactTime
          reportToExch
          commission
          commType
          grossTradeAmt
          settlCurrAmt
          settlCurrency
          settlCurrFxRate
          settlCurrFxRateCalc
          handlInst
          minQty
          maxFloor
          openClose
          maxShow
          text
          encodedTextLen
          encodedText
          futSettDate2
          orderQty2
          clearingFirm
          clearingAccount
          multiLegReportingType
          legRefId
          uploadedToBackoffice
          fixMessage
          isAllocation
          groupUploadId
          processedAt
          createdDate
          createdAt
          updatedAt
          userOrderExecutionReportsId
          groupOrderExecutionReportsId
          __typename
        }
        nextToken
        __typename
      }
      cryptoOrder
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createApexInteractions = /* GraphQL */ `
  mutation CreateApexInteractions(
    $input: CreateApexInteractionsInput!
    $condition: ModelApexInteractionsConditionInput
  ) {
    createApexInteractions(input: $input, condition: $condition) {
      id
      executionReportId
      accountNumber
      request
      response
      responseStatusCode
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateApexInteractions = /* GraphQL */ `
  mutation UpdateApexInteractions(
    $input: UpdateApexInteractionsInput!
    $condition: ModelApexInteractionsConditionInput
  ) {
    updateApexInteractions(input: $input, condition: $condition) {
      id
      executionReportId
      accountNumber
      request
      response
      responseStatusCode
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteApexInteractions = /* GraphQL */ `
  mutation DeleteApexInteractions(
    $input: DeleteApexInteractionsInput!
    $condition: ModelApexInteractionsConditionInput
  ) {
    deleteApexInteractions(input: $input, condition: $condition) {
      id
      executionReportId
      accountNumber
      request
      response
      responseStatusCode
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createMarginCallReport = /* GraphQL */ `
  mutation CreateMarginCallReport(
    $input: CreateMarginCallReportInput!
    $condition: ModelMarginCallReportConditionInput
  ) {
    createMarginCallReport(input: $input, condition: $condition) {
      id
      callId
      accountNumber
      accountName
      callAmount
      callType
      tradeDate
      dueDate
      regTDate
      createdAt
      ttl
      updatedAt
      __typename
    }
  }
`;
export const updateMarginCallReport = /* GraphQL */ `
  mutation UpdateMarginCallReport(
    $input: UpdateMarginCallReportInput!
    $condition: ModelMarginCallReportConditionInput
  ) {
    updateMarginCallReport(input: $input, condition: $condition) {
      id
      callId
      accountNumber
      accountName
      callAmount
      callType
      tradeDate
      dueDate
      regTDate
      createdAt
      ttl
      updatedAt
      __typename
    }
  }
`;
export const deleteMarginCallReport = /* GraphQL */ `
  mutation DeleteMarginCallReport(
    $input: DeleteMarginCallReportInput!
    $condition: ModelMarginCallReportConditionInput
  ) {
    deleteMarginCallReport(input: $input, condition: $condition) {
      id
      callId
      accountNumber
      accountName
      callAmount
      callType
      tradeDate
      dueDate
      regTDate
      createdAt
      ttl
      updatedAt
      __typename
    }
  }
`;
export const createDailyExerciseAssignmentFile = /* GraphQL */ `
  mutation CreateDailyExerciseAssignmentFile(
    $input: CreateDailyExerciseAssignmentFileInput!
    $condition: ModelDailyExerciseAssignmentFileConditionInput
  ) {
    createDailyExerciseAssignmentFile(input: $input, condition: $condition) {
      id
      processingStatus
      executionMethod
      optionSymbolKey
      optionQuantity
      stockIndexIndicator
      deliveryComponent
      optionSymbol
      underlyingSecurityInformation
      customerAccountNumberHoldingTheOption
      officeCode
      underlyingSymbol
      strikePrice
      payOutComponent
      notesField
      customerAccountNumberActivityToBeRunAgainst
      customerAccountType
      buySellCodeForUnderlying
      underlyingQuantity
      underlyingQuantityAdditional
      underLyingSymbolAssociatedWithTrade
      priceOfTrade
      tradeMarketCode
      tradeCapacityCode
      brokerInformation
      executionTimeTheTradeWillBeAssociatedWith
      commission
      tradeDate
      settlementDate
      excerciseAssignmentCode
      occClaimNumber
      accountType
      ttl
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDailyExerciseAssignmentFile = /* GraphQL */ `
  mutation UpdateDailyExerciseAssignmentFile(
    $input: UpdateDailyExerciseAssignmentFileInput!
    $condition: ModelDailyExerciseAssignmentFileConditionInput
  ) {
    updateDailyExerciseAssignmentFile(input: $input, condition: $condition) {
      id
      processingStatus
      executionMethod
      optionSymbolKey
      optionQuantity
      stockIndexIndicator
      deliveryComponent
      optionSymbol
      underlyingSecurityInformation
      customerAccountNumberHoldingTheOption
      officeCode
      underlyingSymbol
      strikePrice
      payOutComponent
      notesField
      customerAccountNumberActivityToBeRunAgainst
      customerAccountType
      buySellCodeForUnderlying
      underlyingQuantity
      underlyingQuantityAdditional
      underLyingSymbolAssociatedWithTrade
      priceOfTrade
      tradeMarketCode
      tradeCapacityCode
      brokerInformation
      executionTimeTheTradeWillBeAssociatedWith
      commission
      tradeDate
      settlementDate
      excerciseAssignmentCode
      occClaimNumber
      accountType
      ttl
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDailyExerciseAssignmentFile = /* GraphQL */ `
  mutation DeleteDailyExerciseAssignmentFile(
    $input: DeleteDailyExerciseAssignmentFileInput!
    $condition: ModelDailyExerciseAssignmentFileConditionInput
  ) {
    deleteDailyExerciseAssignmentFile(input: $input, condition: $condition) {
      id
      processingStatus
      executionMethod
      optionSymbolKey
      optionQuantity
      stockIndexIndicator
      deliveryComponent
      optionSymbol
      underlyingSecurityInformation
      customerAccountNumberHoldingTheOption
      officeCode
      underlyingSymbol
      strikePrice
      payOutComponent
      notesField
      customerAccountNumberActivityToBeRunAgainst
      customerAccountType
      buySellCodeForUnderlying
      underlyingQuantity
      underlyingQuantityAdditional
      underLyingSymbolAssociatedWithTrade
      priceOfTrade
      tradeMarketCode
      tradeCapacityCode
      brokerInformation
      executionTimeTheTradeWillBeAssociatedWith
      commission
      tradeDate
      settlementDate
      excerciseAssignmentCode
      occClaimNumber
      accountType
      ttl
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createNameBaseDump = /* GraphQL */ `
  mutation CreateNameBaseDump(
    $input: CreateNameBaseDumpInput!
    $condition: ModelNameBaseDumpConditionInput
  ) {
    createNameBaseDump(input: $input, condition: $condition) {
      id
      accountNumber
      recordTypeCode
      recordTypeSubTypeCode
      rrIndexCode
      officeCode
      registeredRepCode
      federalIdIndicator
      taxIdNumber
      nameIndex
      shortName
      partyIndex
      relatedParty
      accountName
      addressLine1
      addressLine2
      addressLine3
      addressLine4
      city
      state
      zipCode
      irsControl
      multiRRS
      knd
      mapAccount
      fee
      mmSweep
      del
      pay
      div
      pri
      valCashPosition
      accountClass
      accountBalanceCategory
      printStatement
      fundPrincipal
      fundInterest
      discretion
      portfolioIndicator
      ira
      creditInterestSweep
      moneySweep
      optionLevel
      exposure
      nYTax
      stateTax
      iRSCode
      fedTypeCode
      nonObjecting
      iRSExempt
      foreignCode
      mature
      fundFees
      optionLimit
      forwardLimit
      suppressConfirm
      restrictReasonCode
      commissionSchedule
      w8
      fundDividend
      fundMature
      joint
      legal
      margin
      optionCode
      corpRes
      loan
      nPLoan
      commodites
      powerAttorney
      intFutures
      curFutures
      segCode
      pubEntity
      tradeAuthorize
      tradeAccountAuthorize
      forwardDel
      repo
      customer
      riskDisclose
      nonCashDisclose
      hedgeLetter
      unsolicited
      partnership
      soleOwner
      fedFunds
      safeKeeping
      ach
      mas
      dvp
      disclosureStatement
      sweep
      fundRateClass
      sicCode
      userCode1
      userCode2
      userCode3
      userCode4
      userCode5
      userCode6
      instituion
      agentBank
      customerAccount
      abaNumber
      alternateAccountTypeA
      abaNumberB
      alternateAccountTypeB
      telcoExtension1
      telcoExtension2
      restrDate
      openDDate
      lastChangeDate
      lastActivtyDate
      lastTradeDate
      stockBorrowLoan
      inventoryCarryType
      numberId
      addressIndicator
      telcoCode1
      telcoCode2
      telcoAreaCode1
      telcoExchange1
      telcoBase1
      telcoAreaCode2
      telcoExchange2
      telcoBase2
      dayTradeCounter
      oldSystemAccountNumber
      alternateAccountB
      alternateAccountA
      closedDate
      preEffAYY
      preEffBYY
      tefraChangeYY
      bankFailReport
      issuerStatus
      aRBCode
      processDate
      accountNature
      fdid
      mpid
      cATAccountType
      oATSAccountType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateNameBaseDump = /* GraphQL */ `
  mutation UpdateNameBaseDump(
    $input: UpdateNameBaseDumpInput!
    $condition: ModelNameBaseDumpConditionInput
  ) {
    updateNameBaseDump(input: $input, condition: $condition) {
      id
      accountNumber
      recordTypeCode
      recordTypeSubTypeCode
      rrIndexCode
      officeCode
      registeredRepCode
      federalIdIndicator
      taxIdNumber
      nameIndex
      shortName
      partyIndex
      relatedParty
      accountName
      addressLine1
      addressLine2
      addressLine3
      addressLine4
      city
      state
      zipCode
      irsControl
      multiRRS
      knd
      mapAccount
      fee
      mmSweep
      del
      pay
      div
      pri
      valCashPosition
      accountClass
      accountBalanceCategory
      printStatement
      fundPrincipal
      fundInterest
      discretion
      portfolioIndicator
      ira
      creditInterestSweep
      moneySweep
      optionLevel
      exposure
      nYTax
      stateTax
      iRSCode
      fedTypeCode
      nonObjecting
      iRSExempt
      foreignCode
      mature
      fundFees
      optionLimit
      forwardLimit
      suppressConfirm
      restrictReasonCode
      commissionSchedule
      w8
      fundDividend
      fundMature
      joint
      legal
      margin
      optionCode
      corpRes
      loan
      nPLoan
      commodites
      powerAttorney
      intFutures
      curFutures
      segCode
      pubEntity
      tradeAuthorize
      tradeAccountAuthorize
      forwardDel
      repo
      customer
      riskDisclose
      nonCashDisclose
      hedgeLetter
      unsolicited
      partnership
      soleOwner
      fedFunds
      safeKeeping
      ach
      mas
      dvp
      disclosureStatement
      sweep
      fundRateClass
      sicCode
      userCode1
      userCode2
      userCode3
      userCode4
      userCode5
      userCode6
      instituion
      agentBank
      customerAccount
      abaNumber
      alternateAccountTypeA
      abaNumberB
      alternateAccountTypeB
      telcoExtension1
      telcoExtension2
      restrDate
      openDDate
      lastChangeDate
      lastActivtyDate
      lastTradeDate
      stockBorrowLoan
      inventoryCarryType
      numberId
      addressIndicator
      telcoCode1
      telcoCode2
      telcoAreaCode1
      telcoExchange1
      telcoBase1
      telcoAreaCode2
      telcoExchange2
      telcoBase2
      dayTradeCounter
      oldSystemAccountNumber
      alternateAccountB
      alternateAccountA
      closedDate
      preEffAYY
      preEffBYY
      tefraChangeYY
      bankFailReport
      issuerStatus
      aRBCode
      processDate
      accountNature
      fdid
      mpid
      cATAccountType
      oATSAccountType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteNameBaseDump = /* GraphQL */ `
  mutation DeleteNameBaseDump(
    $input: DeleteNameBaseDumpInput!
    $condition: ModelNameBaseDumpConditionInput
  ) {
    deleteNameBaseDump(input: $input, condition: $condition) {
      id
      accountNumber
      recordTypeCode
      recordTypeSubTypeCode
      rrIndexCode
      officeCode
      registeredRepCode
      federalIdIndicator
      taxIdNumber
      nameIndex
      shortName
      partyIndex
      relatedParty
      accountName
      addressLine1
      addressLine2
      addressLine3
      addressLine4
      city
      state
      zipCode
      irsControl
      multiRRS
      knd
      mapAccount
      fee
      mmSweep
      del
      pay
      div
      pri
      valCashPosition
      accountClass
      accountBalanceCategory
      printStatement
      fundPrincipal
      fundInterest
      discretion
      portfolioIndicator
      ira
      creditInterestSweep
      moneySweep
      optionLevel
      exposure
      nYTax
      stateTax
      iRSCode
      fedTypeCode
      nonObjecting
      iRSExempt
      foreignCode
      mature
      fundFees
      optionLimit
      forwardLimit
      suppressConfirm
      restrictReasonCode
      commissionSchedule
      w8
      fundDividend
      fundMature
      joint
      legal
      margin
      optionCode
      corpRes
      loan
      nPLoan
      commodites
      powerAttorney
      intFutures
      curFutures
      segCode
      pubEntity
      tradeAuthorize
      tradeAccountAuthorize
      forwardDel
      repo
      customer
      riskDisclose
      nonCashDisclose
      hedgeLetter
      unsolicited
      partnership
      soleOwner
      fedFunds
      safeKeeping
      ach
      mas
      dvp
      disclosureStatement
      sweep
      fundRateClass
      sicCode
      userCode1
      userCode2
      userCode3
      userCode4
      userCode5
      userCode6
      instituion
      agentBank
      customerAccount
      abaNumber
      alternateAccountTypeA
      abaNumberB
      alternateAccountTypeB
      telcoExtension1
      telcoExtension2
      restrDate
      openDDate
      lastChangeDate
      lastActivtyDate
      lastTradeDate
      stockBorrowLoan
      inventoryCarryType
      numberId
      addressIndicator
      telcoCode1
      telcoCode2
      telcoAreaCode1
      telcoExchange1
      telcoBase1
      telcoAreaCode2
      telcoExchange2
      telcoBase2
      dayTradeCounter
      oldSystemAccountNumber
      alternateAccountB
      alternateAccountA
      closedDate
      preEffAYY
      preEffBYY
      tefraChangeYY
      bankFailReport
      issuerStatus
      aRBCode
      processDate
      accountNature
      fdid
      mpid
      cATAccountType
      oATSAccountType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createConsolidatedCashActivityReport = /* GraphQL */ `
  mutation CreateConsolidatedCashActivityReport(
    $input: CreateConsolidatedCashActivityReportInput!
    $condition: ModelConsolidatedCashActivityReportConditionInput
  ) {
    createConsolidatedCashActivityReport(input: $input, condition: $condition) {
      id
      accountNumber
      accountType
      amount
      description
      currencyCode
      processDate
      batchCode
      cusip
      entryDate
      sourceProgram
      userId
      activityIndicator
      officeCode
      acatsControlNumber
      actionCode
      checkNumber
      contraAccountNumber
      contraAccountTypeCode
      contraCurrencyCode
      corrWindowCode
      currentPaydownFactor
      divTaxTypeCode
      dTCNumber
      dTCNumberExp
      effectiveDate
      enteredBy
      entryTypeCode
      feeIndicator
      firm
      foreignCode
      fundsUserCode
      gLPostStatusCode
      historyEntryCode
      interestEffectiveDate
      lastPaydownFactor
      mDHIndicator
      mergeEntryCode
      mAgentIndicator
      moneyMarketCode
      mutualFundPostIndicator
      originalQuantity
      overrideIndicator
      pasMergeEntryCode
      payTypeCode
      price
      recTypeCode
      registeredRepCode
      rRCategoryCode
      sequenceNumber
      smaChangeAmount
      statementIndicator
      statusCode
      taxOverrideCode
      taxYear
      terminalId
      thirdPartyCode
      tradeDate
      tradenumber
      userEntryDate
      wireFundsCode
      withholdTaxIndicator
      withholdTaxTypeCode
      correspondentOfficeId
      correspondentId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateConsolidatedCashActivityReport = /* GraphQL */ `
  mutation UpdateConsolidatedCashActivityReport(
    $input: UpdateConsolidatedCashActivityReportInput!
    $condition: ModelConsolidatedCashActivityReportConditionInput
  ) {
    updateConsolidatedCashActivityReport(input: $input, condition: $condition) {
      id
      accountNumber
      accountType
      amount
      description
      currencyCode
      processDate
      batchCode
      cusip
      entryDate
      sourceProgram
      userId
      activityIndicator
      officeCode
      acatsControlNumber
      actionCode
      checkNumber
      contraAccountNumber
      contraAccountTypeCode
      contraCurrencyCode
      corrWindowCode
      currentPaydownFactor
      divTaxTypeCode
      dTCNumber
      dTCNumberExp
      effectiveDate
      enteredBy
      entryTypeCode
      feeIndicator
      firm
      foreignCode
      fundsUserCode
      gLPostStatusCode
      historyEntryCode
      interestEffectiveDate
      lastPaydownFactor
      mDHIndicator
      mergeEntryCode
      mAgentIndicator
      moneyMarketCode
      mutualFundPostIndicator
      originalQuantity
      overrideIndicator
      pasMergeEntryCode
      payTypeCode
      price
      recTypeCode
      registeredRepCode
      rRCategoryCode
      sequenceNumber
      smaChangeAmount
      statementIndicator
      statusCode
      taxOverrideCode
      taxYear
      terminalId
      thirdPartyCode
      tradeDate
      tradenumber
      userEntryDate
      wireFundsCode
      withholdTaxIndicator
      withholdTaxTypeCode
      correspondentOfficeId
      correspondentId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteConsolidatedCashActivityReport = /* GraphQL */ `
  mutation DeleteConsolidatedCashActivityReport(
    $input: DeleteConsolidatedCashActivityReportInput!
    $condition: ModelConsolidatedCashActivityReportConditionInput
  ) {
    deleteConsolidatedCashActivityReport(input: $input, condition: $condition) {
      id
      accountNumber
      accountType
      amount
      description
      currencyCode
      processDate
      batchCode
      cusip
      entryDate
      sourceProgram
      userId
      activityIndicator
      officeCode
      acatsControlNumber
      actionCode
      checkNumber
      contraAccountNumber
      contraAccountTypeCode
      contraCurrencyCode
      corrWindowCode
      currentPaydownFactor
      divTaxTypeCode
      dTCNumber
      dTCNumberExp
      effectiveDate
      enteredBy
      entryTypeCode
      feeIndicator
      firm
      foreignCode
      fundsUserCode
      gLPostStatusCode
      historyEntryCode
      interestEffectiveDate
      lastPaydownFactor
      mDHIndicator
      mergeEntryCode
      mAgentIndicator
      moneyMarketCode
      mutualFundPostIndicator
      originalQuantity
      overrideIndicator
      pasMergeEntryCode
      payTypeCode
      price
      recTypeCode
      registeredRepCode
      rRCategoryCode
      sequenceNumber
      smaChangeAmount
      statementIndicator
      statusCode
      taxOverrideCode
      taxYear
      terminalId
      thirdPartyCode
      tradeDate
      tradenumber
      userEntryDate
      wireFundsCode
      withholdTaxIndicator
      withholdTaxTypeCode
      correspondentOfficeId
      correspondentId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTradeActivity = /* GraphQL */ `
  mutation CreateTradeActivity(
    $input: CreateTradeActivityInput!
    $condition: ModelTradeActivityConditionInput
  ) {
    createTradeActivity(input: $input, condition: $condition) {
      id
      accountNumber
      processDate
      firm
      correspondentId
      correspondentOfficeId
      correspondentCode
      officeCode
      registeredRepCode
      accountType
      buySellcode
      tradeDate
      tradeNumber
      executionTime
      cusip
      symbol
      quantity
      price
      marketCode
      capacityCode
      commissionGrossCalculated
      commissionGrossEntered
      settlementDate
      currencyCode
      prncipalAmount
      netAmount
      feeSec
      feeMisc
      fee1
      fee2
      fee3
      fee4
      fee5
      entryDate
      shortDescription
      trailerCode
      tradeInterest
      executingBrokerBack
      securityTypeCode
      commissionRRCategory
      reallowance
      commissionEntered
      shortName
      factor
      commissionNet
      trailer
      executingBrokerFront
      feeMF
      clearingSymbol
      repo
      description1
      securitySubType
      instructionsTradeLegendCode
      country
      isin
      languageId
      instructionsSpecial1
      instructionsSpecial2
      originalTradeNumber
      tradeLegendCode
      optionSymbolRoot
      displaySymbol
      strikePrice
      callPut
      expirationDeliveryDate
      optionContractDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTradeActivity = /* GraphQL */ `
  mutation UpdateTradeActivity(
    $input: UpdateTradeActivityInput!
    $condition: ModelTradeActivityConditionInput
  ) {
    updateTradeActivity(input: $input, condition: $condition) {
      id
      accountNumber
      processDate
      firm
      correspondentId
      correspondentOfficeId
      correspondentCode
      officeCode
      registeredRepCode
      accountType
      buySellcode
      tradeDate
      tradeNumber
      executionTime
      cusip
      symbol
      quantity
      price
      marketCode
      capacityCode
      commissionGrossCalculated
      commissionGrossEntered
      settlementDate
      currencyCode
      prncipalAmount
      netAmount
      feeSec
      feeMisc
      fee1
      fee2
      fee3
      fee4
      fee5
      entryDate
      shortDescription
      trailerCode
      tradeInterest
      executingBrokerBack
      securityTypeCode
      commissionRRCategory
      reallowance
      commissionEntered
      shortName
      factor
      commissionNet
      trailer
      executingBrokerFront
      feeMF
      clearingSymbol
      repo
      description1
      securitySubType
      instructionsTradeLegendCode
      country
      isin
      languageId
      instructionsSpecial1
      instructionsSpecial2
      originalTradeNumber
      tradeLegendCode
      optionSymbolRoot
      displaySymbol
      strikePrice
      callPut
      expirationDeliveryDate
      optionContractDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTradeActivity = /* GraphQL */ `
  mutation DeleteTradeActivity(
    $input: DeleteTradeActivityInput!
    $condition: ModelTradeActivityConditionInput
  ) {
    deleteTradeActivity(input: $input, condition: $condition) {
      id
      accountNumber
      processDate
      firm
      correspondentId
      correspondentOfficeId
      correspondentCode
      officeCode
      registeredRepCode
      accountType
      buySellcode
      tradeDate
      tradeNumber
      executionTime
      cusip
      symbol
      quantity
      price
      marketCode
      capacityCode
      commissionGrossCalculated
      commissionGrossEntered
      settlementDate
      currencyCode
      prncipalAmount
      netAmount
      feeSec
      feeMisc
      fee1
      fee2
      fee3
      fee4
      fee5
      entryDate
      shortDescription
      trailerCode
      tradeInterest
      executingBrokerBack
      securityTypeCode
      commissionRRCategory
      reallowance
      commissionEntered
      shortName
      factor
      commissionNet
      trailer
      executingBrokerFront
      feeMF
      clearingSymbol
      repo
      description1
      securitySubType
      instructionsTradeLegendCode
      country
      isin
      languageId
      instructionsSpecial1
      instructionsSpecial2
      originalTradeNumber
      tradeLegendCode
      optionSymbolRoot
      displaySymbol
      strikePrice
      callPut
      expirationDeliveryDate
      optionContractDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createOvernightBuyingPower = /* GraphQL */ `
  mutation CreateOvernightBuyingPower(
    $input: CreateOvernightBuyingPowerInput!
    $condition: ModelOvernightBuyingPowerConditionInput
  ) {
    createOvernightBuyingPower(input: $input, condition: $condition) {
      id
      overnightBuyingPowerId
      accountNumber
      firm
      officeCode
      correspondentCode
      processDate
      currencyCode
      totalEquity
      marginEquity
      marginRequirement
      marginExcessEquity
      cashEquity
      cashRequirement
      cashExcessEquity
      marginRequirementWithConcentration
      marginExcessEquityWithConcentration
      overnightBuyingPowerCalculated
      overnightBuyingPowerIssued
      dayTradeBuyingPowerIssued
      regTBuyingPowerCalculated
      regTBuyingPowerIssued
      overnightFactorCalculated
      overnightFactorIssued
      dayTradeFactorCalculated
      dayTradeFactorIssued
      marginEquityPercent
      positionMarketValue
      longEquityMarketValue
      shortEquityMarketValue
      longOptionMarketValue
      shortOptionMarketValue
      totalTradeBalance
      totalSettleBalance
      cashTradeBalance
      marginTradeBalance
      shortTradeBalance
      moneyMarketTradeBalance
      cashSettleBalance
      marginSettleBalance
      shortSettleBalance
      moneyMarketSettleBalance
      freeCash
      sma
      availableToWithdraw
      futureBalance
      futureEquity
      futureRequirement
      optionsRequirement
      nonOptionsRequirement
      lastUpdate
      nonOptionsRequirementNotConcentrated
      typeIUnavailableCashProceeds
      typeIIUnavailableCashProceeds
      netBalance
      smaCommitted
      highWaterMark
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOvernightBuyingPower = /* GraphQL */ `
  mutation UpdateOvernightBuyingPower(
    $input: UpdateOvernightBuyingPowerInput!
    $condition: ModelOvernightBuyingPowerConditionInput
  ) {
    updateOvernightBuyingPower(input: $input, condition: $condition) {
      id
      overnightBuyingPowerId
      accountNumber
      firm
      officeCode
      correspondentCode
      processDate
      currencyCode
      totalEquity
      marginEquity
      marginRequirement
      marginExcessEquity
      cashEquity
      cashRequirement
      cashExcessEquity
      marginRequirementWithConcentration
      marginExcessEquityWithConcentration
      overnightBuyingPowerCalculated
      overnightBuyingPowerIssued
      dayTradeBuyingPowerIssued
      regTBuyingPowerCalculated
      regTBuyingPowerIssued
      overnightFactorCalculated
      overnightFactorIssued
      dayTradeFactorCalculated
      dayTradeFactorIssued
      marginEquityPercent
      positionMarketValue
      longEquityMarketValue
      shortEquityMarketValue
      longOptionMarketValue
      shortOptionMarketValue
      totalTradeBalance
      totalSettleBalance
      cashTradeBalance
      marginTradeBalance
      shortTradeBalance
      moneyMarketTradeBalance
      cashSettleBalance
      marginSettleBalance
      shortSettleBalance
      moneyMarketSettleBalance
      freeCash
      sma
      availableToWithdraw
      futureBalance
      futureEquity
      futureRequirement
      optionsRequirement
      nonOptionsRequirement
      lastUpdate
      nonOptionsRequirementNotConcentrated
      typeIUnavailableCashProceeds
      typeIIUnavailableCashProceeds
      netBalance
      smaCommitted
      highWaterMark
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOvernightBuyingPower = /* GraphQL */ `
  mutation DeleteOvernightBuyingPower(
    $input: DeleteOvernightBuyingPowerInput!
    $condition: ModelOvernightBuyingPowerConditionInput
  ) {
    deleteOvernightBuyingPower(input: $input, condition: $condition) {
      id
      overnightBuyingPowerId
      accountNumber
      firm
      officeCode
      correspondentCode
      processDate
      currencyCode
      totalEquity
      marginEquity
      marginRequirement
      marginExcessEquity
      cashEquity
      cashRequirement
      cashExcessEquity
      marginRequirementWithConcentration
      marginExcessEquityWithConcentration
      overnightBuyingPowerCalculated
      overnightBuyingPowerIssued
      dayTradeBuyingPowerIssued
      regTBuyingPowerCalculated
      regTBuyingPowerIssued
      overnightFactorCalculated
      overnightFactorIssued
      dayTradeFactorCalculated
      dayTradeFactorIssued
      marginEquityPercent
      positionMarketValue
      longEquityMarketValue
      shortEquityMarketValue
      longOptionMarketValue
      shortOptionMarketValue
      totalTradeBalance
      totalSettleBalance
      cashTradeBalance
      marginTradeBalance
      shortTradeBalance
      moneyMarketTradeBalance
      cashSettleBalance
      marginSettleBalance
      shortSettleBalance
      moneyMarketSettleBalance
      freeCash
      sma
      availableToWithdraw
      futureBalance
      futureEquity
      futureRequirement
      optionsRequirement
      nonOptionsRequirement
      lastUpdate
      nonOptionsRequirementNotConcentrated
      typeIUnavailableCashProceeds
      typeIIUnavailableCashProceeds
      netBalance
      smaCommitted
      highWaterMark
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPositionBreakout = /* GraphQL */ `
  mutation CreatePositionBreakout(
    $input: CreatePositionBreakoutInput!
    $condition: ModelPositionBreakoutConditionInput
  ) {
    createPositionBreakout(input: $input, condition: $condition) {
      id
      ttl
      accountNumber
      firm
      officeCode
      strategyId
      strategySequence
      accountType
      cusip
      tradeQuantity
      symbol
      description
      closingPrice
      marketValue
      securityTypeCode
      underlyingSymbol
      strikePrice
      isin
      change
      positionType
      processDate
      isSelling
      maintenanceRequirement
      concentrationRequirement
      optionStrategy
      optionLeg
      strategyMaintenanceRequirement
      strategyConcentrationRequirement
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePositionBreakout = /* GraphQL */ `
  mutation UpdatePositionBreakout(
    $input: UpdatePositionBreakoutInput!
    $condition: ModelPositionBreakoutConditionInput
  ) {
    updatePositionBreakout(input: $input, condition: $condition) {
      id
      ttl
      accountNumber
      firm
      officeCode
      strategyId
      strategySequence
      accountType
      cusip
      tradeQuantity
      symbol
      description
      closingPrice
      marketValue
      securityTypeCode
      underlyingSymbol
      strikePrice
      isin
      change
      positionType
      processDate
      isSelling
      maintenanceRequirement
      concentrationRequirement
      optionStrategy
      optionLeg
      strategyMaintenanceRequirement
      strategyConcentrationRequirement
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePositionBreakout = /* GraphQL */ `
  mutation DeletePositionBreakout(
    $input: DeletePositionBreakoutInput!
    $condition: ModelPositionBreakoutConditionInput
  ) {
    deletePositionBreakout(input: $input, condition: $condition) {
      id
      ttl
      accountNumber
      firm
      officeCode
      strategyId
      strategySequence
      accountType
      cusip
      tradeQuantity
      symbol
      description
      closingPrice
      marketValue
      securityTypeCode
      underlyingSymbol
      strikePrice
      isin
      change
      positionType
      processDate
      isSelling
      maintenanceRequirement
      concentrationRequirement
      optionStrategy
      optionLeg
      strategyMaintenanceRequirement
      strategyConcentrationRequirement
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDailyPostmaster = /* GraphQL */ `
  mutation CreateDailyPostmaster(
    $input: CreateDailyPostmasterInput!
    $condition: ModelDailyPostmasterConditionInput
  ) {
    createDailyPostmaster(input: $input, condition: $condition) {
      id
      firm
      accountNumber
      mailTypeId
      mailTypeDescription
      processDate
      correspondentCode
      officeCode
      accountName
      addressLine1
      addressLine2
      addressLine3
      addressLine4
      city
      state
      zipCode
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDailyPostmaster = /* GraphQL */ `
  mutation UpdateDailyPostmaster(
    $input: UpdateDailyPostmasterInput!
    $condition: ModelDailyPostmasterConditionInput
  ) {
    updateDailyPostmaster(input: $input, condition: $condition) {
      id
      firm
      accountNumber
      mailTypeId
      mailTypeDescription
      processDate
      correspondentCode
      officeCode
      accountName
      addressLine1
      addressLine2
      addressLine3
      addressLine4
      city
      state
      zipCode
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDailyPostmaster = /* GraphQL */ `
  mutation DeleteDailyPostmaster(
    $input: DeleteDailyPostmasterInput!
    $condition: ModelDailyPostmasterConditionInput
  ) {
    deleteDailyPostmaster(input: $input, condition: $condition) {
      id
      firm
      accountNumber
      mailTypeId
      mailTypeDescription
      processDate
      correspondentCode
      officeCode
      accountName
      addressLine1
      addressLine2
      addressLine3
      addressLine4
      city
      state
      zipCode
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createElectronicCommunication = /* GraphQL */ `
  mutation CreateElectronicCommunication(
    $input: CreateElectronicCommunicationInput!
    $condition: ModelElectronicCommunicationConditionInput
  ) {
    createElectronicCommunication(input: $input, condition: $condition) {
      id
      accountNumber
      registeredRepCode
      statementStatus
      confirmStatus
      prospectusStatus
      proxyStatus
      taxStatus
      closedIndicator
      closedReason
      emailAddress
      lastUpdated
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateElectronicCommunication = /* GraphQL */ `
  mutation UpdateElectronicCommunication(
    $input: UpdateElectronicCommunicationInput!
    $condition: ModelElectronicCommunicationConditionInput
  ) {
    updateElectronicCommunication(input: $input, condition: $condition) {
      id
      accountNumber
      registeredRepCode
      statementStatus
      confirmStatus
      prospectusStatus
      proxyStatus
      taxStatus
      closedIndicator
      closedReason
      emailAddress
      lastUpdated
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteElectronicCommunication = /* GraphQL */ `
  mutation DeleteElectronicCommunication(
    $input: DeleteElectronicCommunicationInput!
    $condition: ModelElectronicCommunicationConditionInput
  ) {
    deleteElectronicCommunication(input: $input, condition: $condition) {
      id
      accountNumber
      registeredRepCode
      statementStatus
      confirmStatus
      prospectusStatus
      proxyStatus
      taxStatus
      closedIndicator
      closedReason
      emailAddress
      lastUpdated
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPositionHistory = /* GraphQL */ `
  mutation CreatePositionHistory(
    $input: CreatePositionHistoryInput!
    $condition: ModelPositionHistoryConditionInput
  ) {
    createPositionHistory(input: $input, condition: $condition) {
      id
      recordNumber
      clientNumber
      correspondentCode
      accountNumber
      currency
      trid
      sequenceNumber
      cusip
      securityType
      symbolMsd
      numberMsd
      taxLotOpenBuyDate
      taxLotCloseSellDate
      settlementDate
      quantity
      cost
      netProceed
      realizedGainLoss
      longTermShortTermIndicator
      realizedIndicator
      zeroIndicator
      lmBuyDateIndicator
      lmCostDateIndicator
      lmMarketValueIndicator
      lmGainLossIndicator
      securityNumberMsd
      descriptionNumber
      description1
      description2
      description3
      openBuyPrice
      openBuyCostAmount
      openLotID
      closedLotID
      washSalesIndicator
      buyBackIndicator
      openTransactionID
      closedTransactionID
      giftIndicator
      inheritanceIndicator
      washSaleAdjustmentDate
      coveredIndicator
      washSalesDisAllowed
      costMethod
      washSaleAdjustmentAmount
      costPerShare
      unadjustedAmount
      principleAmount
      principleCommissionFee
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updatePositionHistory = /* GraphQL */ `
  mutation UpdatePositionHistory(
    $input: UpdatePositionHistoryInput!
    $condition: ModelPositionHistoryConditionInput
  ) {
    updatePositionHistory(input: $input, condition: $condition) {
      id
      recordNumber
      clientNumber
      correspondentCode
      accountNumber
      currency
      trid
      sequenceNumber
      cusip
      securityType
      symbolMsd
      numberMsd
      taxLotOpenBuyDate
      taxLotCloseSellDate
      settlementDate
      quantity
      cost
      netProceed
      realizedGainLoss
      longTermShortTermIndicator
      realizedIndicator
      zeroIndicator
      lmBuyDateIndicator
      lmCostDateIndicator
      lmMarketValueIndicator
      lmGainLossIndicator
      securityNumberMsd
      descriptionNumber
      description1
      description2
      description3
      openBuyPrice
      openBuyCostAmount
      openLotID
      closedLotID
      washSalesIndicator
      buyBackIndicator
      openTransactionID
      closedTransactionID
      giftIndicator
      inheritanceIndicator
      washSaleAdjustmentDate
      coveredIndicator
      washSalesDisAllowed
      costMethod
      washSaleAdjustmentAmount
      costPerShare
      unadjustedAmount
      principleAmount
      principleCommissionFee
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deletePositionHistory = /* GraphQL */ `
  mutation DeletePositionHistory(
    $input: DeletePositionHistoryInput!
    $condition: ModelPositionHistoryConditionInput
  ) {
    deletePositionHistory(input: $input, condition: $condition) {
      id
      recordNumber
      clientNumber
      correspondentCode
      accountNumber
      currency
      trid
      sequenceNumber
      cusip
      securityType
      symbolMsd
      numberMsd
      taxLotOpenBuyDate
      taxLotCloseSellDate
      settlementDate
      quantity
      cost
      netProceed
      realizedGainLoss
      longTermShortTermIndicator
      realizedIndicator
      zeroIndicator
      lmBuyDateIndicator
      lmCostDateIndicator
      lmMarketValueIndicator
      lmGainLossIndicator
      securityNumberMsd
      descriptionNumber
      description1
      description2
      description3
      openBuyPrice
      openBuyCostAmount
      openLotID
      closedLotID
      washSalesIndicator
      buyBackIndicator
      openTransactionID
      closedTransactionID
      giftIndicator
      inheritanceIndicator
      washSaleAdjustmentDate
      coveredIndicator
      washSalesDisAllowed
      costMethod
      washSaleAdjustmentAmount
      costPerShare
      unadjustedAmount
      principleAmount
      principleCommissionFee
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createSystemConfig = /* GraphQL */ `
  mutation CreateSystemConfig(
    $input: CreateSystemConfigInput!
    $condition: ModelSystemConfigConditionInput
  ) {
    createSystemConfig(input: $input, condition: $condition) {
      id
      globalTrading
      optionsTrading
      equityTrading
      cryptoTrading
      margin
      lastExecutionProcessed
      lastOrderProcessed
      eventsWatermarks
      symbolTradeRestrictions {
        id
        symbol
        restrictionType
        createdAt
        updatedAt
        __typename
      }
      systemNotification
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSystemConfig = /* GraphQL */ `
  mutation UpdateSystemConfig(
    $input: UpdateSystemConfigInput!
    $condition: ModelSystemConfigConditionInput
  ) {
    updateSystemConfig(input: $input, condition: $condition) {
      id
      globalTrading
      optionsTrading
      equityTrading
      cryptoTrading
      margin
      lastExecutionProcessed
      lastOrderProcessed
      eventsWatermarks
      symbolTradeRestrictions {
        id
        symbol
        restrictionType
        createdAt
        updatedAt
        __typename
      }
      systemNotification
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSystemConfig = /* GraphQL */ `
  mutation DeleteSystemConfig(
    $input: DeleteSystemConfigInput!
    $condition: ModelSystemConfigConditionInput
  ) {
    deleteSystemConfig(input: $input, condition: $condition) {
      id
      globalTrading
      optionsTrading
      equityTrading
      cryptoTrading
      margin
      lastExecutionProcessed
      lastOrderProcessed
      eventsWatermarks
      symbolTradeRestrictions {
        id
        symbol
        restrictionType
        createdAt
        updatedAt
        __typename
      }
      systemNotification
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSymbolTradeRestrictions = /* GraphQL */ `
  mutation CreateSymbolTradeRestrictions(
    $input: CreateSymbolTradeRestrictionsInput!
    $condition: ModelSymbolTradeRestrictionsConditionInput
  ) {
    createSymbolTradeRestrictions(input: $input, condition: $condition) {
      id
      symbol
      restrictionType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSymbolTradeRestrictions = /* GraphQL */ `
  mutation UpdateSymbolTradeRestrictions(
    $input: UpdateSymbolTradeRestrictionsInput!
    $condition: ModelSymbolTradeRestrictionsConditionInput
  ) {
    updateSymbolTradeRestrictions(input: $input, condition: $condition) {
      id
      symbol
      restrictionType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSymbolTradeRestrictions = /* GraphQL */ `
  mutation DeleteSymbolTradeRestrictions(
    $input: DeleteSymbolTradeRestrictionsInput!
    $condition: ModelSymbolTradeRestrictionsConditionInput
  ) {
    deleteSymbolTradeRestrictions(input: $input, condition: $condition) {
      id
      symbol
      restrictionType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCommissionSchedule = /* GraphQL */ `
  mutation CreateCommissionSchedule(
    $input: CreateCommissionScheduleInput!
    $condition: ModelCommissionScheduleConditionInput
  ) {
    createCommissionSchedule(input: $input, condition: $condition) {
      commissionCode
      security
      method
      commissionPerUnit
      minCharge
      ticketCharge
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCommissionSchedule = /* GraphQL */ `
  mutation UpdateCommissionSchedule(
    $input: UpdateCommissionScheduleInput!
    $condition: ModelCommissionScheduleConditionInput
  ) {
    updateCommissionSchedule(input: $input, condition: $condition) {
      commissionCode
      security
      method
      commissionPerUnit
      minCharge
      ticketCharge
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCommissionSchedule = /* GraphQL */ `
  mutation DeleteCommissionSchedule(
    $input: DeleteCommissionScheduleInput!
    $condition: ModelCommissionScheduleConditionInput
  ) {
    deleteCommissionSchedule(input: $input, condition: $condition) {
      commissionCode
      security
      method
      commissionPerUnit
      minCharge
      ticketCharge
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUserProfile = /* GraphQL */ `
  mutation CreateUserProfile(
    $input: CreateUserProfileInput!
    $condition: ModelUserProfileConditionInput
  ) {
    createUserProfile(input: $input, condition: $condition) {
      id
      cognitoId
      owner
      memberStatus
      memberDate
      lastChargeDate
      contactDetails {
        givenName
        familyName
        phone {
          phoneType
          phoneNumber
          __typename
        }
        email
        __typename
      }
      homeAddress {
        streets
        city
        state
        postal
        country
        __typename
      }
      email
      familyName
      phoneNumber
      employment {
        employmentStatus
        employerName
        position
        yearsEmployed
        businessAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        __typename
      }
      mailingAddress {
        streets
        city
        state
        postal
        country
        __typename
      }
      trustedContact {
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
            __typename
          }
          email
          __typename
        }
        address {
          streets
          city
          state
          postal
          country
          __typename
        }
        __typename
      }
      investmentProfile {
        riskStandardOptions
        uncoveredOptionWriters
        investmentExperience
        riskTolerance
        investmentObjective
        minTotalNetWorthUSD
        minAnnualIncomeUSD
        minLiquidNetWorthUSD
        maxTotalNetWorthUSD
        maxAnnualIncomeUSD
        maxLiquidNetWorthUSD
        timeHorizon
        liquidityNeeds
        stockTradesPerYear
        optionsTradesPerYear
        commonditiesTradesPerYear
        corporateBondsTradesPerYear
        municipalBondsTradesPerYear
        governmentBondsTradesPerYear
        fundsTradesPerYear
        marginAccountTradesPerYear
        optionDisclosureDeliveryDate
        priorInvestmentExperiences {
          firmName
          numberOfYears
          stillOpen
          estimatedValueUSD
          __typename
        }
        __typename
      }
      profilePicture {
        id
        owner
        profilePicture
        createdAt
        updatedAt
        __typename
      }
      dateOfBirth
      socialSecurityNumber
      citizenshipCountry
      catAccountholderType
      customerType
      accountType
      politicallyExposed {
        politicalOrganization
        immediateFamily
        __typename
      }
      controlPersonSymbols
      affiliated {
        firmName
        affiliatedApproval
        docS3Key
        __typename
      }
      customerAccountAgreement
      privacyPolicy
      accounts {
        items {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        nextToken
        __typename
      }
      accountNumbers
      status
      visaType
      visaExpirationDate
      permanentResident
      isCorrespondentEmployee
      custodianType
      custodialState
      entityAccountInformation {
        entityName
        entityTaxId
        stateOfOrigin
        mailingPreference
        isPabAccount
        isUSEntity
        issuerDirectCommunicationCode
        isExemptLegalCustomer
        exemption
        legalEntityIdentifier
        entityOfficers {
          familyName
          givenName
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          socialSecurityNumber
          identificationNumber
          citizenshipCountry
          emailAddress
          isUsCitizen
          __typename
        }
        beneficialOwners {
          familyName
          givenName
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          socialSecurityNumber
          identificationNumber
          citizenshipCountry
          emailAddress
          isUsCitizen
          __typename
        }
        accountNature
        __typename
      }
      authorizedSignerTitle
      isUsCitizen
      isForeignBank
      isForeignShellBank
      foreignBankUSAgent
      isMaintainedForForeignFinancialInstitution
      offersServicesToForeignShellBank
      dividendReinvestment
      trusteeTaxId
      trusteeIsUsCitizen
      entityTrust {
        trustName
        isPabAccount
        dateOfTrustCreation
        trustTaxId
        legalAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        __typename
      }
      oatsAccountholderType
      issuerDirectCommunicationCode
      entityCertOfTrust {
        trustTitle
        trustEffectiveDate
        trustSitusState
        trustRevocability
        trustees {
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
              __typename
            }
            email
            __typename
          }
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          socialSecurityNumber
          identificationNumber
          identification {
            number
            documentType
            issuedBy
            issueDate
            snapId
            expirationDate
            s3Uri
            __typename
          }
          __typename
        }
        trustDocumentSnapId
        trustDocumentS3Uri
        trustAgreementAllowsOptions
        trustAgreementAllowsMarginsAndShortPositions
        __typename
      }
      membersAndManagers {
        legalName
        organizationalRole
        isManager
        __typename
      }
      resolutionAdoptionDate
      authorizedSignerName
      secretaryName
      applicants {
        citizenshipCountry
        birthCountry
        dateOfBirth
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
            __typename
          }
          email
          __typename
        }
        homeAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        mailingAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        employment {
          employmentStatus
          employerName
          position
          yearsEmployed
          businessAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        foreignTaxIdCountry
        foreignTaxIdNumber
        socialSecurityNumber
        visaType
        visaExpirationDate
        permanentResident
        identificationType
        identificationNumber
        countryOfIssue
        identificationIssueDate
        identificationExpirationDate
        identificationS3Uri
        identificationSnapId
        __typename
      }
      communityPropertyState
      jointType
      jointTenantsInCommonParticipants {
        name
        estatePercent
        __typename
      }
      birthCountry
      foreignTaxIdCountry
      foreignTaxIdNumber
      identificationType
      identificationNumber
      countryOfIssue
      identificationIssueDate
      identificationExpirationDate
      identificationS3Uri
      identificationSnapId
      typeIra
      brokerageFirmAuthorization
      decedentName
      simpleIraPlanName
      iraBeneficialOwners {
        givenName
        familyName
        beneficiaryType
        sharePercent
        relationship
        socialSecurityNumber
        __typename
      }
      adoptingEmployer {
        name
        businessAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        phoneNumber
        taxId
        __typename
      }
      planInfo {
        name
        date
        administrator
        __typename
      }
      participantType
      articlesOfIncorporationOrOperatingAgreementSnapId
      articlesOfIncorporationSnapId
      articlesOfIncorporationOrOperatingAgreementS3uri
      articlesOfIncorporationS3uri
      updatedBy
      sendToApex
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserProfile = /* GraphQL */ `
  mutation UpdateUserProfile(
    $input: UpdateUserProfileInput!
    $condition: ModelUserProfileConditionInput
  ) {
    updateUserProfile(input: $input, condition: $condition) {
      id
      cognitoId
      owner
      memberStatus
      memberDate
      lastChargeDate
      contactDetails {
        givenName
        familyName
        phone {
          phoneType
          phoneNumber
          __typename
        }
        email
        __typename
      }
      homeAddress {
        streets
        city
        state
        postal
        country
        __typename
      }
      email
      familyName
      phoneNumber
      employment {
        employmentStatus
        employerName
        position
        yearsEmployed
        businessAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        __typename
      }
      mailingAddress {
        streets
        city
        state
        postal
        country
        __typename
      }
      trustedContact {
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
            __typename
          }
          email
          __typename
        }
        address {
          streets
          city
          state
          postal
          country
          __typename
        }
        __typename
      }
      investmentProfile {
        riskStandardOptions
        uncoveredOptionWriters
        investmentExperience
        riskTolerance
        investmentObjective
        minTotalNetWorthUSD
        minAnnualIncomeUSD
        minLiquidNetWorthUSD
        maxTotalNetWorthUSD
        maxAnnualIncomeUSD
        maxLiquidNetWorthUSD
        timeHorizon
        liquidityNeeds
        stockTradesPerYear
        optionsTradesPerYear
        commonditiesTradesPerYear
        corporateBondsTradesPerYear
        municipalBondsTradesPerYear
        governmentBondsTradesPerYear
        fundsTradesPerYear
        marginAccountTradesPerYear
        optionDisclosureDeliveryDate
        priorInvestmentExperiences {
          firmName
          numberOfYears
          stillOpen
          estimatedValueUSD
          __typename
        }
        __typename
      }
      profilePicture {
        id
        owner
        profilePicture
        createdAt
        updatedAt
        __typename
      }
      dateOfBirth
      socialSecurityNumber
      citizenshipCountry
      catAccountholderType
      customerType
      accountType
      politicallyExposed {
        politicalOrganization
        immediateFamily
        __typename
      }
      controlPersonSymbols
      affiliated {
        firmName
        affiliatedApproval
        docS3Key
        __typename
      }
      customerAccountAgreement
      privacyPolicy
      accounts {
        items {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        nextToken
        __typename
      }
      accountNumbers
      status
      visaType
      visaExpirationDate
      permanentResident
      isCorrespondentEmployee
      custodianType
      custodialState
      entityAccountInformation {
        entityName
        entityTaxId
        stateOfOrigin
        mailingPreference
        isPabAccount
        isUSEntity
        issuerDirectCommunicationCode
        isExemptLegalCustomer
        exemption
        legalEntityIdentifier
        entityOfficers {
          familyName
          givenName
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          socialSecurityNumber
          identificationNumber
          citizenshipCountry
          emailAddress
          isUsCitizen
          __typename
        }
        beneficialOwners {
          familyName
          givenName
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          socialSecurityNumber
          identificationNumber
          citizenshipCountry
          emailAddress
          isUsCitizen
          __typename
        }
        accountNature
        __typename
      }
      authorizedSignerTitle
      isUsCitizen
      isForeignBank
      isForeignShellBank
      foreignBankUSAgent
      isMaintainedForForeignFinancialInstitution
      offersServicesToForeignShellBank
      dividendReinvestment
      trusteeTaxId
      trusteeIsUsCitizen
      entityTrust {
        trustName
        isPabAccount
        dateOfTrustCreation
        trustTaxId
        legalAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        __typename
      }
      oatsAccountholderType
      issuerDirectCommunicationCode
      entityCertOfTrust {
        trustTitle
        trustEffectiveDate
        trustSitusState
        trustRevocability
        trustees {
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
              __typename
            }
            email
            __typename
          }
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          socialSecurityNumber
          identificationNumber
          identification {
            number
            documentType
            issuedBy
            issueDate
            snapId
            expirationDate
            s3Uri
            __typename
          }
          __typename
        }
        trustDocumentSnapId
        trustDocumentS3Uri
        trustAgreementAllowsOptions
        trustAgreementAllowsMarginsAndShortPositions
        __typename
      }
      membersAndManagers {
        legalName
        organizationalRole
        isManager
        __typename
      }
      resolutionAdoptionDate
      authorizedSignerName
      secretaryName
      applicants {
        citizenshipCountry
        birthCountry
        dateOfBirth
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
            __typename
          }
          email
          __typename
        }
        homeAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        mailingAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        employment {
          employmentStatus
          employerName
          position
          yearsEmployed
          businessAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        foreignTaxIdCountry
        foreignTaxIdNumber
        socialSecurityNumber
        visaType
        visaExpirationDate
        permanentResident
        identificationType
        identificationNumber
        countryOfIssue
        identificationIssueDate
        identificationExpirationDate
        identificationS3Uri
        identificationSnapId
        __typename
      }
      communityPropertyState
      jointType
      jointTenantsInCommonParticipants {
        name
        estatePercent
        __typename
      }
      birthCountry
      foreignTaxIdCountry
      foreignTaxIdNumber
      identificationType
      identificationNumber
      countryOfIssue
      identificationIssueDate
      identificationExpirationDate
      identificationS3Uri
      identificationSnapId
      typeIra
      brokerageFirmAuthorization
      decedentName
      simpleIraPlanName
      iraBeneficialOwners {
        givenName
        familyName
        beneficiaryType
        sharePercent
        relationship
        socialSecurityNumber
        __typename
      }
      adoptingEmployer {
        name
        businessAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        phoneNumber
        taxId
        __typename
      }
      planInfo {
        name
        date
        administrator
        __typename
      }
      participantType
      articlesOfIncorporationOrOperatingAgreementSnapId
      articlesOfIncorporationSnapId
      articlesOfIncorporationOrOperatingAgreementS3uri
      articlesOfIncorporationS3uri
      updatedBy
      sendToApex
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserProfile = /* GraphQL */ `
  mutation DeleteUserProfile(
    $input: DeleteUserProfileInput!
    $condition: ModelUserProfileConditionInput
  ) {
    deleteUserProfile(input: $input, condition: $condition) {
      id
      cognitoId
      owner
      memberStatus
      memberDate
      lastChargeDate
      contactDetails {
        givenName
        familyName
        phone {
          phoneType
          phoneNumber
          __typename
        }
        email
        __typename
      }
      homeAddress {
        streets
        city
        state
        postal
        country
        __typename
      }
      email
      familyName
      phoneNumber
      employment {
        employmentStatus
        employerName
        position
        yearsEmployed
        businessAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        __typename
      }
      mailingAddress {
        streets
        city
        state
        postal
        country
        __typename
      }
      trustedContact {
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
            __typename
          }
          email
          __typename
        }
        address {
          streets
          city
          state
          postal
          country
          __typename
        }
        __typename
      }
      investmentProfile {
        riskStandardOptions
        uncoveredOptionWriters
        investmentExperience
        riskTolerance
        investmentObjective
        minTotalNetWorthUSD
        minAnnualIncomeUSD
        minLiquidNetWorthUSD
        maxTotalNetWorthUSD
        maxAnnualIncomeUSD
        maxLiquidNetWorthUSD
        timeHorizon
        liquidityNeeds
        stockTradesPerYear
        optionsTradesPerYear
        commonditiesTradesPerYear
        corporateBondsTradesPerYear
        municipalBondsTradesPerYear
        governmentBondsTradesPerYear
        fundsTradesPerYear
        marginAccountTradesPerYear
        optionDisclosureDeliveryDate
        priorInvestmentExperiences {
          firmName
          numberOfYears
          stillOpen
          estimatedValueUSD
          __typename
        }
        __typename
      }
      profilePicture {
        id
        owner
        profilePicture
        createdAt
        updatedAt
        __typename
      }
      dateOfBirth
      socialSecurityNumber
      citizenshipCountry
      catAccountholderType
      customerType
      accountType
      politicallyExposed {
        politicalOrganization
        immediateFamily
        __typename
      }
      controlPersonSymbols
      affiliated {
        firmName
        affiliatedApproval
        docS3Key
        __typename
      }
      customerAccountAgreement
      privacyPolicy
      accounts {
        items {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        nextToken
        __typename
      }
      accountNumbers
      status
      visaType
      visaExpirationDate
      permanentResident
      isCorrespondentEmployee
      custodianType
      custodialState
      entityAccountInformation {
        entityName
        entityTaxId
        stateOfOrigin
        mailingPreference
        isPabAccount
        isUSEntity
        issuerDirectCommunicationCode
        isExemptLegalCustomer
        exemption
        legalEntityIdentifier
        entityOfficers {
          familyName
          givenName
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          socialSecurityNumber
          identificationNumber
          citizenshipCountry
          emailAddress
          isUsCitizen
          __typename
        }
        beneficialOwners {
          familyName
          givenName
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          socialSecurityNumber
          identificationNumber
          citizenshipCountry
          emailAddress
          isUsCitizen
          __typename
        }
        accountNature
        __typename
      }
      authorizedSignerTitle
      isUsCitizen
      isForeignBank
      isForeignShellBank
      foreignBankUSAgent
      isMaintainedForForeignFinancialInstitution
      offersServicesToForeignShellBank
      dividendReinvestment
      trusteeTaxId
      trusteeIsUsCitizen
      entityTrust {
        trustName
        isPabAccount
        dateOfTrustCreation
        trustTaxId
        legalAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        __typename
      }
      oatsAccountholderType
      issuerDirectCommunicationCode
      entityCertOfTrust {
        trustTitle
        trustEffectiveDate
        trustSitusState
        trustRevocability
        trustees {
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
              __typename
            }
            email
            __typename
          }
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          socialSecurityNumber
          identificationNumber
          identification {
            number
            documentType
            issuedBy
            issueDate
            snapId
            expirationDate
            s3Uri
            __typename
          }
          __typename
        }
        trustDocumentSnapId
        trustDocumentS3Uri
        trustAgreementAllowsOptions
        trustAgreementAllowsMarginsAndShortPositions
        __typename
      }
      membersAndManagers {
        legalName
        organizationalRole
        isManager
        __typename
      }
      resolutionAdoptionDate
      authorizedSignerName
      secretaryName
      applicants {
        citizenshipCountry
        birthCountry
        dateOfBirth
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
            __typename
          }
          email
          __typename
        }
        homeAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        mailingAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        employment {
          employmentStatus
          employerName
          position
          yearsEmployed
          businessAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        foreignTaxIdCountry
        foreignTaxIdNumber
        socialSecurityNumber
        visaType
        visaExpirationDate
        permanentResident
        identificationType
        identificationNumber
        countryOfIssue
        identificationIssueDate
        identificationExpirationDate
        identificationS3Uri
        identificationSnapId
        __typename
      }
      communityPropertyState
      jointType
      jointTenantsInCommonParticipants {
        name
        estatePercent
        __typename
      }
      birthCountry
      foreignTaxIdCountry
      foreignTaxIdNumber
      identificationType
      identificationNumber
      countryOfIssue
      identificationIssueDate
      identificationExpirationDate
      identificationS3Uri
      identificationSnapId
      typeIra
      brokerageFirmAuthorization
      decedentName
      simpleIraPlanName
      iraBeneficialOwners {
        givenName
        familyName
        beneficiaryType
        sharePercent
        relationship
        socialSecurityNumber
        __typename
      }
      adoptingEmployer {
        name
        businessAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        phoneNumber
        taxId
        __typename
      }
      planInfo {
        name
        date
        administrator
        __typename
      }
      participantType
      articlesOfIncorporationOrOperatingAgreementSnapId
      articlesOfIncorporationSnapId
      articlesOfIncorporationOrOperatingAgreementS3uri
      articlesOfIncorporationS3uri
      updatedBy
      sendToApex
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createProfilePicture = /* GraphQL */ `
  mutation CreateProfilePicture(
    $input: CreateProfilePictureInput!
    $condition: ModelProfilePictureConditionInput
  ) {
    createProfilePicture(input: $input, condition: $condition) {
      id
      owner
      profilePicture
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateProfilePicture = /* GraphQL */ `
  mutation UpdateProfilePicture(
    $input: UpdateProfilePictureInput!
    $condition: ModelProfilePictureConditionInput
  ) {
    updateProfilePicture(input: $input, condition: $condition) {
      id
      owner
      profilePicture
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteProfilePicture = /* GraphQL */ `
  mutation DeleteProfilePicture(
    $input: DeleteProfilePictureInput!
    $condition: ModelProfilePictureConditionInput
  ) {
    deleteProfilePicture(input: $input, condition: $condition) {
      id
      owner
      profilePicture
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDraftUserProfile = /* GraphQL */ `
  mutation CreateDraftUserProfile(
    $input: CreateDraftUserProfileInput!
    $condition: ModelDraftUserProfileConditionInput
  ) {
    createDraftUserProfile(input: $input, condition: $condition) {
      id
      cognitoId
      owner
      userAccountType
      memberStatus
      memberDate
      lastChargeDate
      contactDetails {
        givenName
        familyName
        phone {
          phoneType
          phoneNumber
          __typename
        }
        email
        __typename
      }
      homeAddress {
        streets
        city
        state
        postal
        country
        __typename
      }
      email
      familyName
      phoneNumber
      employment {
        employmentStatus
        employerName
        position
        yearsEmployed
        businessAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        __typename
      }
      mailingAddress {
        streets
        city
        state
        postal
        country
        __typename
      }
      trustedContact {
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
            __typename
          }
          email
          __typename
        }
        address {
          streets
          city
          state
          postal
          country
          __typename
        }
        __typename
      }
      investmentProfile {
        riskStandardOptions
        uncoveredOptionWriters
        investmentExperience
        riskTolerance
        investmentObjective
        minTotalNetWorthUSD
        minAnnualIncomeUSD
        minLiquidNetWorthUSD
        maxTotalNetWorthUSD
        maxAnnualIncomeUSD
        maxLiquidNetWorthUSD
        timeHorizon
        liquidityNeeds
        stockTradesPerYear
        optionsTradesPerYear
        commonditiesTradesPerYear
        corporateBondsTradesPerYear
        municipalBondsTradesPerYear
        governmentBondsTradesPerYear
        fundsTradesPerYear
        marginAccountTradesPerYear
        optionDisclosureDeliveryDate
        priorInvestmentExperiences {
          firmName
          numberOfYears
          stillOpen
          estimatedValueUSD
          __typename
        }
        __typename
      }
      profilePicture {
        id
        owner
        profilePicture
        createdAt
        updatedAt
        __typename
      }
      dateOfBirth
      socialSecurityNumber
      citizenshipCountry
      catAccountholderType
      customerType
      accountType
      politicallyExposed {
        politicalOrganization
        immediateFamily
        __typename
      }
      controlPersonSymbols
      affiliated {
        firmName
        affiliatedApproval
        docS3Key
        __typename
      }
      customerAccountAgreement
      privacyPolicy
      accounts {
        items {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        nextToken
        __typename
      }
      accountNumbers
      status
      visaType
      visaExpirationDate
      permanentResident
      isCorrespondentEmployee
      custodianType
      custodialState
      entityAccountInformation {
        entityName
        entityTaxId
        stateOfOrigin
        mailingPreference
        isPabAccount
        isUSEntity
        issuerDirectCommunicationCode
        isExemptLegalCustomer
        exemption
        legalEntityIdentifier
        entityOfficers {
          familyName
          givenName
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          socialSecurityNumber
          identificationNumber
          citizenshipCountry
          emailAddress
          isUsCitizen
          __typename
        }
        beneficialOwners {
          familyName
          givenName
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          socialSecurityNumber
          identificationNumber
          citizenshipCountry
          emailAddress
          isUsCitizen
          __typename
        }
        accountNature
        __typename
      }
      authorizedSignerTitle
      isUsCitizen
      isForeignBank
      isForeignShellBank
      foreignBankUSAgent
      isMaintainedForForeignFinancialInstitution
      offersServicesToForeignShellBank
      dividendReinvestment
      trusteeTaxId
      trusteeIsUsCitizen
      entityTrust {
        trustName
        isPabAccount
        dateOfTrustCreation
        trustTaxId
        legalAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        __typename
      }
      oatsAccountholderType
      issuerDirectCommunicationCode
      entityCertOfTrust {
        trustTitle
        trustEffectiveDate
        trustSitusState
        trustRevocability
        trustees {
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
              __typename
            }
            email
            __typename
          }
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          socialSecurityNumber
          identificationNumber
          identification {
            number
            documentType
            issuedBy
            issueDate
            snapId
            expirationDate
            s3Uri
            __typename
          }
          __typename
        }
        trustDocumentSnapId
        trustDocumentS3Uri
        trustAgreementAllowsOptions
        trustAgreementAllowsMarginsAndShortPositions
        __typename
      }
      membersAndManagers {
        legalName
        organizationalRole
        isManager
        __typename
      }
      resolutionAdoptionDate
      authorizedSignerName
      secretaryName
      applicants {
        citizenshipCountry
        birthCountry
        dateOfBirth
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
            __typename
          }
          email
          __typename
        }
        homeAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        mailingAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        employment {
          employmentStatus
          employerName
          position
          yearsEmployed
          businessAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        foreignTaxIdCountry
        foreignTaxIdNumber
        socialSecurityNumber
        visaType
        visaExpirationDate
        permanentResident
        identificationType
        identificationNumber
        countryOfIssue
        identificationIssueDate
        identificationExpirationDate
        identificationS3Uri
        identificationSnapId
        __typename
      }
      communityPropertyState
      jointType
      jointTenantsInCommonParticipants {
        name
        estatePercent
        __typename
      }
      birthCountry
      foreignTaxIdCountry
      foreignTaxIdNumber
      identificationType
      identificationNumber
      countryOfIssue
      identificationIssueDate
      identificationExpirationDate
      identificationS3Uri
      identificationSnapId
      typeIra
      brokerageFirmAuthorization
      decedentName
      simpleIraPlanName
      iraBeneficialOwners {
        givenName
        familyName
        beneficiaryType
        sharePercent
        relationship
        socialSecurityNumber
        __typename
      }
      adoptingEmployer {
        name
        businessAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        phoneNumber
        taxId
        __typename
      }
      planInfo {
        name
        date
        administrator
        __typename
      }
      participantType
      articlesOfIncorporationOrOperatingAgreementSnapId
      articlesOfIncorporationSnapId
      articlesOfIncorporationOrOperatingAgreementS3uri
      articlesOfIncorporationS3uri
      isFinishedOnboarding
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDraftUserProfile = /* GraphQL */ `
  mutation UpdateDraftUserProfile(
    $input: UpdateDraftUserProfileInput!
    $condition: ModelDraftUserProfileConditionInput
  ) {
    updateDraftUserProfile(input: $input, condition: $condition) {
      id
      cognitoId
      owner
      userAccountType
      memberStatus
      memberDate
      lastChargeDate
      contactDetails {
        givenName
        familyName
        phone {
          phoneType
          phoneNumber
          __typename
        }
        email
        __typename
      }
      homeAddress {
        streets
        city
        state
        postal
        country
        __typename
      }
      email
      familyName
      phoneNumber
      employment {
        employmentStatus
        employerName
        position
        yearsEmployed
        businessAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        __typename
      }
      mailingAddress {
        streets
        city
        state
        postal
        country
        __typename
      }
      trustedContact {
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
            __typename
          }
          email
          __typename
        }
        address {
          streets
          city
          state
          postal
          country
          __typename
        }
        __typename
      }
      investmentProfile {
        riskStandardOptions
        uncoveredOptionWriters
        investmentExperience
        riskTolerance
        investmentObjective
        minTotalNetWorthUSD
        minAnnualIncomeUSD
        minLiquidNetWorthUSD
        maxTotalNetWorthUSD
        maxAnnualIncomeUSD
        maxLiquidNetWorthUSD
        timeHorizon
        liquidityNeeds
        stockTradesPerYear
        optionsTradesPerYear
        commonditiesTradesPerYear
        corporateBondsTradesPerYear
        municipalBondsTradesPerYear
        governmentBondsTradesPerYear
        fundsTradesPerYear
        marginAccountTradesPerYear
        optionDisclosureDeliveryDate
        priorInvestmentExperiences {
          firmName
          numberOfYears
          stillOpen
          estimatedValueUSD
          __typename
        }
        __typename
      }
      profilePicture {
        id
        owner
        profilePicture
        createdAt
        updatedAt
        __typename
      }
      dateOfBirth
      socialSecurityNumber
      citizenshipCountry
      catAccountholderType
      customerType
      accountType
      politicallyExposed {
        politicalOrganization
        immediateFamily
        __typename
      }
      controlPersonSymbols
      affiliated {
        firmName
        affiliatedApproval
        docS3Key
        __typename
      }
      customerAccountAgreement
      privacyPolicy
      accounts {
        items {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        nextToken
        __typename
      }
      accountNumbers
      status
      visaType
      visaExpirationDate
      permanentResident
      isCorrespondentEmployee
      custodianType
      custodialState
      entityAccountInformation {
        entityName
        entityTaxId
        stateOfOrigin
        mailingPreference
        isPabAccount
        isUSEntity
        issuerDirectCommunicationCode
        isExemptLegalCustomer
        exemption
        legalEntityIdentifier
        entityOfficers {
          familyName
          givenName
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          socialSecurityNumber
          identificationNumber
          citizenshipCountry
          emailAddress
          isUsCitizen
          __typename
        }
        beneficialOwners {
          familyName
          givenName
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          socialSecurityNumber
          identificationNumber
          citizenshipCountry
          emailAddress
          isUsCitizen
          __typename
        }
        accountNature
        __typename
      }
      authorizedSignerTitle
      isUsCitizen
      isForeignBank
      isForeignShellBank
      foreignBankUSAgent
      isMaintainedForForeignFinancialInstitution
      offersServicesToForeignShellBank
      dividendReinvestment
      trusteeTaxId
      trusteeIsUsCitizen
      entityTrust {
        trustName
        isPabAccount
        dateOfTrustCreation
        trustTaxId
        legalAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        __typename
      }
      oatsAccountholderType
      issuerDirectCommunicationCode
      entityCertOfTrust {
        trustTitle
        trustEffectiveDate
        trustSitusState
        trustRevocability
        trustees {
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
              __typename
            }
            email
            __typename
          }
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          socialSecurityNumber
          identificationNumber
          identification {
            number
            documentType
            issuedBy
            issueDate
            snapId
            expirationDate
            s3Uri
            __typename
          }
          __typename
        }
        trustDocumentSnapId
        trustDocumentS3Uri
        trustAgreementAllowsOptions
        trustAgreementAllowsMarginsAndShortPositions
        __typename
      }
      membersAndManagers {
        legalName
        organizationalRole
        isManager
        __typename
      }
      resolutionAdoptionDate
      authorizedSignerName
      secretaryName
      applicants {
        citizenshipCountry
        birthCountry
        dateOfBirth
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
            __typename
          }
          email
          __typename
        }
        homeAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        mailingAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        employment {
          employmentStatus
          employerName
          position
          yearsEmployed
          businessAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        foreignTaxIdCountry
        foreignTaxIdNumber
        socialSecurityNumber
        visaType
        visaExpirationDate
        permanentResident
        identificationType
        identificationNumber
        countryOfIssue
        identificationIssueDate
        identificationExpirationDate
        identificationS3Uri
        identificationSnapId
        __typename
      }
      communityPropertyState
      jointType
      jointTenantsInCommonParticipants {
        name
        estatePercent
        __typename
      }
      birthCountry
      foreignTaxIdCountry
      foreignTaxIdNumber
      identificationType
      identificationNumber
      countryOfIssue
      identificationIssueDate
      identificationExpirationDate
      identificationS3Uri
      identificationSnapId
      typeIra
      brokerageFirmAuthorization
      decedentName
      simpleIraPlanName
      iraBeneficialOwners {
        givenName
        familyName
        beneficiaryType
        sharePercent
        relationship
        socialSecurityNumber
        __typename
      }
      adoptingEmployer {
        name
        businessAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        phoneNumber
        taxId
        __typename
      }
      planInfo {
        name
        date
        administrator
        __typename
      }
      participantType
      articlesOfIncorporationOrOperatingAgreementSnapId
      articlesOfIncorporationSnapId
      articlesOfIncorporationOrOperatingAgreementS3uri
      articlesOfIncorporationS3uri
      isFinishedOnboarding
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDraftUserProfile = /* GraphQL */ `
  mutation DeleteDraftUserProfile(
    $input: DeleteDraftUserProfileInput!
    $condition: ModelDraftUserProfileConditionInput
  ) {
    deleteDraftUserProfile(input: $input, condition: $condition) {
      id
      cognitoId
      owner
      userAccountType
      memberStatus
      memberDate
      lastChargeDate
      contactDetails {
        givenName
        familyName
        phone {
          phoneType
          phoneNumber
          __typename
        }
        email
        __typename
      }
      homeAddress {
        streets
        city
        state
        postal
        country
        __typename
      }
      email
      familyName
      phoneNumber
      employment {
        employmentStatus
        employerName
        position
        yearsEmployed
        businessAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        __typename
      }
      mailingAddress {
        streets
        city
        state
        postal
        country
        __typename
      }
      trustedContact {
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
            __typename
          }
          email
          __typename
        }
        address {
          streets
          city
          state
          postal
          country
          __typename
        }
        __typename
      }
      investmentProfile {
        riskStandardOptions
        uncoveredOptionWriters
        investmentExperience
        riskTolerance
        investmentObjective
        minTotalNetWorthUSD
        minAnnualIncomeUSD
        minLiquidNetWorthUSD
        maxTotalNetWorthUSD
        maxAnnualIncomeUSD
        maxLiquidNetWorthUSD
        timeHorizon
        liquidityNeeds
        stockTradesPerYear
        optionsTradesPerYear
        commonditiesTradesPerYear
        corporateBondsTradesPerYear
        municipalBondsTradesPerYear
        governmentBondsTradesPerYear
        fundsTradesPerYear
        marginAccountTradesPerYear
        optionDisclosureDeliveryDate
        priorInvestmentExperiences {
          firmName
          numberOfYears
          stillOpen
          estimatedValueUSD
          __typename
        }
        __typename
      }
      profilePicture {
        id
        owner
        profilePicture
        createdAt
        updatedAt
        __typename
      }
      dateOfBirth
      socialSecurityNumber
      citizenshipCountry
      catAccountholderType
      customerType
      accountType
      politicallyExposed {
        politicalOrganization
        immediateFamily
        __typename
      }
      controlPersonSymbols
      affiliated {
        firmName
        affiliatedApproval
        docS3Key
        __typename
      }
      customerAccountAgreement
      privacyPolicy
      accounts {
        items {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        nextToken
        __typename
      }
      accountNumbers
      status
      visaType
      visaExpirationDate
      permanentResident
      isCorrespondentEmployee
      custodianType
      custodialState
      entityAccountInformation {
        entityName
        entityTaxId
        stateOfOrigin
        mailingPreference
        isPabAccount
        isUSEntity
        issuerDirectCommunicationCode
        isExemptLegalCustomer
        exemption
        legalEntityIdentifier
        entityOfficers {
          familyName
          givenName
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          socialSecurityNumber
          identificationNumber
          citizenshipCountry
          emailAddress
          isUsCitizen
          __typename
        }
        beneficialOwners {
          familyName
          givenName
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          socialSecurityNumber
          identificationNumber
          citizenshipCountry
          emailAddress
          isUsCitizen
          __typename
        }
        accountNature
        __typename
      }
      authorizedSignerTitle
      isUsCitizen
      isForeignBank
      isForeignShellBank
      foreignBankUSAgent
      isMaintainedForForeignFinancialInstitution
      offersServicesToForeignShellBank
      dividendReinvestment
      trusteeTaxId
      trusteeIsUsCitizen
      entityTrust {
        trustName
        isPabAccount
        dateOfTrustCreation
        trustTaxId
        legalAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        __typename
      }
      oatsAccountholderType
      issuerDirectCommunicationCode
      entityCertOfTrust {
        trustTitle
        trustEffectiveDate
        trustSitusState
        trustRevocability
        trustees {
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
              __typename
            }
            email
            __typename
          }
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          socialSecurityNumber
          identificationNumber
          identification {
            number
            documentType
            issuedBy
            issueDate
            snapId
            expirationDate
            s3Uri
            __typename
          }
          __typename
        }
        trustDocumentSnapId
        trustDocumentS3Uri
        trustAgreementAllowsOptions
        trustAgreementAllowsMarginsAndShortPositions
        __typename
      }
      membersAndManagers {
        legalName
        organizationalRole
        isManager
        __typename
      }
      resolutionAdoptionDate
      authorizedSignerName
      secretaryName
      applicants {
        citizenshipCountry
        birthCountry
        dateOfBirth
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
            __typename
          }
          email
          __typename
        }
        homeAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        mailingAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        employment {
          employmentStatus
          employerName
          position
          yearsEmployed
          businessAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        foreignTaxIdCountry
        foreignTaxIdNumber
        socialSecurityNumber
        visaType
        visaExpirationDate
        permanentResident
        identificationType
        identificationNumber
        countryOfIssue
        identificationIssueDate
        identificationExpirationDate
        identificationS3Uri
        identificationSnapId
        __typename
      }
      communityPropertyState
      jointType
      jointTenantsInCommonParticipants {
        name
        estatePercent
        __typename
      }
      birthCountry
      foreignTaxIdCountry
      foreignTaxIdNumber
      identificationType
      identificationNumber
      countryOfIssue
      identificationIssueDate
      identificationExpirationDate
      identificationS3Uri
      identificationSnapId
      typeIra
      brokerageFirmAuthorization
      decedentName
      simpleIraPlanName
      iraBeneficialOwners {
        givenName
        familyName
        beneficiaryType
        sharePercent
        relationship
        socialSecurityNumber
        __typename
      }
      adoptingEmployer {
        name
        businessAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        phoneNumber
        taxId
        __typename
      }
      planInfo {
        name
        date
        administrator
        __typename
      }
      participantType
      articlesOfIncorporationOrOperatingAgreementSnapId
      articlesOfIncorporationSnapId
      articlesOfIncorporationOrOperatingAgreementS3uri
      articlesOfIncorporationS3uri
      isFinishedOnboarding
      createdAt
      updatedAt
      __typename
    }
  }
`;
